
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// packages/alpinejs/src/scheduler.js
var $ceb1972acc1ecda9$var$flushPending = false;
var $ceb1972acc1ecda9$var$flushing = false;
var $ceb1972acc1ecda9$var$queue = [];
var $ceb1972acc1ecda9$var$lastFlushedIndex = -1;
function $ceb1972acc1ecda9$var$scheduler(callback) {
    $ceb1972acc1ecda9$var$queueJob(callback);
}
function $ceb1972acc1ecda9$var$queueJob(job) {
    if (!$ceb1972acc1ecda9$var$queue.includes(job)) $ceb1972acc1ecda9$var$queue.push(job);
    $ceb1972acc1ecda9$var$queueFlush();
}
function $ceb1972acc1ecda9$var$dequeueJob(job) {
    let index = $ceb1972acc1ecda9$var$queue.indexOf(job);
    if (index !== -1 && index > $ceb1972acc1ecda9$var$lastFlushedIndex) $ceb1972acc1ecda9$var$queue.splice(index, 1);
}
function $ceb1972acc1ecda9$var$queueFlush() {
    if (!$ceb1972acc1ecda9$var$flushing && !$ceb1972acc1ecda9$var$flushPending) {
        $ceb1972acc1ecda9$var$flushPending = true;
        queueMicrotask($ceb1972acc1ecda9$var$flushJobs);
    }
}
function $ceb1972acc1ecda9$var$flushJobs() {
    $ceb1972acc1ecda9$var$flushPending = false;
    $ceb1972acc1ecda9$var$flushing = true;
    for(let i = 0; i < $ceb1972acc1ecda9$var$queue.length; i++){
        $ceb1972acc1ecda9$var$queue[i]();
        $ceb1972acc1ecda9$var$lastFlushedIndex = i;
    }
    $ceb1972acc1ecda9$var$queue.length = 0;
    $ceb1972acc1ecda9$var$lastFlushedIndex = -1;
    $ceb1972acc1ecda9$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $ceb1972acc1ecda9$var$reactive;
var $ceb1972acc1ecda9$var$effect;
var $ceb1972acc1ecda9$var$release;
var $ceb1972acc1ecda9$var$raw;
var $ceb1972acc1ecda9$var$shouldSchedule = true;
function $ceb1972acc1ecda9$var$disableEffectScheduling(callback) {
    $ceb1972acc1ecda9$var$shouldSchedule = false;
    callback();
    $ceb1972acc1ecda9$var$shouldSchedule = true;
}
function $ceb1972acc1ecda9$var$setReactivityEngine(engine) {
    $ceb1972acc1ecda9$var$reactive = engine.reactive;
    $ceb1972acc1ecda9$var$release = engine.release;
    $ceb1972acc1ecda9$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($ceb1972acc1ecda9$var$shouldSchedule) $ceb1972acc1ecda9$var$scheduler(task);
                else task();
            }
        });
    $ceb1972acc1ecda9$var$raw = engine.raw;
}
function $ceb1972acc1ecda9$var$overrideEffect(override) {
    $ceb1972acc1ecda9$var$effect = override;
}
function $ceb1972acc1ecda9$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $ceb1972acc1ecda9$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $ceb1972acc1ecda9$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/utils/dispatch.js
function $ceb1972acc1ecda9$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $ceb1972acc1ecda9$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$ceb1972acc1ecda9$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $ceb1972acc1ecda9$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $ceb1972acc1ecda9$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $ceb1972acc1ecda9$var$started = false;
function $ceb1972acc1ecda9$var$start() {
    if ($ceb1972acc1ecda9$var$started) $ceb1972acc1ecda9$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $ceb1972acc1ecda9$var$started = true;
    if (!document.body) $ceb1972acc1ecda9$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:init");
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:initializing");
    $ceb1972acc1ecda9$var$startObservingMutations();
    $ceb1972acc1ecda9$var$onElAdded((el)=>$ceb1972acc1ecda9$var$initTree(el, $ceb1972acc1ecda9$var$walk));
    $ceb1972acc1ecda9$var$onElRemoved((el)=>$ceb1972acc1ecda9$var$destroyTree(el));
    $ceb1972acc1ecda9$var$onAttributesAdded((el, attrs)=>{
        $ceb1972acc1ecda9$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$ceb1972acc1ecda9$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($ceb1972acc1ecda9$var$allSelectors())).filter(outNestedComponents).forEach((el)=>{
        $ceb1972acc1ecda9$var$initTree(el);
    });
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:initialized");
}
var $ceb1972acc1ecda9$var$rootSelectorCallbacks = [];
var $ceb1972acc1ecda9$var$initSelectorCallbacks = [];
function $ceb1972acc1ecda9$var$rootSelectors() {
    return $ceb1972acc1ecda9$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $ceb1972acc1ecda9$var$allSelectors() {
    return $ceb1972acc1ecda9$var$rootSelectorCallbacks.concat($ceb1972acc1ecda9$var$initSelectorCallbacks).map((fn)=>fn());
}
function $ceb1972acc1ecda9$var$addRootSelector(selectorCallback) {
    $ceb1972acc1ecda9$var$rootSelectorCallbacks.push(selectorCallback);
}
function $ceb1972acc1ecda9$var$addInitSelector(selectorCallback) {
    $ceb1972acc1ecda9$var$initSelectorCallbacks.push(selectorCallback);
}
function $ceb1972acc1ecda9$var$closestRoot(el, includeInitSelectors = false) {
    return $ceb1972acc1ecda9$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $ceb1972acc1ecda9$var$allSelectors() : $ceb1972acc1ecda9$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $ceb1972acc1ecda9$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $ceb1972acc1ecda9$var$findClosest(el.parentElement, callback);
}
function $ceb1972acc1ecda9$var$isRoot(el) {
    return $ceb1972acc1ecda9$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $ceb1972acc1ecda9$var$initInterceptors = [];
function $ceb1972acc1ecda9$var$interceptInit(callback) {
    $ceb1972acc1ecda9$var$initInterceptors.push(callback);
}
function $ceb1972acc1ecda9$var$initTree(el, walker = $ceb1972acc1ecda9$var$walk, intercept = ()=>{}) {
    $ceb1972acc1ecda9$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $ceb1972acc1ecda9$var$initInterceptors.forEach((i)=>i(el2, skip));
            $ceb1972acc1ecda9$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $ceb1972acc1ecda9$var$destroyTree(root) {
    $ceb1972acc1ecda9$var$walk(root, (el)=>{
        $ceb1972acc1ecda9$var$cleanupAttributes(el);
        $ceb1972acc1ecda9$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $ceb1972acc1ecda9$var$onAttributeAddeds = [];
var $ceb1972acc1ecda9$var$onElRemoveds = [];
var $ceb1972acc1ecda9$var$onElAddeds = [];
function $ceb1972acc1ecda9$var$onElAdded(callback) {
    $ceb1972acc1ecda9$var$onElAddeds.push(callback);
}
function $ceb1972acc1ecda9$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $ceb1972acc1ecda9$var$onElRemoveds.push(callback);
    }
}
function $ceb1972acc1ecda9$var$onAttributesAdded(callback) {
    $ceb1972acc1ecda9$var$onAttributeAddeds.push(callback);
}
function $ceb1972acc1ecda9$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $ceb1972acc1ecda9$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $ceb1972acc1ecda9$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $ceb1972acc1ecda9$var$observer = new MutationObserver($ceb1972acc1ecda9$var$onMutate);
var $ceb1972acc1ecda9$var$currentlyObserving = false;
function $ceb1972acc1ecda9$var$startObservingMutations() {
    $ceb1972acc1ecda9$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $ceb1972acc1ecda9$var$currentlyObserving = true;
}
function $ceb1972acc1ecda9$var$stopObservingMutations() {
    $ceb1972acc1ecda9$var$flushObserver();
    $ceb1972acc1ecda9$var$observer.disconnect();
    $ceb1972acc1ecda9$var$currentlyObserving = false;
}
var $ceb1972acc1ecda9$var$recordQueue = [];
var $ceb1972acc1ecda9$var$willProcessRecordQueue = false;
function $ceb1972acc1ecda9$var$flushObserver() {
    $ceb1972acc1ecda9$var$recordQueue = $ceb1972acc1ecda9$var$recordQueue.concat($ceb1972acc1ecda9$var$observer.takeRecords());
    if ($ceb1972acc1ecda9$var$recordQueue.length && !$ceb1972acc1ecda9$var$willProcessRecordQueue) {
        $ceb1972acc1ecda9$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $ceb1972acc1ecda9$var$processRecordQueue();
            $ceb1972acc1ecda9$var$willProcessRecordQueue = false;
        });
    }
}
function $ceb1972acc1ecda9$var$processRecordQueue() {
    $ceb1972acc1ecda9$var$onMutate($ceb1972acc1ecda9$var$recordQueue);
    $ceb1972acc1ecda9$var$recordQueue.length = 0;
}
function $ceb1972acc1ecda9$var$mutateDom(callback) {
    if (!$ceb1972acc1ecda9$var$currentlyObserving) return callback();
    $ceb1972acc1ecda9$var$stopObservingMutations();
    let result = callback();
    $ceb1972acc1ecda9$var$startObservingMutations();
    return result;
}
var $ceb1972acc1ecda9$var$isCollecting = false;
var $ceb1972acc1ecda9$var$deferredMutations = [];
function $ceb1972acc1ecda9$var$deferMutations() {
    $ceb1972acc1ecda9$var$isCollecting = true;
}
function $ceb1972acc1ecda9$var$flushAndStopDeferringMutations() {
    $ceb1972acc1ecda9$var$isCollecting = false;
    $ceb1972acc1ecda9$var$onMutate($ceb1972acc1ecda9$var$deferredMutations);
    $ceb1972acc1ecda9$var$deferredMutations = [];
}
function $ceb1972acc1ecda9$var$onMutate(mutations) {
    if ($ceb1972acc1ecda9$var$isCollecting) {
        $ceb1972acc1ecda9$var$deferredMutations = $ceb1972acc1ecda9$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $ceb1972acc1ecda9$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $ceb1972acc1ecda9$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $ceb1972acc1ecda9$var$onElRemoveds.forEach((i)=>i(node));
        $ceb1972acc1ecda9$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $ceb1972acc1ecda9$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $ceb1972acc1ecda9$var$scope(node) {
    return $ceb1972acc1ecda9$var$mergeProxies($ceb1972acc1ecda9$var$closestDataStack(node));
}
function $ceb1972acc1ecda9$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$ceb1972acc1ecda9$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $ceb1972acc1ecda9$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $ceb1972acc1ecda9$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $ceb1972acc1ecda9$var$closestDataStack(node.parentNode);
}
function $ceb1972acc1ecda9$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $ceb1972acc1ecda9$var$mergeProxyTrap);
}
var $ceb1972acc1ecda9$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $ceb1972acc1ecda9$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $ceb1972acc1ecda9$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $ceb1972acc1ecda9$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $ceb1972acc1ecda9$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$ceb1972acc1ecda9$var$get(data2, path), (value)=>$ceb1972acc1ecda9$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $ceb1972acc1ecda9$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $ceb1972acc1ecda9$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $ceb1972acc1ecda9$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $ceb1972acc1ecda9$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $ceb1972acc1ecda9$var$magics = {};
function $ceb1972acc1ecda9$var$magic(name, callback) {
    $ceb1972acc1ecda9$var$magics[name] = callback;
}
function $ceb1972acc1ecda9$var$injectMagics(obj, el) {
    Object.entries($ceb1972acc1ecda9$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $ceb1972acc1ecda9$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $ceb1972acc1ecda9$var$interceptor,
                    ...utilities
                };
                $ceb1972acc1ecda9$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $ceb1972acc1ecda9$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $ceb1972acc1ecda9$var$handleError(e, el, expression);
    }
}
function $ceb1972acc1ecda9$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = true;
function $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions(callback) {
    let cache = $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions;
    $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $ceb1972acc1ecda9$var$evaluate(el, expression, extras = {}) {
    let result;
    $ceb1972acc1ecda9$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $ceb1972acc1ecda9$var$evaluateLater(...args) {
    return $ceb1972acc1ecda9$var$theEvaluatorFunction(...args);
}
var $ceb1972acc1ecda9$var$theEvaluatorFunction = $ceb1972acc1ecda9$var$normalEvaluator;
function $ceb1972acc1ecda9$var$setEvaluator(newEvaluator) {
    $ceb1972acc1ecda9$var$theEvaluatorFunction = newEvaluator;
}
function $ceb1972acc1ecda9$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $ceb1972acc1ecda9$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$ceb1972acc1ecda9$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $ceb1972acc1ecda9$var$generateEvaluatorFromFunction(dataStack, expression) : $ceb1972acc1ecda9$var$generateEvaluatorFromString(dataStack, expression, el);
    return $ceb1972acc1ecda9$var$tryCatch.bind(null, el, expression, evaluator);
}
function $ceb1972acc1ecda9$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($ceb1972acc1ecda9$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, result);
    };
}
var $ceb1972acc1ecda9$var$evaluatorMemo = {};
function $ceb1972acc1ecda9$var$generateFunctionFromString(expression, el) {
    if ($ceb1972acc1ecda9$var$evaluatorMemo[expression]) return $ceb1972acc1ecda9$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $ceb1972acc1ecda9$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $ceb1972acc1ecda9$var$evaluatorMemo[expression] = func;
    return func;
}
function $ceb1972acc1ecda9$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $ceb1972acc1ecda9$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $ceb1972acc1ecda9$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, expression));
            if (func.finished) {
                $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $ceb1972acc1ecda9$var$prefixAsString = "x-";
function $ceb1972acc1ecda9$var$prefix(subject = "") {
    return $ceb1972acc1ecda9$var$prefixAsString + subject;
}
function $ceb1972acc1ecda9$var$setPrefix(newPrefix) {
    $ceb1972acc1ecda9$var$prefixAsString = newPrefix;
}
var $ceb1972acc1ecda9$var$directiveHandlers = {};
function $ceb1972acc1ecda9$var$directive(name, callback) {
    $ceb1972acc1ecda9$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$ceb1972acc1ecda9$var$directiveHandlers[directive2]) {
                console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                return;
            }
            const pos = $ceb1972acc1ecda9$var$directiveOrder.indexOf(directive2);
            $ceb1972acc1ecda9$var$directiveOrder.splice(pos >= 0 ? pos : $ceb1972acc1ecda9$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $ceb1972acc1ecda9$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $ceb1972acc1ecda9$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($ceb1972acc1ecda9$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($ceb1972acc1ecda9$var$outNonAlpineAttributes).map($ceb1972acc1ecda9$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($ceb1972acc1ecda9$var$byPriority);
    return directives2.map((directive2)=>{
        return $ceb1972acc1ecda9$var$getDirectiveHandler(el, directive2);
    });
}
function $ceb1972acc1ecda9$var$attributesOnly(attributes) {
    return Array.from(attributes).map($ceb1972acc1ecda9$var$toTransformedAttributes()).filter((attr)=>!$ceb1972acc1ecda9$var$outNonAlpineAttributes(attr));
}
var $ceb1972acc1ecda9$var$isDeferringHandlers = false;
var $ceb1972acc1ecda9$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $ceb1972acc1ecda9$var$currentHandlerStackKey = Symbol();
function $ceb1972acc1ecda9$var$deferHandlingDirectives(callback) {
    $ceb1972acc1ecda9$var$isDeferringHandlers = true;
    let key = Symbol();
    $ceb1972acc1ecda9$var$currentHandlerStackKey = key;
    $ceb1972acc1ecda9$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($ceb1972acc1ecda9$var$directiveHandlerStacks.get(key).length)$ceb1972acc1ecda9$var$directiveHandlerStacks.get(key).shift()();
        $ceb1972acc1ecda9$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $ceb1972acc1ecda9$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $ceb1972acc1ecda9$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $ceb1972acc1ecda9$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $ceb1972acc1ecda9$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $ceb1972acc1ecda9$var$evaluateLater.bind($ceb1972acc1ecda9$var$evaluateLater, el),
        evaluate: $ceb1972acc1ecda9$var$evaluate.bind($ceb1972acc1ecda9$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $ceb1972acc1ecda9$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $ceb1972acc1ecda9$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $ceb1972acc1ecda9$var$getElementBoundUtilities(el);
    $ceb1972acc1ecda9$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $ceb1972acc1ecda9$var$isDeferringHandlers ? $ceb1972acc1ecda9$var$directiveHandlerStacks.get($ceb1972acc1ecda9$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $ceb1972acc1ecda9$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $ceb1972acc1ecda9$var$into = (i)=>i;
function $ceb1972acc1ecda9$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $ceb1972acc1ecda9$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $ceb1972acc1ecda9$var$attributeTransformers = [];
function $ceb1972acc1ecda9$var$mapAttributes(callback) {
    $ceb1972acc1ecda9$var$attributeTransformers.push(callback);
}
function $ceb1972acc1ecda9$var$outNonAlpineAttributes({ name: name }) {
    return $ceb1972acc1ecda9$var$alpineAttributeRegex().test(name);
}
var $ceb1972acc1ecda9$var$alpineAttributeRegex = ()=>new RegExp(`^${$ceb1972acc1ecda9$var$prefixAsString}([^:^.]+)\\b`);
function $ceb1972acc1ecda9$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($ceb1972acc1ecda9$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $ceb1972acc1ecda9$var$DEFAULT = "DEFAULT";
var $ceb1972acc1ecda9$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $ceb1972acc1ecda9$var$DEFAULT,
    "teleport"
];
function $ceb1972acc1ecda9$var$byPriority(a, b) {
    let typeA = $ceb1972acc1ecda9$var$directiveOrder.indexOf(a.type) === -1 ? $ceb1972acc1ecda9$var$DEFAULT : a.type;
    let typeB = $ceb1972acc1ecda9$var$directiveOrder.indexOf(b.type) === -1 ? $ceb1972acc1ecda9$var$DEFAULT : b.type;
    return $ceb1972acc1ecda9$var$directiveOrder.indexOf(typeA) - $ceb1972acc1ecda9$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $ceb1972acc1ecda9$var$tickStack = [];
var $ceb1972acc1ecda9$var$isHolding = false;
function $ceb1972acc1ecda9$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $ceb1972acc1ecda9$var$isHolding || setTimeout(()=>{
            $ceb1972acc1ecda9$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $ceb1972acc1ecda9$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $ceb1972acc1ecda9$var$releaseNextTicks() {
    $ceb1972acc1ecda9$var$isHolding = false;
    while($ceb1972acc1ecda9$var$tickStack.length)$ceb1972acc1ecda9$var$tickStack.shift()();
}
function $ceb1972acc1ecda9$var$holdNextTicks() {
    $ceb1972acc1ecda9$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $ceb1972acc1ecda9$var$setClasses(el, value) {
    if (Array.isArray(value)) return $ceb1972acc1ecda9$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $ceb1972acc1ecda9$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $ceb1972acc1ecda9$var$setClasses(el, value());
    return $ceb1972acc1ecda9$var$setClassesFromString(el, value);
}
function $ceb1972acc1ecda9$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $ceb1972acc1ecda9$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $ceb1972acc1ecda9$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $ceb1972acc1ecda9$var$setStylesFromObject(el, value);
    return $ceb1972acc1ecda9$var$setStylesFromString(el, value);
}
function $ceb1972acc1ecda9$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $ceb1972acc1ecda9$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $ceb1972acc1ecda9$var$setStyles(el, previousStyles);
    };
}
function $ceb1972acc1ecda9$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $ceb1972acc1ecda9$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $ceb1972acc1ecda9$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$ceb1972acc1ecda9$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $ceb1972acc1ecda9$var$registerTransitionsFromHelper(el, modifiers, value);
    else $ceb1972acc1ecda9$var$registerTransitionsFromClassString(el, expression, value);
});
function $ceb1972acc1ecda9$var$registerTransitionsFromClassString(el, classString, stage) {
    $ceb1972acc1ecda9$var$registerTransitionObject(el, $ceb1972acc1ecda9$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $ceb1972acc1ecda9$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $ceb1972acc1ecda9$var$registerTransitionObject(el, $ceb1972acc1ecda9$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $ceb1972acc1ecda9$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $ceb1972acc1ecda9$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $ceb1972acc1ecda9$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $ceb1972acc1ecda9$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $ceb1972acc1ecda9$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $ceb1972acc1ecda9$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $ceb1972acc1ecda9$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $ceb1972acc1ecda9$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $ceb1972acc1ecda9$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $ceb1972acc1ecda9$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $ceb1972acc1ecda9$var$closestHide(parent);
}
function $ceb1972acc1ecda9$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $ceb1972acc1ecda9$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $ceb1972acc1ecda9$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $ceb1972acc1ecda9$var$once(()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $ceb1972acc1ecda9$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $ceb1972acc1ecda9$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $ceb1972acc1ecda9$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $ceb1972acc1ecda9$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                stages.end();
            });
            $ceb1972acc1ecda9$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $ceb1972acc1ecda9$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $ceb1972acc1ecda9$var$isCloning = false;
function $ceb1972acc1ecda9$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$ceb1972acc1ecda9$var$isCloning ? fallback(...args) : callback(...args);
}
function $ceb1972acc1ecda9$var$onlyDuringClone(callback) {
    return (...args)=>$ceb1972acc1ecda9$var$isCloning && callback(...args);
}
function $ceb1972acc1ecda9$var$cloneNode(from, to) {
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
    $ceb1972acc1ecda9$var$isCloning = true;
    $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(()=>{
        $ceb1972acc1ecda9$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $ceb1972acc1ecda9$var$isCloning = false;
}
var $ceb1972acc1ecda9$var$isCloningLegacy = false;
function $ceb1972acc1ecda9$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $ceb1972acc1ecda9$var$isCloning = true;
    $ceb1972acc1ecda9$var$isCloningLegacy = true;
    $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(()=>{
        $ceb1972acc1ecda9$var$cloneTree(newEl);
    });
    $ceb1972acc1ecda9$var$isCloning = false;
    $ceb1972acc1ecda9$var$isCloningLegacy = false;
}
function $ceb1972acc1ecda9$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $ceb1972acc1ecda9$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $ceb1972acc1ecda9$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $ceb1972acc1ecda9$var$initTree(el, shallowWalker);
}
function $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $ceb1972acc1ecda9$var$effect;
    $ceb1972acc1ecda9$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $ceb1972acc1ecda9$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $ceb1972acc1ecda9$var$overrideEffect(cache);
}
function $ceb1972acc1ecda9$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$ceb1972acc1ecda9$var$isCloning) return false;
    if ($ceb1972acc1ecda9$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/utils/bind.js
function $ceb1972acc1ecda9$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $ceb1972acc1ecda9$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $ceb1972acc1ecda9$var$camelCase(name) : name;
    switch(name){
        case "value":
            $ceb1972acc1ecda9$var$bindInputValue(el, value);
            break;
        case "style":
            $ceb1972acc1ecda9$var$bindStyles(el, value);
            break;
        case "class":
            $ceb1972acc1ecda9$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $ceb1972acc1ecda9$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $ceb1972acc1ecda9$var$bindAttribute(el, name, value);
            break;
    }
}
function $ceb1972acc1ecda9$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) el.checked = $ceb1972acc1ecda9$var$checkedAttrLooseCompare(el.value, value);
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$ceb1972acc1ecda9$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $ceb1972acc1ecda9$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $ceb1972acc1ecda9$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $ceb1972acc1ecda9$var$setClasses(el, value);
}
function $ceb1972acc1ecda9$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $ceb1972acc1ecda9$var$setStyles(el, value);
}
function $ceb1972acc1ecda9$var$bindAttributeAndProperty(el, name, value) {
    $ceb1972acc1ecda9$var$bindAttribute(el, name, value);
    $ceb1972acc1ecda9$var$setPropertyIfChanged(el, name, value);
}
function $ceb1972acc1ecda9$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $ceb1972acc1ecda9$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($ceb1972acc1ecda9$var$isBooleanAttr(name)) value = name;
        $ceb1972acc1ecda9$var$setIfChanged(el, name, value);
    }
}
function $ceb1972acc1ecda9$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $ceb1972acc1ecda9$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $ceb1972acc1ecda9$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $ceb1972acc1ecda9$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $ceb1972acc1ecda9$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $ceb1972acc1ecda9$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $ceb1972acc1ecda9$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $ceb1972acc1ecda9$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback);
}
function $ceb1972acc1ecda9$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions(()=>{
            return $ceb1972acc1ecda9$var$evaluate(el, binding.expression);
        });
    }
    return $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback);
}
function $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($ceb1972acc1ecda9$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $ceb1972acc1ecda9$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $ceb1972acc1ecda9$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $ceb1972acc1ecda9$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let reference = $ceb1972acc1ecda9$var$effect(()=>{
        const outer = outerGet();
        const inner = innerGet();
        if (firstRun) {
            innerSet($ceb1972acc1ecda9$var$cloneIfObject(outer));
            firstRun = false;
            outerHash = JSON.stringify(outer);
        } else {
            const outerHashLatest = JSON.stringify(outer);
            if (outerHashLatest !== outerHash) {
                innerSet($ceb1972acc1ecda9$var$cloneIfObject(outer));
                outerHash = outerHashLatest;
            } else {
                outerSet($ceb1972acc1ecda9$var$cloneIfObject(inner));
                outerHash = JSON.stringify(inner);
            }
        }
        JSON.stringify(innerGet());
        JSON.stringify(outerGet());
    });
    return ()=>{
        $ceb1972acc1ecda9$var$release(reference);
    };
}
function $ceb1972acc1ecda9$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $ceb1972acc1ecda9$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($ceb1972acc1ecda9$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $ceb1972acc1ecda9$var$stores = {};
var $ceb1972acc1ecda9$var$isReactive = false;
function $ceb1972acc1ecda9$var$store(name, value) {
    if (!$ceb1972acc1ecda9$var$isReactive) {
        $ceb1972acc1ecda9$var$stores = $ceb1972acc1ecda9$var$reactive($ceb1972acc1ecda9$var$stores);
        $ceb1972acc1ecda9$var$isReactive = true;
    }
    if (value === void 0) return $ceb1972acc1ecda9$var$stores[name];
    $ceb1972acc1ecda9$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $ceb1972acc1ecda9$var$stores[name].init();
    $ceb1972acc1ecda9$var$initInterceptors2($ceb1972acc1ecda9$var$stores[name]);
}
function $ceb1972acc1ecda9$var$getStores() {
    return $ceb1972acc1ecda9$var$stores;
}
// packages/alpinejs/src/binds.js
var $ceb1972acc1ecda9$var$binds = {};
function $ceb1972acc1ecda9$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $ceb1972acc1ecda9$var$applyBindingsObject(name, getBindings());
    else $ceb1972acc1ecda9$var$binds[name] = getBindings;
    return ()=>{};
}
function $ceb1972acc1ecda9$var$injectBindingProviders(obj) {
    Object.entries($ceb1972acc1ecda9$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $ceb1972acc1ecda9$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $ceb1972acc1ecda9$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $ceb1972acc1ecda9$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $ceb1972acc1ecda9$var$datas = {};
function $ceb1972acc1ecda9$var$data(name, callback) {
    $ceb1972acc1ecda9$var$datas[name] = callback;
}
function $ceb1972acc1ecda9$var$injectDataProviders(obj, context) {
    Object.entries($ceb1972acc1ecda9$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $ceb1972acc1ecda9$var$Alpine = {
    get reactive () {
        return $ceb1972acc1ecda9$var$reactive;
    },
    get release () {
        return $ceb1972acc1ecda9$var$release;
    },
    get effect () {
        return $ceb1972acc1ecda9$var$effect;
    },
    get raw () {
        return $ceb1972acc1ecda9$var$raw;
    },
    version: "3.13.2",
    flushAndStopDeferringMutations: $ceb1972acc1ecda9$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $ceb1972acc1ecda9$var$disableEffectScheduling,
    startObservingMutations: $ceb1972acc1ecda9$var$startObservingMutations,
    stopObservingMutations: $ceb1972acc1ecda9$var$stopObservingMutations,
    setReactivityEngine: $ceb1972acc1ecda9$var$setReactivityEngine,
    onAttributeRemoved: $ceb1972acc1ecda9$var$onAttributeRemoved,
    onAttributesAdded: $ceb1972acc1ecda9$var$onAttributesAdded,
    closestDataStack: $ceb1972acc1ecda9$var$closestDataStack,
    skipDuringClone: $ceb1972acc1ecda9$var$skipDuringClone,
    onlyDuringClone: $ceb1972acc1ecda9$var$onlyDuringClone,
    addRootSelector: $ceb1972acc1ecda9$var$addRootSelector,
    addInitSelector: $ceb1972acc1ecda9$var$addInitSelector,
    addScopeToNode: $ceb1972acc1ecda9$var$addScopeToNode,
    deferMutations: $ceb1972acc1ecda9$var$deferMutations,
    mapAttributes: $ceb1972acc1ecda9$var$mapAttributes,
    evaluateLater: $ceb1972acc1ecda9$var$evaluateLater,
    interceptInit: $ceb1972acc1ecda9$var$interceptInit,
    setEvaluator: $ceb1972acc1ecda9$var$setEvaluator,
    mergeProxies: $ceb1972acc1ecda9$var$mergeProxies,
    extractProp: $ceb1972acc1ecda9$var$extractProp,
    findClosest: $ceb1972acc1ecda9$var$findClosest,
    onElRemoved: $ceb1972acc1ecda9$var$onElRemoved,
    closestRoot: $ceb1972acc1ecda9$var$closestRoot,
    destroyTree: $ceb1972acc1ecda9$var$destroyTree,
    interceptor: $ceb1972acc1ecda9$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $ceb1972acc1ecda9$var$transition,
    setStyles: // INTERNAL
    $ceb1972acc1ecda9$var$setStyles,
    mutateDom: // INTERNAL
    $ceb1972acc1ecda9$var$mutateDom,
    directive: $ceb1972acc1ecda9$var$directive,
    entangle: $ceb1972acc1ecda9$var$entangle,
    throttle: $ceb1972acc1ecda9$var$throttle,
    debounce: $ceb1972acc1ecda9$var$debounce,
    evaluate: $ceb1972acc1ecda9$var$evaluate,
    initTree: $ceb1972acc1ecda9$var$initTree,
    nextTick: $ceb1972acc1ecda9$var$nextTick,
    prefixed: $ceb1972acc1ecda9$var$prefix,
    prefix: $ceb1972acc1ecda9$var$setPrefix,
    plugin: $ceb1972acc1ecda9$var$plugin,
    magic: $ceb1972acc1ecda9$var$magic,
    store: $ceb1972acc1ecda9$var$store,
    start: $ceb1972acc1ecda9$var$start,
    clone: $ceb1972acc1ecda9$var$clone,
    cloneNode: // INTERNAL
    $ceb1972acc1ecda9$var$cloneNode,
    // INTERNAL
    bound: $ceb1972acc1ecda9$var$getBinding,
    $data: $ceb1972acc1ecda9$var$scope,
    walk: $ceb1972acc1ecda9$var$walk,
    data: $ceb1972acc1ecda9$var$data,
    bind: $ceb1972acc1ecda9$var$bind2
};
var $ceb1972acc1ecda9$var$alpine_default = $ceb1972acc1ecda9$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $ceb1972acc1ecda9$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $ceb1972acc1ecda9$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $ceb1972acc1ecda9$var$isBooleanAttr2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$makeMap($ceb1972acc1ecda9$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $ceb1972acc1ecda9$var$EMPTY_OBJ = Object.freeze({});
var $ceb1972acc1ecda9$var$EMPTY_ARR = Object.freeze([]);
var $ceb1972acc1ecda9$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ceb1972acc1ecda9$var$hasOwn = (val, key)=>$ceb1972acc1ecda9$var$hasOwnProperty.call(val, key);
var $ceb1972acc1ecda9$var$isArray = Array.isArray;
var $ceb1972acc1ecda9$var$isMap = (val)=>$ceb1972acc1ecda9$var$toTypeString(val) === "[object Map]";
var $ceb1972acc1ecda9$var$isString = (val)=>typeof val === "string";
var $ceb1972acc1ecda9$var$isSymbol = (val)=>typeof val === "symbol";
var $ceb1972acc1ecda9$var$isObject = (val)=>val !== null && typeof val === "object";
var $ceb1972acc1ecda9$var$objectToString = Object.prototype.toString;
var $ceb1972acc1ecda9$var$toTypeString = (value)=>$ceb1972acc1ecda9$var$objectToString.call(value);
var $ceb1972acc1ecda9$var$toRawType = (value)=>{
    return $ceb1972acc1ecda9$var$toTypeString(value).slice(8, -1);
};
var $ceb1972acc1ecda9$var$isIntegerKey = (key)=>$ceb1972acc1ecda9$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $ceb1972acc1ecda9$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $ceb1972acc1ecda9$var$camelizeRE = /-(\w)/g;
var $ceb1972acc1ecda9$var$camelize = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>{
    return str.replace($ceb1972acc1ecda9$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $ceb1972acc1ecda9$var$hyphenateRE = /\B([A-Z])/g;
var $ceb1972acc1ecda9$var$hyphenate = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str.replace($ceb1972acc1ecda9$var$hyphenateRE, "-$1").toLowerCase());
var $ceb1972acc1ecda9$var$capitalize = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $ceb1972acc1ecda9$var$toHandlerKey = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str ? `on${$ceb1972acc1ecda9$var$capitalize(str)}` : ``);
var $ceb1972acc1ecda9$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $ceb1972acc1ecda9$var$targetMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$effectStack = [];
var $ceb1972acc1ecda9$var$activeEffect;
var $ceb1972acc1ecda9$var$ITERATE_KEY = Symbol("iterate");
var $ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $ceb1972acc1ecda9$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $ceb1972acc1ecda9$var$effect2(fn, options = $ceb1972acc1ecda9$var$EMPTY_OBJ) {
    if ($ceb1972acc1ecda9$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $ceb1972acc1ecda9$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $ceb1972acc1ecda9$var$stop(effect3) {
    if (effect3.active) {
        $ceb1972acc1ecda9$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $ceb1972acc1ecda9$var$uid = 0;
function $ceb1972acc1ecda9$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$ceb1972acc1ecda9$var$effectStack.includes(effect3)) {
            $ceb1972acc1ecda9$var$cleanup(effect3);
            try {
                $ceb1972acc1ecda9$var$enableTracking();
                $ceb1972acc1ecda9$var$effectStack.push(effect3);
                $ceb1972acc1ecda9$var$activeEffect = effect3;
                return fn();
            } finally{
                $ceb1972acc1ecda9$var$effectStack.pop();
                $ceb1972acc1ecda9$var$resetTracking();
                $ceb1972acc1ecda9$var$activeEffect = $ceb1972acc1ecda9$var$effectStack[$ceb1972acc1ecda9$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $ceb1972acc1ecda9$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $ceb1972acc1ecda9$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $ceb1972acc1ecda9$var$shouldTrack = true;
var $ceb1972acc1ecda9$var$trackStack = [];
function $ceb1972acc1ecda9$var$pauseTracking() {
    $ceb1972acc1ecda9$var$trackStack.push($ceb1972acc1ecda9$var$shouldTrack);
    $ceb1972acc1ecda9$var$shouldTrack = false;
}
function $ceb1972acc1ecda9$var$enableTracking() {
    $ceb1972acc1ecda9$var$trackStack.push($ceb1972acc1ecda9$var$shouldTrack);
    $ceb1972acc1ecda9$var$shouldTrack = true;
}
function $ceb1972acc1ecda9$var$resetTracking() {
    const last = $ceb1972acc1ecda9$var$trackStack.pop();
    $ceb1972acc1ecda9$var$shouldTrack = last === void 0 ? true : last;
}
function $ceb1972acc1ecda9$var$track(target, type, key) {
    if (!$ceb1972acc1ecda9$var$shouldTrack || $ceb1972acc1ecda9$var$activeEffect === void 0) return;
    let depsMap = $ceb1972acc1ecda9$var$targetMap.get(target);
    if (!depsMap) $ceb1972acc1ecda9$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($ceb1972acc1ecda9$var$activeEffect)) {
        dep.add($ceb1972acc1ecda9$var$activeEffect);
        $ceb1972acc1ecda9$var$activeEffect.deps.push(dep);
        if ($ceb1972acc1ecda9$var$activeEffect.options.onTrack) $ceb1972acc1ecda9$var$activeEffect.options.onTrack({
            effect: $ceb1972acc1ecda9$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $ceb1972acc1ecda9$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $ceb1972acc1ecda9$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $ceb1972acc1ecda9$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $ceb1972acc1ecda9$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$ceb1972acc1ecda9$var$isArray(target)) {
                    add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                    if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY));
                } else if ($ceb1972acc1ecda9$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$ceb1972acc1ecda9$var$isArray(target)) {
                    add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                    if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $ceb1972acc1ecda9$var$isNonTrackableKeys = /* @__PURE__ */ $ceb1972acc1ecda9$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $ceb1972acc1ecda9$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($ceb1972acc1ecda9$var$isSymbol));
var $ceb1972acc1ecda9$var$get2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$createGetter();
var $ceb1972acc1ecda9$var$readonlyGet = /* @__PURE__ */ $ceb1972acc1ecda9$var$createGetter(true);
var $ceb1972acc1ecda9$var$arrayInstrumentations = /* @__PURE__ */ $ceb1972acc1ecda9$var$createArrayInstrumentations();
function $ceb1972acc1ecda9$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $ceb1972acc1ecda9$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$ceb1972acc1ecda9$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($ceb1972acc1ecda9$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $ceb1972acc1ecda9$var$pauseTracking();
            const res = $ceb1972acc1ecda9$var$toRaw(this)[key].apply(this, args);
            $ceb1972acc1ecda9$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $ceb1972acc1ecda9$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $ceb1972acc1ecda9$var$shallowReadonlyMap : $ceb1972acc1ecda9$var$readonlyMap : shallow ? $ceb1972acc1ecda9$var$shallowReactiveMap : $ceb1972acc1ecda9$var$reactiveMap).get(target)) return target;
        const targetIsArray = $ceb1972acc1ecda9$var$isArray(target);
        if (!isReadonly && targetIsArray && $ceb1972acc1ecda9$var$hasOwn($ceb1972acc1ecda9$var$arrayInstrumentations, key)) return Reflect.get($ceb1972acc1ecda9$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($ceb1972acc1ecda9$var$isSymbol(key) ? $ceb1972acc1ecda9$var$builtInSymbols.has(key) : $ceb1972acc1ecda9$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $ceb1972acc1ecda9$var$track(target, "get", key);
        if (shallow) return res;
        if ($ceb1972acc1ecda9$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$ceb1972acc1ecda9$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($ceb1972acc1ecda9$var$isObject(res)) return isReadonly ? $ceb1972acc1ecda9$var$readonly(res) : $ceb1972acc1ecda9$var$reactive2(res);
        return res;
    };
}
var $ceb1972acc1ecda9$var$set2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$createSetter();
function $ceb1972acc1ecda9$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $ceb1972acc1ecda9$var$toRaw(value);
            oldValue = $ceb1972acc1ecda9$var$toRaw(oldValue);
            if (!$ceb1972acc1ecda9$var$isArray(target) && $ceb1972acc1ecda9$var$isRef(oldValue) && !$ceb1972acc1ecda9$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $ceb1972acc1ecda9$var$isArray(target) && $ceb1972acc1ecda9$var$isIntegerKey(key) ? Number(key) < target.length : $ceb1972acc1ecda9$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $ceb1972acc1ecda9$var$toRaw(receiver)) {
            if (!hadKey) $ceb1972acc1ecda9$var$trigger(target, "add", key, value);
            else if ($ceb1972acc1ecda9$var$hasChanged(value, oldValue)) $ceb1972acc1ecda9$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $ceb1972acc1ecda9$var$deleteProperty(target, key) {
    const hadKey = $ceb1972acc1ecda9$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $ceb1972acc1ecda9$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $ceb1972acc1ecda9$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$ceb1972acc1ecda9$var$isSymbol(key) || !$ceb1972acc1ecda9$var$builtInSymbols.has(key)) $ceb1972acc1ecda9$var$track(target, "has", key);
    return result;
}
function $ceb1972acc1ecda9$var$ownKeys(target) {
    $ceb1972acc1ecda9$var$track(target, "iterate", $ceb1972acc1ecda9$var$isArray(target) ? "length" : $ceb1972acc1ecda9$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $ceb1972acc1ecda9$var$mutableHandlers = {
    get: $ceb1972acc1ecda9$var$get2,
    set: $ceb1972acc1ecda9$var$set2,
    deleteProperty: $ceb1972acc1ecda9$var$deleteProperty,
    has: $ceb1972acc1ecda9$var$has,
    ownKeys: $ceb1972acc1ecda9$var$ownKeys
};
var $ceb1972acc1ecda9$var$readonlyHandlers = {
    get: $ceb1972acc1ecda9$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $ceb1972acc1ecda9$var$toReactive = (value)=>$ceb1972acc1ecda9$var$isObject(value) ? $ceb1972acc1ecda9$var$reactive2(value) : value;
var $ceb1972acc1ecda9$var$toReadonly = (value)=>$ceb1972acc1ecda9$var$isObject(value) ? $ceb1972acc1ecda9$var$readonly(value) : value;
var $ceb1972acc1ecda9$var$toShallow = (value)=>value;
var $ceb1972acc1ecda9$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $ceb1972acc1ecda9$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "get", key);
    !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $ceb1972acc1ecda9$var$getProto(rawTarget);
    const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $ceb1972acc1ecda9$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "has", key);
    !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $ceb1972acc1ecda9$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $ceb1972acc1ecda9$var$track($ceb1972acc1ecda9$var$toRaw(target), "iterate", $ceb1972acc1ecda9$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $ceb1972acc1ecda9$var$add(value) {
    value = $ceb1972acc1ecda9$var$toRaw(value);
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const proto = $ceb1972acc1ecda9$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $ceb1972acc1ecda9$var$trigger(target, "add", value, value);
    }
    return this;
}
function $ceb1972acc1ecda9$var$set$1(key, value) {
    value = $ceb1972acc1ecda9$var$toRaw(value);
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const { has: has2, get: get3 } = $ceb1972acc1ecda9$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $ceb1972acc1ecda9$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $ceb1972acc1ecda9$var$trigger(target, "add", key, value);
    else if ($ceb1972acc1ecda9$var$hasChanged(value, oldValue)) $ceb1972acc1ecda9$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $ceb1972acc1ecda9$var$deleteEntry(key) {
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const { has: has2, get: get3 } = $ceb1972acc1ecda9$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $ceb1972acc1ecda9$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $ceb1972acc1ecda9$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $ceb1972acc1ecda9$var$clear() {
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $ceb1972acc1ecda9$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $ceb1972acc1ecda9$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $ceb1972acc1ecda9$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
        const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
        !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "iterate", $ceb1972acc1ecda9$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $ceb1972acc1ecda9$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
        const targetIsMap = $ceb1972acc1ecda9$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
        !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "iterate", isKeyOnly ? $ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY : $ceb1972acc1ecda9$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $ceb1972acc1ecda9$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$ceb1972acc1ecda9$var$capitalize(type)} operation ${key}failed: target is readonly.`, $ceb1972acc1ecda9$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $ceb1972acc1ecda9$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this);
        },
        has: $ceb1972acc1ecda9$var$has$1,
        add: $ceb1972acc1ecda9$var$add,
        set: $ceb1972acc1ecda9$var$set$1,
        delete: $ceb1972acc1ecda9$var$deleteEntry,
        clear: $ceb1972acc1ecda9$var$clear,
        forEach: $ceb1972acc1ecda9$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, false, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this);
        },
        has: $ceb1972acc1ecda9$var$has$1,
        add: $ceb1972acc1ecda9$var$add,
        set: $ceb1972acc1ecda9$var$set$1,
        delete: $ceb1972acc1ecda9$var$deleteEntry,
        clear: $ceb1972acc1ecda9$var$clear,
        forEach: $ceb1972acc1ecda9$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this, true);
        },
        has (key) {
            return $ceb1972acc1ecda9$var$has$1.call(this, key, true);
        },
        add: $ceb1972acc1ecda9$var$createReadonlyMethod("add"),
        set: $ceb1972acc1ecda9$var$createReadonlyMethod("set"),
        delete: $ceb1972acc1ecda9$var$createReadonlyMethod("delete"),
        clear: $ceb1972acc1ecda9$var$createReadonlyMethod("clear"),
        forEach: $ceb1972acc1ecda9$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, true, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this, true);
        },
        has (key) {
            return $ceb1972acc1ecda9$var$has$1.call(this, key, true);
        },
        add: $ceb1972acc1ecda9$var$createReadonlyMethod("add"),
        set: $ceb1972acc1ecda9$var$createReadonlyMethod("set"),
        delete: $ceb1972acc1ecda9$var$createReadonlyMethod("delete"),
        clear: $ceb1972acc1ecda9$var$createReadonlyMethod("clear"),
        forEach: $ceb1972acc1ecda9$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$ceb1972acc1ecda9$var$mutableInstrumentations, $ceb1972acc1ecda9$var$readonlyInstrumentations, $ceb1972acc1ecda9$var$shallowInstrumentations, $ceb1972acc1ecda9$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentations();
function $ceb1972acc1ecda9$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $ceb1972acc1ecda9$var$shallowReadonlyInstrumentations : $ceb1972acc1ecda9$var$shallowInstrumentations : isReadonly ? $ceb1972acc1ecda9$var$readonlyInstrumentations : $ceb1972acc1ecda9$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($ceb1972acc1ecda9$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $ceb1972acc1ecda9$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentationGetter(false, false)
};
var $ceb1972acc1ecda9$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentationGetter(true, false)
};
function $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $ceb1972acc1ecda9$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $ceb1972acc1ecda9$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $ceb1972acc1ecda9$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $ceb1972acc1ecda9$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $ceb1972acc1ecda9$var$targetTypeMap($ceb1972acc1ecda9$var$toRawType(value));
}
function $ceb1972acc1ecda9$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $ceb1972acc1ecda9$var$createReactiveObject(target, false, $ceb1972acc1ecda9$var$mutableHandlers, $ceb1972acc1ecda9$var$mutableCollectionHandlers, $ceb1972acc1ecda9$var$reactiveMap);
}
function $ceb1972acc1ecda9$var$readonly(target) {
    return $ceb1972acc1ecda9$var$createReactiveObject(target, true, $ceb1972acc1ecda9$var$readonlyHandlers, $ceb1972acc1ecda9$var$readonlyCollectionHandlers, $ceb1972acc1ecda9$var$readonlyMap);
}
function $ceb1972acc1ecda9$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$ceb1972acc1ecda9$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $ceb1972acc1ecda9$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $ceb1972acc1ecda9$var$toRaw(observed) {
    return observed && $ceb1972acc1ecda9$var$toRaw(observed["__v_raw"]) || observed;
}
function $ceb1972acc1ecda9$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$ceb1972acc1ecda9$var$magic("nextTick", ()=>$ceb1972acc1ecda9$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$ceb1972acc1ecda9$var$magic("dispatch", (el)=>$ceb1972acc1ecda9$var$dispatch.bind($ceb1972acc1ecda9$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$ceb1972acc1ecda9$var$magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$ceb1972acc1ecda9$var$magic("store", $ceb1972acc1ecda9$var$getStores);
// packages/alpinejs/src/magics/$data.js
$ceb1972acc1ecda9$var$magic("data", (el)=>$ceb1972acc1ecda9$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$ceb1972acc1ecda9$var$magic("root", (el)=>$ceb1972acc1ecda9$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$ceb1972acc1ecda9$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $ceb1972acc1ecda9$var$mergeProxies($ceb1972acc1ecda9$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $ceb1972acc1ecda9$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $ceb1972acc1ecda9$var$globalIdMemo = {};
function $ceb1972acc1ecda9$var$findAndIncrementId(name) {
    if (!$ceb1972acc1ecda9$var$globalIdMemo[name]) $ceb1972acc1ecda9$var$globalIdMemo[name] = 0;
    return ++$ceb1972acc1ecda9$var$globalIdMemo[name];
}
function $ceb1972acc1ecda9$var$closestIdRoot(el, name) {
    return $ceb1972acc1ecda9$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $ceb1972acc1ecda9$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $ceb1972acc1ecda9$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$ceb1972acc1ecda9$var$magic("id", (el)=>(name, key = null)=>{
        let root = $ceb1972acc1ecda9$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $ceb1972acc1ecda9$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$ceb1972acc1ecda9$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$ceb1972acc1ecda9$var$warnMissingPluginMagic("Focus", "focus", "focus");
$ceb1972acc1ecda9$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $ceb1972acc1ecda9$var$warnMissingPluginMagic(name, magicName, slug) {
    $ceb1972acc1ecda9$var$magic(magicName, (el)=>$ceb1972acc1ecda9$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$ceb1972acc1ecda9$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $ceb1972acc1ecda9$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$ceb1972acc1ecda9$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $ceb1972acc1ecda9$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $ceb1972acc1ecda9$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $ceb1972acc1ecda9$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $ceb1972acc1ecda9$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $ceb1972acc1ecda9$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $ceb1972acc1ecda9$var$getTarget(expression);
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $ceb1972acc1ecda9$var$teleportContainerDuringClone = document.createElement("div");
function $ceb1972acc1ecda9$var$getTarget(expression) {
    let target = $ceb1972acc1ecda9$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $ceb1972acc1ecda9$var$teleportContainerDuringClone;
    })();
    if (!target) $ceb1972acc1ecda9$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $ceb1972acc1ecda9$var$handler = ()=>{};
$ceb1972acc1ecda9$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$ceb1972acc1ecda9$var$directive("ignore", $ceb1972acc1ecda9$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$ceb1972acc1ecda9$var$directive("effect", (el, { expression: expression }, { effect: effect3 })=>effect3($ceb1972acc1ecda9$var$evaluateLater(el, expression)));
// packages/alpinejs/src/utils/on.js
function $ceb1972acc1ecda9$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $ceb1972acc1ecda9$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $ceb1972acc1ecda9$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $ceb1972acc1ecda9$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $ceb1972acc1ecda9$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $ceb1972acc1ecda9$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $ceb1972acc1ecda9$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($ceb1972acc1ecda9$var$isKeyEvent(event)) {
            if ($ceb1972acc1ecda9$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $ceb1972acc1ecda9$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $ceb1972acc1ecda9$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $ceb1972acc1ecda9$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $ceb1972acc1ecda9$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $ceb1972acc1ecda9$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $ceb1972acc1ecda9$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $ceb1972acc1ecda9$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $ceb1972acc1ecda9$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $ceb1972acc1ecda9$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($ceb1972acc1ecda9$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $ceb1972acc1ecda9$var$keyToModifiers(key) {
    if (!key) return [];
    key = $ceb1972acc1ecda9$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$ceb1972acc1ecda9$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $ceb1972acc1ecda9$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($ceb1972acc1ecda9$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $ceb1972acc1ecda9$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $ceb1972acc1ecda9$var$isCloning ? ()=>{} : $ceb1972acc1ecda9$var$on(el, event, modifiers, (e)=>{
        setValue($ceb1972acc1ecda9$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $ceb1972acc1ecda9$var$on(el.form, "reset", [], (e)=>{
            $ceb1972acc1ecda9$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $ceb1972acc1ecda9$var$mutateDom(()=>$ceb1972acc1ecda9$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $ceb1972acc1ecda9$var$getInputValue(el, modifiers, event, currentValue) {
    return $ceb1972acc1ecda9$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = modifiers.includes("number") ? $ceb1972acc1ecda9$var$safeParseNumber(event.target.value) : event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$ceb1972acc1ecda9$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option)=>{
            let rawValue = option.value || option.text;
            return $ceb1972acc1ecda9$var$safeParseNumber(rawValue);
        }) : Array.from(event.target.selectedOptions).map((option)=>{
            return option.value || option.text;
        });
        else {
            let rawValue = event.target.value;
            return modifiers.includes("number") ? $ceb1972acc1ecda9$var$safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
        }
    });
}
function $ceb1972acc1ecda9$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $ceb1972acc1ecda9$var$isNumeric2(number) ? number : rawValue;
}
function $ceb1972acc1ecda9$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $ceb1972acc1ecda9$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $ceb1972acc1ecda9$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$ceb1972acc1ecda9$var$directive("cloak", (el)=>queueMicrotask(()=>$ceb1972acc1ecda9$var$mutateDom(()=>el.removeAttribute($ceb1972acc1ecda9$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$ceb1972acc1ecda9$var$addInitSelector(()=>`[${$ceb1972acc1ecda9$var$prefix("init")}]`);
$ceb1972acc1ecda9$var$directive("init", $ceb1972acc1ecda9$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$ceb1972acc1ecda9$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$ceb1972acc1ecda9$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $ceb1972acc1ecda9$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$ceb1972acc1ecda9$var$mapAttributes($ceb1972acc1ecda9$var$startingWith(":", $ceb1972acc1ecda9$var$into($ceb1972acc1ecda9$var$prefix("bind:"))));
var $ceb1972acc1ecda9$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $ceb1972acc1ecda9$var$injectBindingProviders(bindingProviders);
        let getBindings = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $ceb1972acc1ecda9$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $ceb1972acc1ecda9$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $ceb1972acc1ecda9$var$mutateDom(()=>$ceb1972acc1ecda9$var$bind(el, value, result, modifiers));
        }));
};
$ceb1972acc1ecda9$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$ceb1972acc1ecda9$var$directive("bind", $ceb1972acc1ecda9$var$handler2);
function $ceb1972acc1ecda9$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$ceb1972acc1ecda9$var$addRootSelector(()=>`[${$ceb1972acc1ecda9$var$prefix("data")}]`);
$ceb1972acc1ecda9$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($ceb1972acc1ecda9$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $ceb1972acc1ecda9$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $ceb1972acc1ecda9$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $ceb1972acc1ecda9$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $ceb1972acc1ecda9$var$injectMagics(data2, el);
    let reactiveData = $ceb1972acc1ecda9$var$reactive(data2);
    $ceb1972acc1ecda9$var$initInterceptors2(reactiveData);
    let undo = $ceb1972acc1ecda9$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $ceb1972acc1ecda9$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $ceb1972acc1ecda9$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
// packages/alpinejs/src/directives/x-show.js
$ceb1972acc1ecda9$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $ceb1972acc1ecda9$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$ceb1972acc1ecda9$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $ceb1972acc1ecda9$var$parseForExpression(expression);
    let evaluateItems = $ceb1972acc1ecda9$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $ceb1972acc1ecda9$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$ceb1972acc1ecda9$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $ceb1972acc1ecda9$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($ceb1972acc1ecda9$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($ceb1972acc1ecda9$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                if (!elForSpot) $ceb1972acc1ecda9$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $ceb1972acc1ecda9$var$reactive(scope2);
            $ceb1972acc1ecda9$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                lastEl.after(clone2);
                $ceb1972acc1ecda9$var$initTree(clone2);
            });
            if (typeof key === "object") $ceb1972acc1ecda9$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $ceb1972acc1ecda9$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $ceb1972acc1ecda9$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $ceb1972acc1ecda9$var$handler3() {}
$ceb1972acc1ecda9$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $ceb1972acc1ecda9$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$ceb1972acc1ecda9$var$directive("ref", $ceb1972acc1ecda9$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$ceb1972acc1ecda9$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $ceb1972acc1ecda9$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $ceb1972acc1ecda9$var$addScopeToNode(clone2, {}, el);
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            el.after(clone2);
            $ceb1972acc1ecda9$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $ceb1972acc1ecda9$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($ceb1972acc1ecda9$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$ceb1972acc1ecda9$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$ceb1972acc1ecda9$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$ceb1972acc1ecda9$var$mapAttributes($ceb1972acc1ecda9$var$startingWith("@", $ceb1972acc1ecda9$var$into($ceb1972acc1ecda9$var$prefix("on:"))));
$ceb1972acc1ecda9$var$directive("on", $ceb1972acc1ecda9$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $ceb1972acc1ecda9$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $ceb1972acc1ecda9$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Focus", "trap", "focus");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $ceb1972acc1ecda9$var$warnMissingPluginDirective(name, directiveName, slug) {
    $ceb1972acc1ecda9$var$directive(directiveName, (el)=>$ceb1972acc1ecda9$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$ceb1972acc1ecda9$var$alpine_default.setEvaluator($ceb1972acc1ecda9$var$normalEvaluator);
$ceb1972acc1ecda9$var$alpine_default.setReactivityEngine({
    reactive: $ceb1972acc1ecda9$var$reactive2,
    effect: $ceb1972acc1ecda9$var$effect2,
    release: $ceb1972acc1ecda9$var$stop,
    raw: $ceb1972acc1ecda9$var$toRaw
});
var $ceb1972acc1ecda9$var$src_default = $ceb1972acc1ecda9$var$alpine_default;
// packages/alpinejs/builds/module.js
var $ceb1972acc1ecda9$export$2e2bcd8739ae039 = $ceb1972acc1ecda9$var$src_default;


class $4256b05ef69d80e2$export$2e2bcd8739ae039 {
    constructor(faces = [
        1,
        2,
        3,
        4,
        5,
        6
    ]){
        this.face = faces[Math.floor(Math.random() * faces.length)];
        this.held = false;
        this.element = null;
    }
    roll(faces) {
        this.face = faces[Math.floor(Math.random() * faces.length)];
        this.rotateRandomly();
    }
    animateRoll(faces) {
        document.getElementById("audio-dice").play();
        let int = setInterval(()=>this.roll(faces), 50);
        setTimeout(()=>{
            clearInterval(int);
        }, 400);
    }
    rotateRandomly() {
        let min = -0.1;
        let max = 0.1;
        let delta = max - min;
        const travel = delta * Math.random();
        this.element.children[0].style.transform = `rotate(${min + travel}turn)`;
    }
    resetPosition() {
        this.held = false;
        this.element.setAttribute("data-x", 0);
        this.element.setAttribute("data-y", 0);
        this.element.style.transform = "translate(0,0)";
    }
}


var $e5dce095faec56ac$exports = {};
$e5dce095faec56ac$exports = new URL("1.b055f9f7.svg", import.meta.url).toString();


var $54aca6678ba55f38$exports = {};
$54aca6678ba55f38$exports = new URL("2.c5aeb32e.svg", import.meta.url).toString();


var $1166dc3a7802b25d$exports = {};
$1166dc3a7802b25d$exports = new URL("3.dc807893.svg", import.meta.url).toString();


var $c443b86f3d2a9cfc$exports = {};
$c443b86f3d2a9cfc$exports = new URL("4.3728eda6.svg", import.meta.url).toString();


var $839ddb0a74caa422$exports = {};
$839ddb0a74caa422$exports = new URL("5.6b69b1fd.svg", import.meta.url).toString();


var $40a68a6834bb1ad7$exports = {};
$40a68a6834bb1ad7$exports = new URL("6.e82c949c.svg", import.meta.url).toString();


var $8dc991c4c18630b2$export$2e2bcd8739ae039 = ()=>({
        customDice: false,
        customPanelOpen: false,
        customSets: [],
        dice: [],
        pipImages: [
            (0, (/*@__PURE__*/$parcel$interopDefault($e5dce095faec56ac$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($54aca6678ba55f38$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($1166dc3a7802b25d$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($c443b86f3d2a9cfc$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($839ddb0a74caa422$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($40a68a6834bb1ad7$exports)))
        ],
        faces: [
            1,
            2,
            3,
            4,
            5,
            6
        ],
        init () {
            this.numDice = 5;
            this.getCustomSets();
        },
        get numDice () {
            return this.dice.length;
        },
        set numDice (val){
            const next = Math.max(0, parseInt(val, 10) || 0);
            if (next > this.dice.length) {
                this.addDie();
                this.numDice = next;
            } else if (next < this.dice.length) {
                this.removeDie();
                this.numDice = next;
            }
        },
        get numFaces () {
            return this.faces.length;
        },
        set numFaces (val){
            const next = Math.max(1, parseInt(val, 10) || 0);
            this.faces = [];
            for(let i = 0; i < next; i++)this.faces.push(i + 1);
        },
        get numHeldDice () {
            return this.numDice - this.freeDice.length;
        },
        get freeDice () {
            return this.dice.filter((die)=>!die.held);
        },
        get facingDice () {
            return this.dice.map((die)=>die.face).sort();
        },
        get facingTotal () {
            return this.dice.map((die)=>parseInt(die.face)).reduce((a, b)=>a + b, 0);
        },
        addDie () {
            this.dice.push(new (0, $4256b05ef69d80e2$export$2e2bcd8739ae039)(this.faces));
        },
        removeDie () {
            this.dice.pop();
        },
        addFace (text = this.faces.length + 1) {
            this.faces.push(text);
        },
        removeFace (index = -1) {
            this.faces.splice(index, 1);
        },
        resetFaces () {
            this.faces.forEach((face, i)=>{
                this.faces[i] = i + 1;
            });
            this.dice.forEach((die)=>die.roll(this.faces));
        },
        toggleCustomDice () {
            if (this.customDice && this.customPanelOpen) {
                this.customDice = false;
                this.customPanelOpen = false;
                this.resetFaces();
                return;
            }
            if (this.customDice && !this.customPanelOpen) {
                this.customPanelOpen = true;
                return;
            }
            this.customDice = true;
            this.customPanelOpen = true;
        },
        closeCustomPanel () {
            this.customPanelOpen = false;
        },
        // READ AND WRITE SETS TO LOCAL STORAgE
        addCustomSet (inputName) {
            // Check if name exists
            let i = this.customSets.map((set)=>set.name).indexOf(inputName);
            if (i >= 0) {
                if (confirm("Would you like to overwrite the exising set with that name? \nIf not, cancel and choose a different name") == true) {
                    this.customSets[i] = {
                        name: inputName,
                        list: [
                            ...this.faces
                        ]
                    };
                    localStorage.setItem("customSets", JSON.stringify(this.customSets));
                    this.getCustomSets();
                }
            } else {
                this.customSets.push({
                    name: inputName,
                    list: [
                        ...this.faces
                    ]
                });
                localStorage.setItem("customSets", JSON.stringify(this.customSets));
                this.getCustomSets();
            }
            this.setName = "";
        },
        getCustomSets () {
            try {
                this.customSets = JSON.parse(localStorage.getItem("customSets")) || [];
            } catch (error) {
                this.customSets = [];
                localStorage.removeItem("customSets");
            }
        },
        removeCustomSet (set) {
            this.customSets.splice(this.customSets.indexOf(set), 1);
            localStorage.setItem("customSets", JSON.stringify(this.customSets));
        },
        useCustomSet (set) {
            this.faces = [
                ...set.list
            ];
            this.setName = set.name;
        }
    });


var $46efa3ec03c6de42$exports = {};
/* interact.js 1.10.19 | https://interactjs.io/license */ !function(t1) {
    $46efa3ec03c6de42$exports = t1();
}(function() {
    var t1 = {};
    Object.defineProperty(t1, "__esModule", {
        value: !0
    }), t1.default = void 0, t1.default = function(t1) {
        return !(!t1 || !t1.Window) && t1 instanceof t1.Window;
    };
    var e = {};
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getWindow = function(e) {
        return (0, t1.default)(e) ? e : (e.ownerDocument || e).defaultView || r.window;
    }, e.init = o, e.window = e.realWindow = void 0;
    var n = void 0;
    e.realWindow = n;
    var r = void 0;
    function o(t1) {
        e.realWindow = n = t1;
        var o = t1.document.createTextNode("");
        o.ownerDocument !== t1.document && "function" == typeof t1.wrap && t1.wrap(o) === o && (t1 = t1.wrap(t1)), e.window = r = t1;
    }
    e.window = r, "undefined" != typeof window && window && o(window);
    var i = {};
    function a(t1) {
        return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, a(t1);
    }
    Object.defineProperty(i, "__esModule", {
        value: !0
    }), i.default = void 0;
    var s = function(t1) {
        return !!t1 && "object" === a(t1);
    }, l = function(t1) {
        return "function" == typeof t1;
    }, u = {
        window: function(n) {
            return n === e.window || (0, t1.default)(n);
        },
        docFrag: function(t1) {
            return s(t1) && 11 === t1.nodeType;
        },
        object: s,
        func: l,
        number: function(t1) {
            return "number" == typeof t1;
        },
        bool: function(t1) {
            return "boolean" == typeof t1;
        },
        string: function(t1) {
            return "string" == typeof t1;
        },
        element: function(t1) {
            if (!t1 || "object" !== a(t1)) return !1;
            var n = e.getWindow(t1) || e.window;
            return /object|function/.test("undefined" == typeof Element ? "undefined" : a(Element)) ? t1 instanceof Element || t1 instanceof n.Element : 1 === t1.nodeType && "string" == typeof t1.nodeName;
        },
        plainObject: function(t1) {
            return s(t1) && !!t1.constructor && /function Object\b/.test(t1.constructor.toString());
        },
        array: function(t1) {
            return s(t1) && void 0 !== t1.length && l(t1.splice);
        }
    };
    i.default = u;
    var c = {};
    function f(t1) {
        var e = t1.interaction;
        if ("drag" === e.prepared.name) {
            var n = e.prepared.axis;
            "x" === n ? (e.coords.cur.page.y = e.coords.start.page.y, e.coords.cur.client.y = e.coords.start.client.y, e.coords.velocity.client.y = 0, e.coords.velocity.page.y = 0) : "y" === n && (e.coords.cur.page.x = e.coords.start.page.x, e.coords.cur.client.x = e.coords.start.client.x, e.coords.velocity.client.x = 0, e.coords.velocity.page.x = 0);
        }
    }
    function d(t1) {
        var e = t1.iEvent, n = t1.interaction;
        if ("drag" === n.prepared.name) {
            var r = n.prepared.axis;
            if ("x" === r || "y" === r) {
                var o = "x" === r ? "y" : "x";
                e.page[o] = n.coords.start.page[o], e.client[o] = n.coords.start.client[o], e.delta[o] = 0;
            }
        }
    }
    Object.defineProperty(c, "__esModule", {
        value: !0
    }), c.default = void 0;
    var p = {
        id: "actions/drag",
        install: function(t1) {
            var e = t1.actions, n = t1.Interactable, r = t1.defaults;
            n.prototype.draggable = p.draggable, e.map.drag = p, e.methodDict.drag = "draggable", r.actions.drag = p.defaults;
        },
        listeners: {
            "interactions:before-action-move": f,
            "interactions:action-resume": f,
            "interactions:action-move": d,
            "auto-start:check": function(t1) {
                var e = t1.interaction, n = t1.interactable, r = t1.buttons, o = n.options.drag;
                if (o && o.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || 0 != (r & n.options.drag.mouseButtons))) return t1.action = {
                    name: "drag",
                    axis: "start" === o.lockAxis ? o.startAxis : o.lockAxis
                }, !1;
            }
        },
        draggable: function(t1) {
            return i.default.object(t1) ? (this.options.drag.enabled = !1 !== t1.enabled, this.setPerAction("drag", t1), this.setOnEvents("drag", t1), /^(xy|x|y|start)$/.test(t1.lockAxis) && (this.options.drag.lockAxis = t1.lockAxis), /^(xy|x|y)$/.test(t1.startAxis) && (this.options.drag.startAxis = t1.startAxis), this) : i.default.bool(t1) ? (this.options.drag.enabled = t1, this) : this.options.drag;
        },
        beforeMove: f,
        move: d,
        defaults: {
            startAxis: "xy",
            lockAxis: "xy"
        },
        getCursor: function() {
            return "move";
        }
    }, v = p;
    c.default = v;
    var h = {};
    Object.defineProperty(h, "__esModule", {
        value: !0
    }), h.default = void 0;
    var g = {
        init: function(t1) {
            var e = t1;
            g.document = e.document, g.DocumentFragment = e.DocumentFragment || y, g.SVGElement = e.SVGElement || y, g.SVGSVGElement = e.SVGSVGElement || y, g.SVGElementInstance = e.SVGElementInstance || y, g.Element = e.Element || y, g.HTMLElement = e.HTMLElement || g.Element, g.Event = e.Event, g.Touch = e.Touch || y, g.PointerEvent = e.PointerEvent || e.MSPointerEvent;
        },
        document: null,
        DocumentFragment: null,
        SVGElement: null,
        SVGSVGElement: null,
        SVGElementInstance: null,
        Element: null,
        HTMLElement: null,
        Event: null,
        Touch: null,
        PointerEvent: null
    };
    function y() {}
    var m = g;
    h.default = m;
    var b = {};
    Object.defineProperty(b, "__esModule", {
        value: !0
    }), b.default = void 0;
    var x = {
        init: function(t1) {
            var e = h.default.Element, n = t1.navigator || {};
            x.supportsTouch = "ontouchstart" in t1 || i.default.func(t1.DocumentTouch) && h.default.document instanceof t1.DocumentTouch, x.supportsPointerEvent = !1 !== n.pointerEnabled && !!h.default.PointerEvent, x.isIOS = /iP(hone|od|ad)/.test(n.platform), x.isIOS7 = /iP(hone|od|ad)/.test(n.platform) && /OS 7[^\d]/.test(n.appVersion), x.isIe9 = /MSIE 9/.test(n.userAgent), x.isOperaMobile = "Opera" === n.appName && x.supportsTouch && /Presto/.test(n.userAgent), x.prefixedMatchesSelector = "matches" in e.prototype ? "matches" : "webkitMatchesSelector" in e.prototype ? "webkitMatchesSelector" : "mozMatchesSelector" in e.prototype ? "mozMatchesSelector" : "oMatchesSelector" in e.prototype ? "oMatchesSelector" : "msMatchesSelector", x.pEventTypes = x.supportsPointerEvent ? h.default.PointerEvent === t1.MSPointerEvent ? {
                up: "MSPointerUp",
                down: "MSPointerDown",
                over: "mouseover",
                out: "mouseout",
                move: "MSPointerMove",
                cancel: "MSPointerCancel"
            } : {
                up: "pointerup",
                down: "pointerdown",
                over: "pointerover",
                out: "pointerout",
                move: "pointermove",
                cancel: "pointercancel"
            } : null, x.wheelEvent = h.default.document && "onmousewheel" in h.default.document ? "mousewheel" : "wheel";
        },
        supportsTouch: null,
        supportsPointerEvent: null,
        isIOS7: null,
        isIOS: null,
        isIe9: null,
        isOperaMobile: null,
        prefixedMatchesSelector: null,
        pEventTypes: null,
        wheelEvent: null
    }, w = x;
    b.default = w;
    var _ = {};
    function P(t1) {
        var e = t1.parentNode;
        if (i.default.docFrag(e)) {
            for(; (e = e.host) && i.default.docFrag(e););
            return e;
        }
        return e;
    }
    function O(t1, n) {
        return e.window !== e.realWindow && (n = n.replace(/\/deep\//g, " ")), t1[b.default.prefixedMatchesSelector](n);
    }
    Object.defineProperty(_, "__esModule", {
        value: !0
    }), _.closest = function(t1, e) {
        for(; i.default.element(t1);){
            if (O(t1, e)) return t1;
            t1 = P(t1);
        }
        return null;
    }, _.getActualElement = function(t1) {
        return t1.correspondingUseElement || t1;
    }, _.getElementClientRect = j, _.getElementRect = function(t1) {
        var n = j(t1);
        if (!b.default.isIOS7 && n) {
            var r = T(e.getWindow(t1));
            n.left += r.x, n.right += r.x, n.top += r.y, n.bottom += r.y;
        }
        return n;
    }, _.getPath = function(t1) {
        for(var e = []; t1;)e.push(t1), t1 = P(t1);
        return e;
    }, _.getScrollXY = T, _.indexOfDeepestElement = function(t1) {
        for(var n, r = [], o = 0; o < t1.length; o++){
            var i = t1[o], a = t1[n];
            if (i && o !== n) {
                if (a) {
                    var s = E(i), l = E(a);
                    if (s !== i.ownerDocument) {
                        if (l !== i.ownerDocument) {
                            if (s !== l) {
                                r = r.length ? r : S(a);
                                var u = void 0;
                                if (a instanceof h.default.HTMLElement && i instanceof h.default.SVGElement && !(i instanceof h.default.SVGSVGElement)) {
                                    if (i === l) continue;
                                    u = i.ownerSVGElement;
                                } else u = i;
                                for(var c = S(u, a.ownerDocument), f = 0; c[f] && c[f] === r[f];)f++;
                                var d = [
                                    c[f - 1],
                                    c[f],
                                    r[f]
                                ];
                                if (d[0]) for(var p = d[0].lastChild; p;){
                                    if (p === d[1]) {
                                        n = o, r = c;
                                        break;
                                    }
                                    if (p === d[2]) break;
                                    p = p.previousSibling;
                                }
                            } else v = i, g = a, (parseInt(e.getWindow(v).getComputedStyle(v).zIndex, 10) || 0) >= (parseInt(e.getWindow(g).getComputedStyle(g).zIndex, 10) || 0) && (n = o);
                        } else n = o;
                    }
                } else n = o;
            }
        }
        var v, g;
        return n;
    }, _.matchesSelector = O, _.matchesUpTo = function(t1, e, n) {
        for(; i.default.element(t1);){
            if (O(t1, e)) return !0;
            if ((t1 = P(t1)) === n) return O(t1, e);
        }
        return !1;
    }, _.nodeContains = function(t1, e) {
        if (t1.contains) return t1.contains(e);
        for(; e;){
            if (e === t1) return !0;
            e = e.parentNode;
        }
        return !1;
    }, _.parentNode = P, _.trySelector = function(t1) {
        return !!i.default.string(t1) && (h.default.document.querySelector(t1), !0);
    };
    var E = function(t1) {
        return t1.parentNode || t1.host;
    };
    function S(t1, e) {
        for(var n, r = [], o = t1; (n = E(o)) && o !== e && n !== o.ownerDocument;)r.unshift(o), o = n;
        return r;
    }
    function T(t1) {
        return {
            x: (t1 = t1 || e.window).scrollX || t1.document.documentElement.scrollLeft,
            y: t1.scrollY || t1.document.documentElement.scrollTop
        };
    }
    function j(t1) {
        var e = t1 instanceof h.default.SVGElement ? t1.getBoundingClientRect() : t1.getClientRects()[0];
        return e && {
            left: e.left,
            right: e.right,
            top: e.top,
            bottom: e.bottom,
            width: e.width || e.right - e.left,
            height: e.height || e.bottom - e.top
        };
    }
    var M = {};
    Object.defineProperty(M, "__esModule", {
        value: !0
    }), M.default = function(t1, e) {
        for(var n in e)t1[n] = e[n];
        return t1;
    };
    var k = {};
    function I(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var n = 0, r = Array(e); n < e; n++)r[n] = t1[n];
        return r;
    }
    function D(t1, e, n) {
        return "parent" === t1 ? (0, _.parentNode)(n) : "self" === t1 ? e.getRect(n) : (0, _.closest)(n, t1);
    }
    Object.defineProperty(k, "__esModule", {
        value: !0
    }), k.addEdges = function(t1, e, n) {
        t1.left && (e.left += n.x), t1.right && (e.right += n.x), t1.top && (e.top += n.y), t1.bottom && (e.bottom += n.y), e.width = e.right - e.left, e.height = e.bottom - e.top;
    }, k.getStringOptionResult = D, k.rectToXY = function(t1) {
        return t1 && {
            x: "x" in t1 ? t1.x : t1.left,
            y: "y" in t1 ? t1.y : t1.top
        };
    }, k.resolveRectLike = function(t1, e, n, r) {
        var o, a = t1;
        return i.default.string(a) ? a = D(a, e, n) : i.default.func(a) && (a = a.apply(void 0, function(t1) {
            if (Array.isArray(t1)) return I(t1);
        }(o = r) || function(t1) {
            if ("undefined" != typeof Symbol && null != t1[Symbol.iterator] || null != t1["@@iterator"]) return Array.from(t1);
        }(o) || function(t1, e) {
            if (t1) {
                if ("string" == typeof t1) return I(t1, e);
                var n = Object.prototype.toString.call(t1).slice(8, -1);
                return "Object" === n && t1.constructor && (n = t1.constructor.name), "Map" === n || "Set" === n ? Array.from(t1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? I(t1, e) : void 0;
            }
        }(o) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }())), i.default.element(a) && (a = (0, _.getElementRect)(a)), a;
    }, k.tlbrToXywh = function(t1) {
        return !t1 || "x" in t1 && "y" in t1 || ((t1 = (0, M.default)({}, t1)).x = t1.left || 0, t1.y = t1.top || 0, t1.width = t1.width || (t1.right || 0) - t1.x, t1.height = t1.height || (t1.bottom || 0) - t1.y), t1;
    }, k.xywhToTlbr = function(t1) {
        return !t1 || "left" in t1 && "top" in t1 || ((t1 = (0, M.default)({}, t1)).left = t1.x || 0, t1.top = t1.y || 0, t1.right = t1.right || t1.left + t1.width, t1.bottom = t1.bottom || t1.top + t1.height), t1;
    };
    var A = {};
    Object.defineProperty(A, "__esModule", {
        value: !0
    }), A.default = function(t1, e, n) {
        var r = t1.options[n], o = r && r.origin || t1.options.origin, i = (0, k.resolveRectLike)(o, t1, e, [
            t1 && e
        ]);
        return (0, k.rectToXY)(i) || {
            x: 0,
            y: 0
        };
    };
    var z = {};
    function C(t1) {
        return t1.trim().split(/ +/);
    }
    Object.defineProperty(z, "__esModule", {
        value: !0
    }), z.default = function t1(e, n, r) {
        if (r = r || {}, i.default.string(e) && -1 !== e.search(" ") && (e = C(e)), i.default.array(e)) return e.reduce(function(e, o) {
            return (0, M.default)(e, t1(o, n, r));
        }, r);
        if (i.default.object(e) && (n = e, e = ""), i.default.func(n)) r[e] = r[e] || [], r[e].push(n);
        else if (i.default.array(n)) for(var o = 0; o < n.length; o++){
            var a;
            a = n[o], t1(e, a, r);
        }
        else if (i.default.object(n)) for(var s in n){
            var l = C(s).map(function(t1) {
                return "".concat(e).concat(t1);
            });
            t1(l, n[s], r);
        }
        return r;
    };
    var R = {};
    Object.defineProperty(R, "__esModule", {
        value: !0
    }), R.default = void 0, R.default = function(t1, e) {
        return Math.sqrt(t1 * t1 + e * e);
    };
    var F = {};
    Object.defineProperty(F, "__esModule", {
        value: !0
    }), F.default = function(t1, e) {
        t1.__set || (t1.__set = {});
        var n = function(n) {
            if (X.some(function(t1) {
                return 0 === n.indexOf(t1);
            })) return "continue";
            "function" != typeof t1[n] && "__set" !== n && Object.defineProperty(t1, n, {
                get: function() {
                    return n in t1.__set ? t1.__set[n] : t1.__set[n] = e[n];
                },
                set: function(e) {
                    t1.__set[n] = e;
                },
                configurable: !0
            });
        };
        for(var r in e)n(r);
        return t1;
    };
    var X = [
        "webkit",
        "moz"
    ], B = {};
    function Y(t1) {
        return t1 instanceof h.default.Event || t1 instanceof h.default.Touch;
    }
    function W(t1, e, n) {
        return t1 = t1 || "page", (n = n || {}).x = e[t1 + "X"], n.y = e[t1 + "Y"], n;
    }
    function L(t1, e) {
        return e = e || {
            x: 0,
            y: 0
        }, b.default.isOperaMobile && Y(t1) ? (W("screen", t1, e), e.x += window.scrollX, e.y += window.scrollY) : W("page", t1, e), e;
    }
    function U(t1, e) {
        return e = e || {}, b.default.isOperaMobile && Y(t1) ? W("screen", t1, e) : W("client", t1, e), e;
    }
    function V(t1) {
        var e = [];
        return i.default.array(t1) ? (e[0] = t1[0], e[1] = t1[1]) : "touchend" === t1.type ? 1 === t1.touches.length ? (e[0] = t1.touches[0], e[1] = t1.changedTouches[0]) : 0 === t1.touches.length && (e[0] = t1.changedTouches[0], e[1] = t1.changedTouches[1]) : (e[0] = t1.touches[0], e[1] = t1.touches[1]), e;
    }
    function N(t1) {
        for(var e = {
            pageX: 0,
            pageY: 0,
            clientX: 0,
            clientY: 0,
            screenX: 0,
            screenY: 0
        }, n = 0; n < t1.length; n++){
            var r = t1[n];
            for(var o in e)e[o] += r[o];
        }
        for(var i in e)e[i] /= t1.length;
        return e;
    }
    Object.defineProperty(B, "__esModule", {
        value: !0
    }), B.coordsToEvent = function(t1) {
        return {
            coords: t1,
            get page () {
                return this.coords.page;
            },
            get client () {
                return this.coords.client;
            },
            get timeStamp () {
                return this.coords.timeStamp;
            },
            get pageX () {
                return this.coords.page.x;
            },
            get pageY () {
                return this.coords.page.y;
            },
            get clientX () {
                return this.coords.client.x;
            },
            get clientY () {
                return this.coords.client.y;
            },
            get pointerId () {
                return this.coords.pointerId;
            },
            get target () {
                return this.coords.target;
            },
            get type () {
                return this.coords.type;
            },
            get pointerType () {
                return this.coords.pointerType;
            },
            get buttons () {
                return this.coords.buttons;
            },
            preventDefault: function() {}
        };
    }, B.copyCoords = function(t1, e) {
        t1.page = t1.page || {}, t1.page.x = e.page.x, t1.page.y = e.page.y, t1.client = t1.client || {}, t1.client.x = e.client.x, t1.client.y = e.client.y, t1.timeStamp = e.timeStamp;
    }, B.getClientXY = U, B.getEventTargets = function(t1) {
        var e = i.default.func(t1.composedPath) ? t1.composedPath() : t1.path;
        return [
            _.getActualElement(e ? e[0] : t1.target),
            _.getActualElement(t1.currentTarget)
        ];
    }, B.getPageXY = L, B.getPointerId = function(t1) {
        return i.default.number(t1.pointerId) ? t1.pointerId : t1.identifier;
    }, B.getPointerType = function(t1) {
        return i.default.string(t1.pointerType) ? t1.pointerType : i.default.number(t1.pointerType) ? [
            void 0,
            void 0,
            "touch",
            "pen",
            "mouse"
        ][t1.pointerType] : /touch/.test(t1.type || "") || t1 instanceof h.default.Touch ? "touch" : "mouse";
    }, B.getTouchPair = V, B.getXY = W, B.isNativePointer = Y, B.newCoords = function() {
        return {
            page: {
                x: 0,
                y: 0
            },
            client: {
                x: 0,
                y: 0
            },
            timeStamp: 0
        };
    }, B.pointerAverage = N, Object.defineProperty(B, "pointerExtend", {
        enumerable: !0,
        get: function() {
            return F.default;
        }
    }), B.setCoordDeltas = function(t1, e, n) {
        t1.page.x = n.page.x - e.page.x, t1.page.y = n.page.y - e.page.y, t1.client.x = n.client.x - e.client.x, t1.client.y = n.client.y - e.client.y, t1.timeStamp = n.timeStamp - e.timeStamp;
    }, B.setCoordVelocity = function(t1, e) {
        var n = Math.max(e.timeStamp / 1e3, .001);
        t1.page.x = e.page.x / n, t1.page.y = e.page.y / n, t1.client.x = e.client.x / n, t1.client.y = e.client.y / n, t1.timeStamp = n;
    }, B.setCoords = function(t1, e, n) {
        var r = e.length > 1 ? N(e) : e[0];
        L(r, t1.page), U(r, t1.client), t1.timeStamp = n;
    }, B.setZeroCoords = function(t1) {
        t1.page.x = 0, t1.page.y = 0, t1.client.x = 0, t1.client.y = 0;
    }, B.touchAngle = function(t1, e) {
        var n = e + "X", r = e + "Y", o = V(t1), i = o[1][n] - o[0][n], a = o[1][r] - o[0][r];
        return 180 * Math.atan2(a, i) / Math.PI;
    }, B.touchBBox = function(t1) {
        if (!t1.length) return null;
        var e = V(t1), n = Math.min(e[0].pageX, e[1].pageX), r = Math.min(e[0].pageY, e[1].pageY), o = Math.max(e[0].pageX, e[1].pageX), i = Math.max(e[0].pageY, e[1].pageY);
        return {
            x: n,
            y: r,
            left: n,
            top: r,
            right: o,
            bottom: i,
            width: o - n,
            height: i - r
        };
    }, B.touchDistance = function(t1, e) {
        var n = e + "X", r = e + "Y", o = V(t1), i = o[0][n] - o[1][n], a = o[0][r] - o[1][r];
        return (0, R.default)(i, a);
    };
    var q = {};
    function G(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function $(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(q, "__esModule", {
        value: !0
    }), q.BaseEvent = void 0;
    var H = function() {
        function t1(e) {
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t1), $(this, "immediatePropagationStopped", !1), $(this, "propagationStopped", !1), this._interaction = e;
        }
        var e, n;
        return e = t1, n = [
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            }
        ], G(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t1;
    }();
    q.BaseEvent = H, Object.defineProperty(H.prototype, "interaction", {
        get: function() {
            return this._interaction._proxy;
        },
        set: function() {}
    });
    var K = {};
    Object.defineProperty(K, "__esModule", {
        value: !0
    }), K.remove = K.merge = K.from = K.findIndex = K.find = K.contains = void 0, K.contains = function(t1, e) {
        return -1 !== t1.indexOf(e);
    }, K.remove = function(t1, e) {
        return t1.splice(t1.indexOf(e), 1);
    };
    var Z = function(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            t1.push(r);
        }
        return t1;
    };
    K.merge = Z, K.from = function(t1) {
        return Z([], t1);
    };
    var J = function(t1, e) {
        for(var n = 0; n < t1.length; n++)if (e(t1[n], n, t1)) return n;
        return -1;
    };
    K.findIndex = J, K.find = function(t1, e) {
        return t1[J(t1, e)];
    };
    var Q = {};
    function tt(t1) {
        return tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, tt(t1);
    }
    function et(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function nt(t1, e) {
        return nt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
            return t1.__proto__ = e, t1;
        }, nt(t1, e);
    }
    function rt(t1, e) {
        if (e && ("object" === tt(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return ot(t1);
    }
    function ot(t1) {
        if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t1;
    }
    function it(t1) {
        return it = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
            return t1.__proto__ || Object.getPrototypeOf(t1);
        }, it(t1);
    }
    function at(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(Q, "__esModule", {
        value: !0
    }), Q.DropEvent = void 0;
    var st = function(t1) {
        !function(t1, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t1.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t1,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(t1, "prototype", {
                writable: !1
            }), e && nt(t1, e);
        }(a, t1);
        var e, n, r, o, i = (r = a, o = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (t1) {
                return !1;
            }
        }(), function() {
            var t1, e = it(r);
            if (o) {
                var n = it(this).constructor;
                t1 = Reflect.construct(e, arguments, n);
            } else t1 = e.apply(this, arguments);
            return rt(this, t1);
        });
        function a(t1, e, n) {
            var r;
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, a), at(ot(r = i.call(this, e._interaction)), "dropzone", void 0), at(ot(r), "dragEvent", void 0), at(ot(r), "relatedTarget", void 0), at(ot(r), "draggable", void 0), at(ot(r), "propagationStopped", !1), at(ot(r), "immediatePropagationStopped", !1);
            var o = "dragleave" === n ? t1.prev : t1.cur, s = o.element, l = o.dropzone;
            return r.type = n, r.target = s, r.currentTarget = s, r.dropzone = l, r.dragEvent = e, r.relatedTarget = e.target, r.draggable = e.interactable, r.timeStamp = e.timeStamp, r;
        }
        return e = a, n = [
            {
                key: "reject",
                value: function() {
                    var t1 = this, e = this._interaction.dropState;
                    if ("dropactivate" === this.type || this.dropzone && e.cur.dropzone === this.dropzone && e.cur.element === this.target) {
                        if (e.prev.dropzone = this.dropzone, e.prev.element = this.target, e.rejected = !0, e.events.enter = null, this.stopImmediatePropagation(), "dropactivate" === this.type) {
                            var n = e.activeDrops, r = K.findIndex(n, function(e) {
                                var n = e.dropzone, r = e.element;
                                return n === t1.dropzone && r === t1.target;
                            });
                            e.activeDrops.splice(r, 1);
                            var o = new a(e, this.dragEvent, "dropdeactivate");
                            o.dropzone = this.dropzone, o.target = this.target, this.dropzone.fire(o);
                        } else this.dropzone.fire(new a(e, this.dragEvent, "dragleave"));
                    }
                }
            },
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            }
        ], et(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), a;
    }(q.BaseEvent);
    Q.DropEvent = st;
    var lt = {};
    function ut(t1, e) {
        for(var n = 0; n < t1.slice().length; n++){
            var r = t1.slice()[n], o = r.dropzone, i = r.element;
            e.dropzone = o, e.target = i, o.fire(e), e.propagationStopped = e.immediatePropagationStopped = !1;
        }
    }
    function ct(t1, e) {
        for(var n = function(t1, e) {
            for(var n = t1.interactables, r = [], o = 0; o < n.list.length; o++){
                var a = n.list[o];
                if (a.options.drop.enabled) {
                    var s = a.options.drop.accept;
                    if (!(i.default.element(s) && s !== e || i.default.string(s) && !_.matchesSelector(e, s) || i.default.func(s) && !s({
                        dropzone: a,
                        draggableElement: e
                    }))) for(var l = i.default.string(a.target) ? a._context.querySelectorAll(a.target) : i.default.array(a.target) ? a.target : [
                        a.target
                    ], u = 0; u < l.length; u++){
                        var c = l[u];
                        c !== e && r.push({
                            dropzone: a,
                            element: c,
                            rect: a.getRect(c)
                        });
                    }
                }
            }
            return r;
        }(t1, e), r = 0; r < n.length; r++){
            var o = n[r];
            o.rect = o.dropzone.getRect(o.element);
        }
        return n;
    }
    function ft(t1, e, n) {
        for(var r = t1.dropState, o = t1.interactable, i = t1.element, a = [], s = 0; s < r.activeDrops.length; s++){
            var l = r.activeDrops[s], u = l.dropzone, c = l.element, f = l.rect;
            a.push(u.dropCheck(e, n, o, i, c, f) ? c : null);
        }
        var d = _.indexOfDeepestElement(a);
        return r.activeDrops[d] || null;
    }
    function dt(t1, e, n) {
        var r = t1.dropState, o = {
            enter: null,
            leave: null,
            activate: null,
            deactivate: null,
            move: null,
            drop: null
        };
        return "dragstart" === n.type && (o.activate = new Q.DropEvent(r, n, "dropactivate"), o.activate.target = null, o.activate.dropzone = null), "dragend" === n.type && (o.deactivate = new Q.DropEvent(r, n, "dropdeactivate"), o.deactivate.target = null, o.deactivate.dropzone = null), r.rejected || (r.cur.element !== r.prev.element && (r.prev.dropzone && (o.leave = new Q.DropEvent(r, n, "dragleave"), n.dragLeave = o.leave.target = r.prev.element, n.prevDropzone = o.leave.dropzone = r.prev.dropzone), r.cur.dropzone && (o.enter = new Q.DropEvent(r, n, "dragenter"), n.dragEnter = r.cur.element, n.dropzone = r.cur.dropzone)), "dragend" === n.type && r.cur.dropzone && (o.drop = new Q.DropEvent(r, n, "drop"), n.dropzone = r.cur.dropzone, n.relatedTarget = r.cur.element), "dragmove" === n.type && r.cur.dropzone && (o.move = new Q.DropEvent(r, n, "dropmove"), o.move.dragmove = n, n.dropzone = r.cur.dropzone)), o;
    }
    function pt(t1, e) {
        var n = t1.dropState, r = n.activeDrops, o = n.cur, i = n.prev;
        e.leave && i.dropzone.fire(e.leave), e.enter && o.dropzone.fire(e.enter), e.move && o.dropzone.fire(e.move), e.drop && o.dropzone.fire(e.drop), e.deactivate && ut(r, e.deactivate), n.prev.dropzone = o.dropzone, n.prev.element = o.element;
    }
    function vt(t1, e) {
        var n = t1.interaction, r = t1.iEvent, o = t1.event;
        if ("dragmove" === r.type || "dragend" === r.type) {
            var i = n.dropState;
            e.dynamicDrop && (i.activeDrops = ct(e, n.element));
            var a = r, s = ft(n, a, o);
            i.rejected = i.rejected && !!s && s.dropzone === i.cur.dropzone && s.element === i.cur.element, i.cur.dropzone = s && s.dropzone, i.cur.element = s && s.element, i.events = dt(n, 0, a);
        }
    }
    Object.defineProperty(lt, "__esModule", {
        value: !0
    }), lt.default = void 0;
    var ht = {
        id: "actions/drop",
        install: function(t1) {
            var e = t1.actions, n = t1.interactStatic, r = t1.Interactable, o = t1.defaults;
            t1.usePlugin(c.default), r.prototype.dropzone = function(t1) {
                return function(t1, e) {
                    if (i.default.object(e)) {
                        if (t1.options.drop.enabled = !1 !== e.enabled, e.listeners) {
                            var n = (0, z.default)(e.listeners), r = Object.keys(n).reduce(function(t1, e) {
                                return t1[/^(enter|leave)/.test(e) ? "drag".concat(e) : /^(activate|deactivate|move)/.test(e) ? "drop".concat(e) : e] = n[e], t1;
                            }, {});
                            t1.off(t1.options.drop.listeners), t1.on(r), t1.options.drop.listeners = r;
                        }
                        return i.default.func(e.ondrop) && t1.on("drop", e.ondrop), i.default.func(e.ondropactivate) && t1.on("dropactivate", e.ondropactivate), i.default.func(e.ondropdeactivate) && t1.on("dropdeactivate", e.ondropdeactivate), i.default.func(e.ondragenter) && t1.on("dragenter", e.ondragenter), i.default.func(e.ondragleave) && t1.on("dragleave", e.ondragleave), i.default.func(e.ondropmove) && t1.on("dropmove", e.ondropmove), /^(pointer|center)$/.test(e.overlap) ? t1.options.drop.overlap = e.overlap : i.default.number(e.overlap) && (t1.options.drop.overlap = Math.max(Math.min(1, e.overlap), 0)), "accept" in e && (t1.options.drop.accept = e.accept), "checker" in e && (t1.options.drop.checker = e.checker), t1;
                    }
                    return i.default.bool(e) ? (t1.options.drop.enabled = e, t1) : t1.options.drop;
                }(this, t1);
            }, r.prototype.dropCheck = function(t1, e, n, r, o, a) {
                return function(t1, e, n, r, o, a, s) {
                    var l = !1;
                    if (!(s = s || t1.getRect(a))) return !!t1.options.drop.checker && t1.options.drop.checker(e, n, l, t1, a, r, o);
                    var u = t1.options.drop.overlap;
                    if ("pointer" === u) {
                        var c = (0, A.default)(r, o, "drag"), f = B.getPageXY(e);
                        f.x += c.x, f.y += c.y;
                        var d = f.x > s.left && f.x < s.right, p = f.y > s.top && f.y < s.bottom;
                        l = d && p;
                    }
                    var v = r.getRect(o);
                    if (v && "center" === u) {
                        var h = v.left + v.width / 2, g = v.top + v.height / 2;
                        l = h >= s.left && h <= s.right && g >= s.top && g <= s.bottom;
                    }
                    return v && i.default.number(u) && (l = Math.max(0, Math.min(s.right, v.right) - Math.max(s.left, v.left)) * Math.max(0, Math.min(s.bottom, v.bottom) - Math.max(s.top, v.top)) / (v.width * v.height) >= u), t1.options.drop.checker && (l = t1.options.drop.checker(e, n, l, t1, a, r, o)), l;
                }(this, t1, e, n, r, o, a);
            }, n.dynamicDrop = function(e) {
                return i.default.bool(e) ? (t1.dynamicDrop = e, n) : t1.dynamicDrop;
            }, (0, M.default)(e.phaselessTypes, {
                dragenter: !0,
                dragleave: !0,
                dropactivate: !0,
                dropdeactivate: !0,
                dropmove: !0,
                drop: !0
            }), e.methodDict.drop = "dropzone", t1.dynamicDrop = !1, o.actions.drop = ht.defaults;
        },
        listeners: {
            "interactions:before-action-start": function(t1) {
                var e = t1.interaction;
                "drag" === e.prepared.name && (e.dropState = {
                    cur: {
                        dropzone: null,
                        element: null
                    },
                    prev: {
                        dropzone: null,
                        element: null
                    },
                    rejected: null,
                    events: null,
                    activeDrops: []
                });
            },
            "interactions:after-action-start": function(t1, e) {
                var n = t1.interaction, r = (t1.event, t1.iEvent);
                if ("drag" === n.prepared.name) {
                    var o = n.dropState;
                    o.activeDrops = null, o.events = null, o.activeDrops = ct(e, n.element), o.events = dt(n, 0, r), o.events.activate && (ut(o.activeDrops, o.events.activate), e.fire("actions/drop:start", {
                        interaction: n,
                        dragEvent: r
                    }));
                }
            },
            "interactions:action-move": vt,
            "interactions:after-action-move": function(t1, e) {
                var n = t1.interaction, r = t1.iEvent;
                "drag" === n.prepared.name && (pt(n, n.dropState.events), e.fire("actions/drop:move", {
                    interaction: n,
                    dragEvent: r
                }), n.dropState.events = {});
            },
            "interactions:action-end": function(t1, e) {
                if ("drag" === t1.interaction.prepared.name) {
                    var n = t1.interaction, r = t1.iEvent;
                    vt(t1, e), pt(n, n.dropState.events), e.fire("actions/drop:end", {
                        interaction: n,
                        dragEvent: r
                    });
                }
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction;
                if ("drag" === e.prepared.name) {
                    var n = e.dropState;
                    n && (n.activeDrops = null, n.events = null, n.cur.dropzone = null, n.cur.element = null, n.prev.dropzone = null, n.prev.element = null, n.rejected = !1);
                }
            }
        },
        getActiveDrops: ct,
        getDrop: ft,
        getDropEvents: dt,
        fireDropEvents: pt,
        defaults: {
            enabled: !1,
            accept: null,
            overlap: "pointer"
        }
    }, gt = ht;
    lt.default = gt;
    var yt = {};
    function mt(t1) {
        var e = t1.interaction, n = t1.iEvent, r = t1.phase;
        if ("gesture" === e.prepared.name) {
            var o = e.pointers.map(function(t1) {
                return t1.pointer;
            }), a = "start" === r, s = "end" === r, l = e.interactable.options.deltaSource;
            if (n.touches = [
                o[0],
                o[1]
            ], a) n.distance = B.touchDistance(o, l), n.box = B.touchBBox(o), n.scale = 1, n.ds = 0, n.angle = B.touchAngle(o, l), n.da = 0, e.gesture.startDistance = n.distance, e.gesture.startAngle = n.angle;
            else if (s) {
                var u = e.prevEvent;
                n.distance = u.distance, n.box = u.box, n.scale = u.scale, n.ds = 0, n.angle = u.angle, n.da = 0;
            } else n.distance = B.touchDistance(o, l), n.box = B.touchBBox(o), n.scale = n.distance / e.gesture.startDistance, n.angle = B.touchAngle(o, l), n.ds = n.scale - e.gesture.scale, n.da = n.angle - e.gesture.angle;
            e.gesture.distance = n.distance, e.gesture.angle = n.angle, i.default.number(n.scale) && n.scale !== 1 / 0 && !isNaN(n.scale) && (e.gesture.scale = n.scale);
        }
    }
    Object.defineProperty(yt, "__esModule", {
        value: !0
    }), yt.default = void 0;
    var bt = {
        id: "actions/gesture",
        before: [
            "actions/drag",
            "actions/resize"
        ],
        install: function(t1) {
            var e = t1.actions, n = t1.Interactable, r = t1.defaults;
            n.prototype.gesturable = function(t1) {
                return i.default.object(t1) ? (this.options.gesture.enabled = !1 !== t1.enabled, this.setPerAction("gesture", t1), this.setOnEvents("gesture", t1), this) : i.default.bool(t1) ? (this.options.gesture.enabled = t1, this) : this.options.gesture;
            }, e.map.gesture = bt, e.methodDict.gesture = "gesturable", r.actions.gesture = bt.defaults;
        },
        listeners: {
            "interactions:action-start": mt,
            "interactions:action-move": mt,
            "interactions:action-end": mt,
            "interactions:new": function(t1) {
                t1.interaction.gesture = {
                    angle: 0,
                    distance: 0,
                    scale: 1,
                    startAngle: 0,
                    startDistance: 0
                };
            },
            "auto-start:check": function(t1) {
                if (!(t1.interaction.pointers.length < 2)) {
                    var e = t1.interactable.options.gesture;
                    if (e && e.enabled) return t1.action = {
                        name: "gesture"
                    }, !1;
                }
            }
        },
        defaults: {},
        getCursor: function() {
            return "";
        }
    }, xt = bt;
    yt.default = xt;
    var wt = {};
    function _t(t1, e, n, r, o, a, s) {
        if (!e) return !1;
        if (!0 === e) {
            var l = i.default.number(a.width) ? a.width : a.right - a.left, u = i.default.number(a.height) ? a.height : a.bottom - a.top;
            if (s = Math.min(s, Math.abs(("left" === t1 || "right" === t1 ? l : u) / 2)), l < 0 && ("left" === t1 ? t1 = "right" : "right" === t1 && (t1 = "left")), u < 0 && ("top" === t1 ? t1 = "bottom" : "bottom" === t1 && (t1 = "top")), "left" === t1) {
                var c = l >= 0 ? a.left : a.right;
                return n.x < c + s;
            }
            if ("top" === t1) {
                var f = u >= 0 ? a.top : a.bottom;
                return n.y < f + s;
            }
            if ("right" === t1) return n.x > (l >= 0 ? a.right : a.left) - s;
            if ("bottom" === t1) return n.y > (u >= 0 ? a.bottom : a.top) - s;
        }
        return !!i.default.element(r) && (i.default.element(e) ? e === r : _.matchesUpTo(r, e, o));
    }
    function Pt(t1) {
        var e = t1.iEvent, n = t1.interaction;
        if ("resize" === n.prepared.name && n.resizeAxes) {
            var r = e;
            n.interactable.options.resize.square ? ("y" === n.resizeAxes ? r.delta.x = r.delta.y : r.delta.y = r.delta.x, r.axes = "xy") : (r.axes = n.resizeAxes, "x" === n.resizeAxes ? r.delta.y = 0 : "y" === n.resizeAxes && (r.delta.x = 0));
        }
    }
    Object.defineProperty(wt, "__esModule", {
        value: !0
    }), wt.default = void 0;
    var Ot = {
        id: "actions/resize",
        before: [
            "actions/drag"
        ],
        install: function(t1) {
            var e = t1.actions, n = t1.browser, r = t1.Interactable, o = t1.defaults;
            Ot.cursors = function(t1) {
                return t1.isIe9 ? {
                    x: "e-resize",
                    y: "s-resize",
                    xy: "se-resize",
                    top: "n-resize",
                    left: "w-resize",
                    bottom: "s-resize",
                    right: "e-resize",
                    topleft: "se-resize",
                    bottomright: "se-resize",
                    topright: "ne-resize",
                    bottomleft: "ne-resize"
                } : {
                    x: "ew-resize",
                    y: "ns-resize",
                    xy: "nwse-resize",
                    top: "ns-resize",
                    left: "ew-resize",
                    bottom: "ns-resize",
                    right: "ew-resize",
                    topleft: "nwse-resize",
                    bottomright: "nwse-resize",
                    topright: "nesw-resize",
                    bottomleft: "nesw-resize"
                };
            }(n), Ot.defaultMargin = n.supportsTouch || n.supportsPointerEvent ? 20 : 10, r.prototype.resizable = function(e) {
                return function(t1, e, n) {
                    return i.default.object(e) ? (t1.options.resize.enabled = !1 !== e.enabled, t1.setPerAction("resize", e), t1.setOnEvents("resize", e), i.default.string(e.axis) && /^x$|^y$|^xy$/.test(e.axis) ? t1.options.resize.axis = e.axis : null === e.axis && (t1.options.resize.axis = n.defaults.actions.resize.axis), i.default.bool(e.preserveAspectRatio) ? t1.options.resize.preserveAspectRatio = e.preserveAspectRatio : i.default.bool(e.square) && (t1.options.resize.square = e.square), t1) : i.default.bool(e) ? (t1.options.resize.enabled = e, t1) : t1.options.resize;
                }(this, e, t1);
            }, e.map.resize = Ot, e.methodDict.resize = "resizable", o.actions.resize = Ot.defaults;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.resizeAxes = "xy";
            },
            "interactions:action-start": function(t1) {
                !function(t1) {
                    var e = t1.iEvent, n = t1.interaction;
                    if ("resize" === n.prepared.name && n.prepared.edges) {
                        var r = e, o = n.rect;
                        n._rects = {
                            start: (0, M.default)({}, o),
                            corrected: (0, M.default)({}, o),
                            previous: (0, M.default)({}, o),
                            delta: {
                                left: 0,
                                right: 0,
                                width: 0,
                                top: 0,
                                bottom: 0,
                                height: 0
                            }
                        }, r.edges = n.prepared.edges, r.rect = n._rects.corrected, r.deltaRect = n._rects.delta;
                    }
                }(t1), Pt(t1);
            },
            "interactions:action-move": function(t1) {
                !function(t1) {
                    var e = t1.iEvent, n = t1.interaction;
                    if ("resize" === n.prepared.name && n.prepared.edges) {
                        var r = e, o = n.interactable.options.resize.invert, i = "reposition" === o || "negate" === o, a = n.rect, s = n._rects, l = s.start, u = s.corrected, c = s.delta, f = s.previous;
                        if ((0, M.default)(f, u), i) {
                            if ((0, M.default)(u, a), "reposition" === o) {
                                if (u.top > u.bottom) {
                                    var d = u.top;
                                    u.top = u.bottom, u.bottom = d;
                                }
                                if (u.left > u.right) {
                                    var p = u.left;
                                    u.left = u.right, u.right = p;
                                }
                            }
                        } else u.top = Math.min(a.top, l.bottom), u.bottom = Math.max(a.bottom, l.top), u.left = Math.min(a.left, l.right), u.right = Math.max(a.right, l.left);
                        for(var v in u.width = u.right - u.left, u.height = u.bottom - u.top, u)c[v] = u[v] - f[v];
                        r.edges = n.prepared.edges, r.rect = u, r.deltaRect = c;
                    }
                }(t1), Pt(t1);
            },
            "interactions:action-end": function(t1) {
                var e = t1.iEvent, n = t1.interaction;
                if ("resize" === n.prepared.name && n.prepared.edges) {
                    var r = e;
                    r.edges = n.prepared.edges, r.rect = n._rects.corrected, r.deltaRect = n._rects.delta;
                }
            },
            "auto-start:check": function(t1) {
                var e = t1.interaction, n = t1.interactable, r = t1.element, o = t1.rect, a = t1.buttons;
                if (o) {
                    var s = (0, M.default)({}, e.coords.cur.page), l = n.options.resize;
                    if (l && l.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || 0 != (a & l.mouseButtons))) {
                        if (i.default.object(l.edges)) {
                            var u = {
                                left: !1,
                                right: !1,
                                top: !1,
                                bottom: !1
                            };
                            for(var c in u)u[c] = _t(c, l.edges[c], s, e._latestPointer.eventTarget, r, o, l.margin || Ot.defaultMargin);
                            u.left = u.left && !u.right, u.top = u.top && !u.bottom, (u.left || u.right || u.top || u.bottom) && (t1.action = {
                                name: "resize",
                                edges: u
                            });
                        } else {
                            var f = "y" !== l.axis && s.x > o.right - Ot.defaultMargin, d = "x" !== l.axis && s.y > o.bottom - Ot.defaultMargin;
                            (f || d) && (t1.action = {
                                name: "resize",
                                axes: (f ? "x" : "") + (d ? "y" : "")
                            });
                        }
                        return !t1.action && void 0;
                    }
                }
            }
        },
        defaults: {
            square: !1,
            preserveAspectRatio: !1,
            axis: "xy",
            margin: NaN,
            edges: null,
            invert: "none"
        },
        cursors: null,
        getCursor: function(t1) {
            var e = t1.edges, n = t1.axis, r = t1.name, o = Ot.cursors, i = null;
            if (n) i = o[r + n];
            else if (e) {
                for(var a = "", s = [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ], l = 0; l < s.length; l++){
                    var u = s[l];
                    e[u] && (a += u);
                }
                i = o[a];
            }
            return i;
        },
        defaultMargin: null
    }, Et = Ot;
    wt.default = Et;
    var St = {};
    Object.defineProperty(St, "__esModule", {
        value: !0
    }), St.default = void 0;
    var Tt = {
        id: "actions",
        install: function(t1) {
            t1.usePlugin(yt.default), t1.usePlugin(wt.default), t1.usePlugin(c.default), t1.usePlugin(lt.default);
        }
    };
    St.default = Tt;
    var jt = {};
    Object.defineProperty(jt, "__esModule", {
        value: !0
    }), jt.default = void 0;
    var Mt, kt, It = 0, Dt = {
        request: function(t1) {
            return Mt(t1);
        },
        cancel: function(t1) {
            return kt(t1);
        },
        init: function(t1) {
            if (Mt = t1.requestAnimationFrame, kt = t1.cancelAnimationFrame, !Mt) for(var e = [
                "ms",
                "moz",
                "webkit",
                "o"
            ], n = 0; n < e.length; n++){
                var r = e[n];
                Mt = t1["".concat(r, "RequestAnimationFrame")], kt = t1["".concat(r, "CancelAnimationFrame")] || t1["".concat(r, "CancelRequestAnimationFrame")];
            }
            Mt = Mt && Mt.bind(t1), kt = kt && kt.bind(t1), Mt || (Mt = function(e) {
                var n = Date.now(), r = Math.max(0, 16 - (n - It)), o = t1.setTimeout(function() {
                    e(n + r);
                }, r);
                return It = n + r, o;
            }, kt = function(t1) {
                return clearTimeout(t1);
            });
        }
    };
    jt.default = Dt;
    var At = {};
    Object.defineProperty(At, "__esModule", {
        value: !0
    }), At.default = void 0, At.getContainer = Ct, At.getScroll = Rt, At.getScrollSize = function(t1) {
        return i.default.window(t1) && (t1 = window.document.body), {
            x: t1.scrollWidth,
            y: t1.scrollHeight
        };
    }, At.getScrollSizeDelta = function(t1, e) {
        var n = t1.interaction, r = t1.element, o = n && n.interactable.options[n.prepared.name].autoScroll;
        if (!o || !o.enabled) return e(), {
            x: 0,
            y: 0
        };
        var i = Ct(o.container, n.interactable, r), a = Rt(i);
        e();
        var s = Rt(i);
        return {
            x: s.x - a.x,
            y: s.y - a.y
        };
    };
    var zt = {
        defaults: {
            enabled: !1,
            margin: 60,
            container: null,
            speed: 300
        },
        now: Date.now,
        interaction: null,
        i: 0,
        x: 0,
        y: 0,
        isScrolling: !1,
        prevTime: 0,
        margin: 0,
        speed: 0,
        start: function(t1) {
            zt.isScrolling = !0, jt.default.cancel(zt.i), t1.autoScroll = zt, zt.interaction = t1, zt.prevTime = zt.now(), zt.i = jt.default.request(zt.scroll);
        },
        stop: function() {
            zt.isScrolling = !1, zt.interaction && (zt.interaction.autoScroll = null), jt.default.cancel(zt.i);
        },
        scroll: function() {
            var t1 = zt.interaction, e = t1.interactable, n = t1.element, r = t1.prepared.name, o = e.options[r].autoScroll, a = Ct(o.container, e, n), s = zt.now(), l = (s - zt.prevTime) / 1e3, u = o.speed * l;
            if (u >= 1) {
                var c = {
                    x: zt.x * u,
                    y: zt.y * u
                };
                if (c.x || c.y) {
                    var f = Rt(a);
                    i.default.window(a) ? a.scrollBy(c.x, c.y) : a && (a.scrollLeft += c.x, a.scrollTop += c.y);
                    var d = Rt(a), p = {
                        x: d.x - f.x,
                        y: d.y - f.y
                    };
                    (p.x || p.y) && e.fire({
                        type: "autoscroll",
                        target: n,
                        interactable: e,
                        delta: p,
                        interaction: t1,
                        container: a
                    });
                }
                zt.prevTime = s;
            }
            zt.isScrolling && (jt.default.cancel(zt.i), zt.i = jt.default.request(zt.scroll));
        },
        check: function(t1, e) {
            var n;
            return null == (n = t1.options[e].autoScroll) ? void 0 : n.enabled;
        },
        onInteractionMove: function(t1) {
            var e = t1.interaction, n = t1.pointer;
            if (e.interacting() && zt.check(e.interactable, e.prepared.name)) {
                if (e.simulation) zt.x = zt.y = 0;
                else {
                    var r, o, a, s, l = e.interactable, u = e.element, c = e.prepared.name, f = l.options[c].autoScroll, d = Ct(f.container, l, u);
                    if (i.default.window(d)) s = n.clientX < zt.margin, r = n.clientY < zt.margin, o = n.clientX > d.innerWidth - zt.margin, a = n.clientY > d.innerHeight - zt.margin;
                    else {
                        var p = _.getElementClientRect(d);
                        s = n.clientX < p.left + zt.margin, r = n.clientY < p.top + zt.margin, o = n.clientX > p.right - zt.margin, a = n.clientY > p.bottom - zt.margin;
                    }
                    zt.x = o ? 1 : s ? -1 : 0, zt.y = a ? 1 : r ? -1 : 0, zt.isScrolling || (zt.margin = f.margin, zt.speed = f.speed, zt.start(e));
                }
            }
        }
    };
    function Ct(t1, n, r) {
        return (i.default.string(t1) ? (0, k.getStringOptionResult)(t1, n, r) : t1) || (0, e.getWindow)(r);
    }
    function Rt(t1) {
        return i.default.window(t1) && (t1 = window.document.body), {
            x: t1.scrollLeft,
            y: t1.scrollTop
        };
    }
    var Ft = {
        id: "auto-scroll",
        install: function(t1) {
            var e = t1.defaults, n = t1.actions;
            t1.autoScroll = zt, zt.now = function() {
                return t1.now();
            }, n.phaselessTypes.autoscroll = !0, e.perAction.autoScroll = zt.defaults;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.autoScroll = null;
            },
            "interactions:destroy": function(t1) {
                t1.interaction.autoScroll = null, zt.stop(), zt.interaction && (zt.interaction = null);
            },
            "interactions:stop": zt.stop,
            "interactions:action-move": function(t1) {
                return zt.onInteractionMove(t1);
            }
        }
    }, Xt = Ft;
    At.default = Xt;
    var Bt = {};
    Object.defineProperty(Bt, "__esModule", {
        value: !0
    }), Bt.copyAction = function(t1, e) {
        return t1.name = e.name, t1.axis = e.axis, t1.edges = e.edges, t1;
    }, Bt.sign = void 0, Bt.warnOnce = function(t1, n) {
        var r = !1;
        return function() {
            return r || (e.window.console.warn(n), r = !0), t1.apply(this, arguments);
        };
    }, Bt.sign = function(t1) {
        return t1 >= 0 ? 1 : -1;
    };
    var Yt = {};
    function Wt(t1) {
        return i.default.bool(t1) ? (this.options.styleCursor = t1, this) : null === t1 ? (delete this.options.styleCursor, this) : this.options.styleCursor;
    }
    function Lt(t1) {
        return i.default.func(t1) ? (this.options.actionChecker = t1, this) : null === t1 ? (delete this.options.actionChecker, this) : this.options.actionChecker;
    }
    Object.defineProperty(Yt, "__esModule", {
        value: !0
    }), Yt.default = void 0;
    var Ut = {
        id: "auto-start/interactableMethods",
        install: function(t1) {
            var e = t1.Interactable;
            e.prototype.getAction = function(e, n, r, o) {
                var i = function(t1, e, n, r, o) {
                    var i = t1.getRect(r), a = {
                        action: null,
                        interactable: t1,
                        interaction: n,
                        element: r,
                        rect: i,
                        buttons: e.buttons || ({
                            0: 1,
                            1: 4,
                            3: 8,
                            4: 16
                        })[e.button]
                    };
                    return o.fire("auto-start:check", a), a.action;
                }(this, n, r, o, t1);
                return this.options.actionChecker ? this.options.actionChecker(e, n, i, this, o, r) : i;
            }, e.prototype.ignoreFrom = (0, Bt.warnOnce)(function(t1) {
                return this._backCompatOption("ignoreFrom", t1);
            }, "Interactable.ignoreFrom() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue})."), e.prototype.allowFrom = (0, Bt.warnOnce)(function(t1) {
                return this._backCompatOption("allowFrom", t1);
            }, "Interactable.allowFrom() has been deprecated. Use Interactble.draggable({allowFrom: newValue})."), e.prototype.actionChecker = Lt, e.prototype.styleCursor = Wt;
        }
    };
    Yt.default = Ut;
    var Vt = {};
    function Nt(t1, e, n, r, o) {
        return e.testIgnoreAllow(e.options[t1.name], n, r) && e.options[t1.name].enabled && Ht(e, n, t1, o) ? t1 : null;
    }
    function qt(t1, e, n, r, o, i, a) {
        for(var s = 0, l = r.length; s < l; s++){
            var u = r[s], c = o[s], f = u.getAction(e, n, t1, c);
            if (f) {
                var d = Nt(f, u, c, i, a);
                if (d) return {
                    action: d,
                    interactable: u,
                    element: c
                };
            }
        }
        return {
            action: null,
            interactable: null,
            element: null
        };
    }
    function Gt(t1, e, n, r, o) {
        var a = [], s = [], l = r;
        function u(t1) {
            a.push(t1), s.push(l);
        }
        for(; i.default.element(l);){
            a = [], s = [], o.interactables.forEachMatch(l, u);
            var c = qt(t1, e, n, a, s, r, o);
            if (c.action && !c.interactable.options[c.action.name].manualStart) return c;
            l = _.parentNode(l);
        }
        return {
            action: null,
            interactable: null,
            element: null
        };
    }
    function $t(t1, e, n) {
        var r = e.action, o = e.interactable, i = e.element;
        r = r || {
            name: null
        }, t1.interactable = o, t1.element = i, (0, Bt.copyAction)(t1.prepared, r), t1.rect = o && r.name ? o.getRect(i) : null, Jt(t1, n), n.fire("autoStart:prepared", {
            interaction: t1
        });
    }
    function Ht(t1, e, n, r) {
        var o = t1.options, i = o[n.name].max, a = o[n.name].maxPerElement, s = r.autoStart.maxInteractions, l = 0, u = 0, c = 0;
        if (!(i && a && s)) return !1;
        for(var f = 0; f < r.interactions.list.length; f++){
            var d = r.interactions.list[f], p = d.prepared.name;
            if (d.interacting()) {
                if (++l >= s) return !1;
                if (d.interactable === t1) {
                    if ((u += p === n.name ? 1 : 0) >= i) return !1;
                    if (d.element === e && (c++, p === n.name && c >= a)) return !1;
                }
            }
        }
        return s > 0;
    }
    function Kt(t1, e) {
        return i.default.number(t1) ? (e.autoStart.maxInteractions = t1, this) : e.autoStart.maxInteractions;
    }
    function Zt(t1, e, n) {
        var r = n.autoStart.cursorElement;
        r && r !== t1 && (r.style.cursor = ""), t1.ownerDocument.documentElement.style.cursor = e, t1.style.cursor = e, n.autoStart.cursorElement = e ? t1 : null;
    }
    function Jt(t1, e) {
        var n = t1.interactable, r = t1.element, o = t1.prepared;
        if ("mouse" === t1.pointerType && n && n.options.styleCursor) {
            var a = "";
            if (o.name) {
                var s = n.options[o.name].cursorChecker;
                a = i.default.func(s) ? s(o, n, r, t1._interacting) : e.actions.map[o.name].getCursor(o);
            }
            Zt(t1.element, a || "", e);
        } else e.autoStart.cursorElement && Zt(e.autoStart.cursorElement, "", e);
    }
    Object.defineProperty(Vt, "__esModule", {
        value: !0
    }), Vt.default = void 0;
    var Qt = {
        id: "auto-start/base",
        before: [
            "actions"
        ],
        install: function(t1) {
            var e = t1.interactStatic, n = t1.defaults;
            t1.usePlugin(Yt.default), n.base.actionChecker = null, n.base.styleCursor = !0, (0, M.default)(n.perAction, {
                manualStart: !1,
                max: 1 / 0,
                maxPerElement: 1,
                allowFrom: null,
                ignoreFrom: null,
                mouseButtons: 1
            }), e.maxInteractions = function(e) {
                return Kt(e, t1);
            }, t1.autoStart = {
                maxInteractions: 1 / 0,
                withinInteractionLimit: Ht,
                cursorElement: null
            };
        },
        listeners: {
            "interactions:down": function(t1, e) {
                var n = t1.interaction, r = t1.pointer, o = t1.event, i = t1.eventTarget;
                n.interacting() || $t(n, Gt(n, r, o, i, e), e);
            },
            "interactions:move": function(t1, e) {
                !function(t1, e) {
                    var n = t1.interaction, r = t1.pointer, o = t1.event, i = t1.eventTarget;
                    "mouse" !== n.pointerType || n.pointerIsDown || n.interacting() || $t(n, Gt(n, r, o, i, e), e);
                }(t1, e), function(t1, e) {
                    var n = t1.interaction;
                    if (n.pointerIsDown && !n.interacting() && n.pointerWasMoved && n.prepared.name) {
                        e.fire("autoStart:before-start", t1);
                        var r = n.interactable, o = n.prepared.name;
                        o && r && (r.options[o].manualStart || !Ht(r, n.element, n.prepared, e) ? n.stop() : (n.start(n.prepared, r, n.element), Jt(n, e)));
                    }
                }(t1, e);
            },
            "interactions:stop": function(t1, e) {
                var n = t1.interaction, r = n.interactable;
                r && r.options.styleCursor && Zt(n.element, "", e);
            }
        },
        maxInteractions: Kt,
        withinInteractionLimit: Ht,
        validateAction: Nt
    }, te = Qt;
    Vt.default = te;
    var ee = {};
    Object.defineProperty(ee, "__esModule", {
        value: !0
    }), ee.default = void 0;
    var ne = {
        id: "auto-start/dragAxis",
        listeners: {
            "autoStart:before-start": function(t1, e) {
                var n = t1.interaction, r = t1.eventTarget, o = t1.dx, a = t1.dy;
                if ("drag" === n.prepared.name) {
                    var s = Math.abs(o), l = Math.abs(a), u = n.interactable.options.drag, c = u.startAxis, f = s > l ? "x" : s < l ? "y" : "xy";
                    if (n.prepared.axis = "start" === u.lockAxis ? f[0] : u.lockAxis, "xy" !== f && "xy" !== c && c !== f) {
                        n.prepared.name = null;
                        for(var d = r, p = function(t1) {
                            if (t1 !== n.interactable) {
                                var o = n.interactable.options.drag;
                                if (!o.manualStart && t1.testIgnoreAllow(o, d, r)) {
                                    var i = t1.getAction(n.downPointer, n.downEvent, n, d);
                                    if (i && "drag" === i.name && function(t1, e) {
                                        if (!e) return !1;
                                        var n = e.options.drag.startAxis;
                                        return "xy" === t1 || "xy" === n || n === t1;
                                    }(f, t1) && Vt.default.validateAction(i, t1, d, r, e)) return t1;
                                }
                            }
                        }; i.default.element(d);){
                            var v = e.interactables.forEachMatch(d, p);
                            if (v) {
                                n.prepared.name = "drag", n.interactable = v, n.element = d;
                                break;
                            }
                            d = (0, _.parentNode)(d);
                        }
                    }
                }
            }
        }
    };
    ee.default = ne;
    var re = {};
    function oe(t1) {
        var e = t1.prepared && t1.prepared.name;
        if (!e) return null;
        var n = t1.interactable.options;
        return n[e].hold || n[e].delay;
    }
    Object.defineProperty(re, "__esModule", {
        value: !0
    }), re.default = void 0;
    var ie = {
        id: "auto-start/hold",
        install: function(t1) {
            var e = t1.defaults;
            t1.usePlugin(Vt.default), e.perAction.hold = 0, e.perAction.delay = 0;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.autoStartHoldTimer = null;
            },
            "autoStart:prepared": function(t1) {
                var e = t1.interaction, n = oe(e);
                n > 0 && (e.autoStartHoldTimer = setTimeout(function() {
                    e.start(e.prepared, e.interactable, e.element);
                }, n));
            },
            "interactions:move": function(t1) {
                var e = t1.interaction, n = t1.duplicate;
                e.autoStartHoldTimer && e.pointerWasMoved && !n && (clearTimeout(e.autoStartHoldTimer), e.autoStartHoldTimer = null);
            },
            "autoStart:before-start": function(t1) {
                var e = t1.interaction;
                oe(e) > 0 && (e.prepared.name = null);
            }
        },
        getHoldDuration: oe
    }, ae = ie;
    re.default = ae;
    var se = {};
    Object.defineProperty(se, "__esModule", {
        value: !0
    }), se.default = void 0;
    var le = {
        id: "auto-start",
        install: function(t1) {
            t1.usePlugin(Vt.default), t1.usePlugin(re.default), t1.usePlugin(ee.default);
        }
    };
    se.default = le;
    var ue = {};
    function ce(t1) {
        return /^(always|never|auto)$/.test(t1) ? (this.options.preventDefault = t1, this) : i.default.bool(t1) ? (this.options.preventDefault = t1 ? "always" : "never", this) : this.options.preventDefault;
    }
    function fe(t1) {
        var e = t1.interaction, n = t1.event;
        e.interactable && e.interactable.checkAndPreventDefault(n);
    }
    function de(t1) {
        var n = t1.Interactable;
        n.prototype.preventDefault = ce, n.prototype.checkAndPreventDefault = function(n) {
            return function(t1, n, r) {
                var o = t1.options.preventDefault;
                if ("never" !== o) {
                    if ("always" !== o) {
                        if (n.events.supportsPassive && /^touch(start|move)$/.test(r.type)) {
                            var a = (0, e.getWindow)(r.target).document, s = n.getDocOptions(a);
                            if (!s || !s.events || !1 !== s.events.passive) return;
                        }
                        /^(mouse|pointer|touch)*(down|start)/i.test(r.type) || i.default.element(r.target) && (0, _.matchesSelector)(r.target, "input,select,textarea,[contenteditable=true],[contenteditable=true] *") || r.preventDefault();
                    } else r.preventDefault();
                }
            }(this, t1, n);
        }, t1.interactions.docEvents.push({
            type: "dragstart",
            listener: function(e) {
                for(var n = 0; n < t1.interactions.list.length; n++){
                    var r = t1.interactions.list[n];
                    if (r.element && (r.element === e.target || (0, _.nodeContains)(r.element, e.target))) return void r.interactable.checkAndPreventDefault(e);
                }
            }
        });
    }
    Object.defineProperty(ue, "__esModule", {
        value: !0
    }), ue.default = void 0, ue.install = de;
    var pe = {
        id: "core/interactablePreventDefault",
        install: de,
        listeners: [
            "down",
            "move",
            "up",
            "cancel"
        ].reduce(function(t1, e) {
            return t1["interactions:".concat(e)] = fe, t1;
        }, {})
    };
    ue.default = pe;
    var ve = {};
    Object.defineProperty(ve, "__esModule", {
        value: !0
    }), ve.default = void 0, ve.default = {};
    var he, ge = {};
    Object.defineProperty(ge, "__esModule", {
        value: !0
    }), ge.default = void 0, function(t1) {
        t1.touchAction = "touchAction", t1.boxSizing = "boxSizing", t1.noListeners = "noListeners";
    }(he || (he = {}));
    he.touchAction, he.boxSizing, he.noListeners;
    var ye = {
        id: "dev-tools",
        install: function() {}
    };
    ge.default = ye;
    var me = {};
    Object.defineProperty(me, "__esModule", {
        value: !0
    }), me.default = function t1(e) {
        var n = {};
        for(var r in e){
            var o = e[r];
            i.default.plainObject(o) ? n[r] = t1(o) : i.default.array(o) ? n[r] = K.from(o) : n[r] = o;
        }
        return n;
    };
    var be = {};
    function xe(t1, e) {
        return function(t1) {
            if (Array.isArray(t1)) return t1;
        }(t1) || function(t1, e) {
            var n = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
            if (null != n) {
                var r, o, i = [], a = !0, s = !1;
                try {
                    for(n = n.call(t1); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0);
                } catch (t1) {
                    s = !0, o = t1;
                } finally{
                    try {
                        a || null == n.return || n.return();
                    } finally{
                        if (s) throw o;
                    }
                }
                return i;
            }
        }(t1, e) || function(t1, e) {
            if (t1) {
                if ("string" == typeof t1) return we(t1, e);
                var n = Object.prototype.toString.call(t1).slice(8, -1);
                return "Object" === n && t1.constructor && (n = t1.constructor.name), "Map" === n || "Set" === n ? Array.from(t1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? we(t1, e) : void 0;
            }
        }(t1, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function we(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var n = 0, r = Array(e); n < e; n++)r[n] = t1[n];
        return r;
    }
    function _e(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function Pe(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(be, "__esModule", {
        value: !0
    }), be.default = void 0, be.getRectOffset = Se;
    var Oe = function() {
        function t1(e) {
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t1), Pe(this, "states", []), Pe(this, "startOffset", {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }), Pe(this, "startDelta", void 0), Pe(this, "result", void 0), Pe(this, "endResult", void 0), Pe(this, "startEdges", void 0), Pe(this, "edges", void 0), Pe(this, "interaction", void 0), this.interaction = e, this.result = Ee(), this.edges = {
                left: !1,
                right: !1,
                top: !1,
                bottom: !1
            };
        }
        var e, n;
        return e = t1, n = [
            {
                key: "start",
                value: function(t1, e) {
                    var n = t1.phase, r = this.interaction, o = function(t1) {
                        var e = t1.interactable.options[t1.prepared.name], n = e.modifiers;
                        return n && n.length ? n : [
                            "snap",
                            "snapSize",
                            "snapEdges",
                            "restrict",
                            "restrictEdges",
                            "restrictSize"
                        ].map(function(t1) {
                            var n = e[t1];
                            return n && n.enabled && {
                                options: n,
                                methods: n._methods
                            };
                        }).filter(function(t1) {
                            return !!t1;
                        });
                    }(r);
                    this.prepareStates(o), this.startEdges = (0, M.default)({}, r.edges), this.edges = (0, M.default)({}, this.startEdges), this.startOffset = Se(r.rect, e), this.startDelta = {
                        x: 0,
                        y: 0
                    };
                    var i = this.fillArg({
                        phase: n,
                        pageCoords: e,
                        preEnd: !1
                    });
                    return this.result = Ee(), this.startAll(i), this.result = this.setAll(i);
                }
            },
            {
                key: "fillArg",
                value: function(t1) {
                    var e = this.interaction;
                    return t1.interaction = e, t1.interactable = e.interactable, t1.element = e.element, t1.rect || (t1.rect = e.rect), t1.edges || (t1.edges = this.startEdges), t1.startOffset = this.startOffset, t1;
                }
            },
            {
                key: "startAll",
                value: function(t1) {
                    for(var e = 0; e < this.states.length; e++){
                        var n = this.states[e];
                        n.methods.start && (t1.state = n, n.methods.start(t1));
                    }
                }
            },
            {
                key: "setAll",
                value: function(t1) {
                    var e = t1.phase, n = t1.preEnd, r = t1.skipModifiers, o = t1.rect, i = t1.edges;
                    t1.coords = (0, M.default)({}, t1.pageCoords), t1.rect = (0, M.default)({}, o), t1.edges = (0, M.default)({}, i);
                    for(var a = r ? this.states.slice(r) : this.states, s = Ee(t1.coords, t1.rect), l = 0; l < a.length; l++){
                        var u, c = a[l], f = c.options, d = (0, M.default)({}, t1.coords), p = null;
                        null != (u = c.methods) && u.set && this.shouldDo(f, n, e) && (t1.state = c, p = c.methods.set(t1), k.addEdges(t1.edges, t1.rect, {
                            x: t1.coords.x - d.x,
                            y: t1.coords.y - d.y
                        })), s.eventProps.push(p);
                    }
                    (0, M.default)(this.edges, t1.edges), s.delta.x = t1.coords.x - t1.pageCoords.x, s.delta.y = t1.coords.y - t1.pageCoords.y, s.rectDelta.left = t1.rect.left - o.left, s.rectDelta.right = t1.rect.right - o.right, s.rectDelta.top = t1.rect.top - o.top, s.rectDelta.bottom = t1.rect.bottom - o.bottom;
                    var v = this.result.coords, h = this.result.rect;
                    if (v && h) {
                        var g = s.rect.left !== h.left || s.rect.right !== h.right || s.rect.top !== h.top || s.rect.bottom !== h.bottom;
                        s.changed = g || v.x !== s.coords.x || v.y !== s.coords.y;
                    }
                    return s;
                }
            },
            {
                key: "applyToInteraction",
                value: function(t1) {
                    var e = this.interaction, n = t1.phase, r = e.coords.cur, o = e.coords.start, i = this.result, a = this.startDelta, s = i.delta;
                    "start" === n && (0, M.default)(this.startDelta, i.delta);
                    for(var l = 0; l < 2; l++){
                        var u = xe([
                            [
                                o,
                                a
                            ],
                            [
                                r,
                                s
                            ]
                        ][l], 2), c = u[0], f = u[1];
                        c.page.x += f.x, c.page.y += f.y, c.client.x += f.x, c.client.y += f.y;
                    }
                    var d = this.result.rectDelta, p = t1.rect || e.rect;
                    p.left += d.left, p.right += d.right, p.top += d.top, p.bottom += d.bottom, p.width = p.right - p.left, p.height = p.bottom - p.top;
                }
            },
            {
                key: "setAndApply",
                value: function(t1) {
                    var e = this.interaction, n = t1.phase, r = t1.preEnd, o = t1.skipModifiers, i = this.setAll(this.fillArg({
                        preEnd: r,
                        phase: n,
                        pageCoords: t1.modifiedCoords || e.coords.cur.page
                    }));
                    if (this.result = i, !i.changed && (!o || o < this.states.length) && e.interacting()) return !1;
                    if (t1.modifiedCoords) {
                        var a = e.coords.cur.page, s = {
                            x: t1.modifiedCoords.x - a.x,
                            y: t1.modifiedCoords.y - a.y
                        };
                        i.coords.x += s.x, i.coords.y += s.y, i.delta.x += s.x, i.delta.y += s.y;
                    }
                    this.applyToInteraction(t1);
                }
            },
            {
                key: "beforeEnd",
                value: function(t1) {
                    var e = t1.interaction, n = t1.event, r = this.states;
                    if (r && r.length) {
                        for(var o = !1, i = 0; i < r.length; i++){
                            var a = r[i];
                            t1.state = a;
                            var s = a.options, l = a.methods, u = l.beforeEnd && l.beforeEnd(t1);
                            if (u) return this.endResult = u, !1;
                            o = o || !o && this.shouldDo(s, !0, t1.phase, !0);
                        }
                        o && e.move({
                            event: n,
                            preEnd: !0
                        });
                    }
                }
            },
            {
                key: "stop",
                value: function(t1) {
                    var e = t1.interaction;
                    if (this.states && this.states.length) {
                        var n = (0, M.default)({
                            states: this.states,
                            interactable: e.interactable,
                            element: e.element,
                            rect: null
                        }, t1);
                        this.fillArg(n);
                        for(var r = 0; r < this.states.length; r++){
                            var o = this.states[r];
                            n.state = o, o.methods.stop && o.methods.stop(n);
                        }
                        this.states = null, this.endResult = null;
                    }
                }
            },
            {
                key: "prepareStates",
                value: function(t1) {
                    this.states = [];
                    for(var e = 0; e < t1.length; e++){
                        var n = t1[e], r = n.options, o = n.methods, i = n.name;
                        this.states.push({
                            options: r,
                            methods: o,
                            index: e,
                            name: i
                        });
                    }
                    return this.states;
                }
            },
            {
                key: "restoreInteractionCoords",
                value: function(t1) {
                    var e = t1.interaction, n = e.coords, r = e.rect, o = e.modification;
                    if (o.result) {
                        for(var i = o.startDelta, a = o.result, s = a.delta, l = a.rectDelta, u = [
                            [
                                n.start,
                                i
                            ],
                            [
                                n.cur,
                                s
                            ]
                        ], c = 0; c < u.length; c++){
                            var f = xe(u[c], 2), d = f[0], p = f[1];
                            d.page.x -= p.x, d.page.y -= p.y, d.client.x -= p.x, d.client.y -= p.y;
                        }
                        r.left -= l.left, r.right -= l.right, r.top -= l.top, r.bottom -= l.bottom;
                    }
                }
            },
            {
                key: "shouldDo",
                value: function(t1, e, n, r) {
                    return !(!t1 || !1 === t1.enabled || r && !t1.endOnly || t1.endOnly && !e || "start" === n && !t1.setStart);
                }
            },
            {
                key: "copyFrom",
                value: function(t1) {
                    this.startOffset = t1.startOffset, this.startDelta = t1.startDelta, this.startEdges = t1.startEdges, this.edges = t1.edges, this.states = t1.states.map(function(t1) {
                        return (0, me.default)(t1);
                    }), this.result = Ee((0, M.default)({}, t1.result.coords), (0, M.default)({}, t1.result.rect));
                }
            },
            {
                key: "destroy",
                value: function() {
                    for(var t1 in this)this[t1] = null;
                }
            }
        ], _e(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t1;
    }();
    function Ee(t1, e) {
        return {
            rect: e,
            coords: t1,
            delta: {
                x: 0,
                y: 0
            },
            rectDelta: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            },
            eventProps: [],
            changed: !0
        };
    }
    function Se(t1, e) {
        return t1 ? {
            left: e.x - t1.left,
            top: e.y - t1.top,
            right: t1.right - e.x,
            bottom: t1.bottom - e.y
        } : {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
    }
    be.default = Oe;
    var Te = {};
    function je(t1) {
        var e = t1.iEvent, n = t1.interaction.modification.result;
        n && (e.modifiers = n.eventProps);
    }
    Object.defineProperty(Te, "__esModule", {
        value: !0
    }), Te.addEventModifiers = je, Te.default = void 0, Te.makeModifier = function(t1, e) {
        var n = t1.defaults, r = {
            start: t1.start,
            set: t1.set,
            beforeEnd: t1.beforeEnd,
            stop: t1.stop
        }, o = function(t1) {
            var o = t1 || {};
            for(var i in o.enabled = !1 !== o.enabled, n)i in o || (o[i] = n[i]);
            var a = {
                options: o,
                methods: r,
                name: e,
                enable: function() {
                    return o.enabled = !0, a;
                },
                disable: function() {
                    return o.enabled = !1, a;
                }
            };
            return a;
        };
        return e && "string" == typeof e && (o._defaults = n, o._methods = r), o;
    };
    var Me = {
        id: "modifiers/base",
        before: [
            "actions"
        ],
        install: function(t1) {
            t1.defaults.perAction.modifiers = [];
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.modification = new be.default(e);
            },
            "interactions:before-action-start": function(t1) {
                var e = t1.interaction, n = t1.interaction.modification;
                n.start(t1, e.coords.start.page), e.edges = n.edges, n.applyToInteraction(t1);
            },
            "interactions:before-action-move": function(t1) {
                var e = t1.interaction, n = e.modification, r = n.setAndApply(t1);
                return e.edges = n.edges, r;
            },
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction, n = e.modification, r = n.beforeEnd(t1);
                return e.edges = n.startEdges, r;
            },
            "interactions:action-start": je,
            "interactions:action-move": je,
            "interactions:action-end": je,
            "interactions:after-action-start": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:after-action-move": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:stop": function(t1) {
                return t1.interaction.modification.stop(t1);
            }
        }
    }, ke = Me;
    Te.default = ke;
    var Ie = {};
    Object.defineProperty(Ie, "__esModule", {
        value: !0
    }), Ie.defaults = void 0, Ie.defaults = {
        base: {
            preventDefault: "auto",
            deltaSource: "page"
        },
        perAction: {
            enabled: !1,
            origin: {
                x: 0,
                y: 0
            }
        },
        actions: {}
    };
    var De = {};
    function Ae(t1) {
        return Ae = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, Ae(t1);
    }
    function ze(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function Ce(t1, e) {
        return Ce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
            return t1.__proto__ = e, t1;
        }, Ce(t1, e);
    }
    function Re(t1, e) {
        if (e && ("object" === Ae(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return Fe(t1);
    }
    function Fe(t1) {
        if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t1;
    }
    function Xe(t1) {
        return Xe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
            return t1.__proto__ || Object.getPrototypeOf(t1);
        }, Xe(t1);
    }
    function Be(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(De, "__esModule", {
        value: !0
    }), De.InteractEvent = void 0;
    var Ye = function(t1) {
        !function(t1, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t1.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t1,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(t1, "prototype", {
                writable: !1
            }), e && Ce(t1, e);
        }(a, t1);
        var e, n, r, o, i = (r = a, o = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (t1) {
                return !1;
            }
        }(), function() {
            var t1, e = Xe(r);
            if (o) {
                var n = Xe(this).constructor;
                t1 = Reflect.construct(e, arguments, n);
            } else t1 = e.apply(this, arguments);
            return Re(this, t1);
        });
        function a(t1, e, n, r, o, s, l) {
            var u;
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, a), Be(Fe(u = i.call(this, t1)), "relatedTarget", null), Be(Fe(u), "screenX", void 0), Be(Fe(u), "screenY", void 0), Be(Fe(u), "button", void 0), Be(Fe(u), "buttons", void 0), Be(Fe(u), "ctrlKey", void 0), Be(Fe(u), "shiftKey", void 0), Be(Fe(u), "altKey", void 0), Be(Fe(u), "metaKey", void 0), Be(Fe(u), "page", void 0), Be(Fe(u), "client", void 0), Be(Fe(u), "delta", void 0), Be(Fe(u), "rect", void 0), Be(Fe(u), "x0", void 0), Be(Fe(u), "y0", void 0), Be(Fe(u), "t0", void 0), Be(Fe(u), "dt", void 0), Be(Fe(u), "duration", void 0), Be(Fe(u), "clientX0", void 0), Be(Fe(u), "clientY0", void 0), Be(Fe(u), "velocity", void 0), Be(Fe(u), "speed", void 0), Be(Fe(u), "swipe", void 0), Be(Fe(u), "axes", void 0), Be(Fe(u), "preEnd", void 0), o = o || t1.element;
            var c = t1.interactable, f = (c && c.options || Ie.defaults).deltaSource, d = (0, A.default)(c, o, n), p = "start" === r, v = "end" === r, h = p ? Fe(u) : t1.prevEvent, g = p ? t1.coords.start : v ? {
                page: h.page,
                client: h.client,
                timeStamp: t1.coords.cur.timeStamp
            } : t1.coords.cur;
            return u.page = (0, M.default)({}, g.page), u.client = (0, M.default)({}, g.client), u.rect = (0, M.default)({}, t1.rect), u.timeStamp = g.timeStamp, v || (u.page.x -= d.x, u.page.y -= d.y, u.client.x -= d.x, u.client.y -= d.y), u.ctrlKey = e.ctrlKey, u.altKey = e.altKey, u.shiftKey = e.shiftKey, u.metaKey = e.metaKey, u.button = e.button, u.buttons = e.buttons, u.target = o, u.currentTarget = o, u.preEnd = s, u.type = l || n + (r || ""), u.interactable = c, u.t0 = p ? t1.pointers[t1.pointers.length - 1].downTime : h.t0, u.x0 = t1.coords.start.page.x - d.x, u.y0 = t1.coords.start.page.y - d.y, u.clientX0 = t1.coords.start.client.x - d.x, u.clientY0 = t1.coords.start.client.y - d.y, u.delta = p || v ? {
                x: 0,
                y: 0
            } : {
                x: u[f].x - h[f].x,
                y: u[f].y - h[f].y
            }, u.dt = t1.coords.delta.timeStamp, u.duration = u.timeStamp - u.t0, u.velocity = (0, M.default)({}, t1.coords.velocity[f]), u.speed = (0, R.default)(u.velocity.x, u.velocity.y), u.swipe = v || "inertiastart" === r ? u.getSwipe() : null, u;
        }
        return e = a, n = [
            {
                key: "getSwipe",
                value: function() {
                    var t1 = this._interaction;
                    if (t1.prevEvent.speed < 600 || this.timeStamp - t1.prevEvent.timeStamp > 150) return null;
                    var e = 180 * Math.atan2(t1.prevEvent.velocityY, t1.prevEvent.velocityX) / Math.PI;
                    e < 0 && (e += 360);
                    var n = 112.5 <= e && e < 247.5, r = 202.5 <= e && e < 337.5;
                    return {
                        up: r,
                        down: !r && 22.5 <= e && e < 157.5,
                        left: n,
                        right: !n && (292.5 <= e || e < 67.5),
                        angle: e,
                        speed: t1.prevEvent.speed,
                        velocity: {
                            x: t1.prevEvent.velocityX,
                            y: t1.prevEvent.velocityY
                        }
                    };
                }
            },
            {
                key: "preventDefault",
                value: function() {}
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.immediatePropagationStopped = this.propagationStopped = !0;
                }
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.propagationStopped = !0;
                }
            }
        ], ze(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), a;
    }(q.BaseEvent);
    De.InteractEvent = Ye, Object.defineProperties(Ye.prototype, {
        pageX: {
            get: function() {
                return this.page.x;
            },
            set: function(t1) {
                this.page.x = t1;
            }
        },
        pageY: {
            get: function() {
                return this.page.y;
            },
            set: function(t1) {
                this.page.y = t1;
            }
        },
        clientX: {
            get: function() {
                return this.client.x;
            },
            set: function(t1) {
                this.client.x = t1;
            }
        },
        clientY: {
            get: function() {
                return this.client.y;
            },
            set: function(t1) {
                this.client.y = t1;
            }
        },
        dx: {
            get: function() {
                return this.delta.x;
            },
            set: function(t1) {
                this.delta.x = t1;
            }
        },
        dy: {
            get: function() {
                return this.delta.y;
            },
            set: function(t1) {
                this.delta.y = t1;
            }
        },
        velocityX: {
            get: function() {
                return this.velocity.x;
            },
            set: function(t1) {
                this.velocity.x = t1;
            }
        },
        velocityY: {
            get: function() {
                return this.velocity.y;
            },
            set: function(t1) {
                this.velocity.y = t1;
            }
        }
    });
    var We = {};
    function Le(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function Ue(t1, e, n) {
        return e && Le(t1.prototype, e), n && Le(t1, n), Object.defineProperty(t1, "prototype", {
            writable: !1
        }), t1;
    }
    function Ve(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(We, "__esModule", {
        value: !0
    }), We.PointerInfo = void 0;
    var Ne = Ue(function t1(e, n, r, o, i) {
        !function(t1, e) {
            if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t1), Ve(this, "id", void 0), Ve(this, "pointer", void 0), Ve(this, "event", void 0), Ve(this, "downTime", void 0), Ve(this, "downTarget", void 0), this.id = e, this.pointer = n, this.event = r, this.downTime = o, this.downTarget = i;
    });
    We.PointerInfo = Ne;
    var qe, Ge, $e = {};
    function He(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function Ke(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty($e, "__esModule", {
        value: !0
    }), $e.Interaction = void 0, Object.defineProperty($e, "PointerInfo", {
        enumerable: !0,
        get: function() {
            return We.PointerInfo;
        }
    }), $e.default = $e._ProxyValues = $e._ProxyMethods = void 0, $e._ProxyValues = qe, function(t1) {
        t1.interactable = "", t1.element = "", t1.prepared = "", t1.pointerIsDown = "", t1.pointerWasMoved = "", t1._proxy = "";
    }(qe || ($e._ProxyValues = qe = {})), $e._ProxyMethods = Ge, function(t1) {
        t1.start = "", t1.move = "", t1.end = "", t1.stop = "", t1.interacting = "";
    }(Ge || ($e._ProxyMethods = Ge = {}));
    var Ze = 0, Je = function() {
        function t1(e) {
            var n = this, r = e.pointerType, o = e.scopeFire;
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t1), Ke(this, "interactable", null), Ke(this, "element", null), Ke(this, "rect", null), Ke(this, "_rects", void 0), Ke(this, "edges", null), Ke(this, "_scopeFire", void 0), Ke(this, "prepared", {
                name: null,
                axis: null,
                edges: null
            }), Ke(this, "pointerType", void 0), Ke(this, "pointers", []), Ke(this, "downEvent", null), Ke(this, "downPointer", {}), Ke(this, "_latestPointer", {
                pointer: null,
                event: null,
                eventTarget: null
            }), Ke(this, "prevEvent", null), Ke(this, "pointerIsDown", !1), Ke(this, "pointerWasMoved", !1), Ke(this, "_interacting", !1), Ke(this, "_ending", !1), Ke(this, "_stopped", !0), Ke(this, "_proxy", null), Ke(this, "simulation", null), Ke(this, "doMove", (0, Bt.warnOnce)(function(t1) {
                this.move(t1);
            }, "The interaction.doMove() method has been renamed to interaction.move()")), Ke(this, "coords", {
                start: B.newCoords(),
                prev: B.newCoords(),
                cur: B.newCoords(),
                delta: B.newCoords(),
                velocity: B.newCoords()
            }), Ke(this, "_id", Ze++), this._scopeFire = o, this.pointerType = r;
            var i = this;
            this._proxy = {};
            var a = function(t1) {
                Object.defineProperty(n._proxy, t1, {
                    get: function() {
                        return i[t1];
                    }
                });
            };
            for(var s in qe)a(s);
            var l = function(t1) {
                Object.defineProperty(n._proxy, t1, {
                    value: function() {
                        return i[t1].apply(i, arguments);
                    }
                });
            };
            for(var u in Ge)l(u);
            this._scopeFire("interactions:new", {
                interaction: this
            });
        }
        var e, n;
        return e = t1, n = [
            {
                key: "pointerMoveTolerance",
                get: function() {
                    return 1;
                }
            },
            {
                key: "pointerDown",
                value: function(t1, e, n) {
                    var r = this.updatePointer(t1, e, n, !0), o = this.pointers[r];
                    this._scopeFire("interactions:down", {
                        pointer: t1,
                        event: e,
                        eventTarget: n,
                        pointerIndex: r,
                        pointerInfo: o,
                        type: "down",
                        interaction: this
                    });
                }
            },
            {
                key: "start",
                value: function(t1, e, n) {
                    return !(this.interacting() || !this.pointerIsDown || this.pointers.length < ("gesture" === t1.name ? 2 : 1) || !e.options[t1.name].enabled) && ((0, Bt.copyAction)(this.prepared, t1), this.interactable = e, this.element = n, this.rect = e.getRect(n), this.edges = this.prepared.edges ? (0, M.default)({}, this.prepared.edges) : {
                        left: !0,
                        right: !0,
                        top: !0,
                        bottom: !0
                    }, this._stopped = !1, this._interacting = this._doPhase({
                        interaction: this,
                        event: this.downEvent,
                        phase: "start"
                    }) && !this._stopped, this._interacting);
                }
            },
            {
                key: "pointerMove",
                value: function(t1, e, n) {
                    this.simulation || this.modification && this.modification.endResult || this.updatePointer(t1, e, n, !1);
                    var r, o, i = this.coords.cur.page.x === this.coords.prev.page.x && this.coords.cur.page.y === this.coords.prev.page.y && this.coords.cur.client.x === this.coords.prev.client.x && this.coords.cur.client.y === this.coords.prev.client.y;
                    this.pointerIsDown && !this.pointerWasMoved && (r = this.coords.cur.client.x - this.coords.start.client.x, o = this.coords.cur.client.y - this.coords.start.client.y, this.pointerWasMoved = (0, R.default)(r, o) > this.pointerMoveTolerance);
                    var a = this.getPointerIndex(t1), s = {
                        pointer: t1,
                        pointerIndex: a,
                        pointerInfo: this.pointers[a],
                        event: e,
                        type: "move",
                        eventTarget: n,
                        dx: r,
                        dy: o,
                        duplicate: i,
                        interaction: this
                    };
                    i || B.setCoordVelocity(this.coords.velocity, this.coords.delta), this._scopeFire("interactions:move", s), i || this.simulation || (this.interacting() && (s.type = null, this.move(s)), this.pointerWasMoved && B.copyCoords(this.coords.prev, this.coords.cur));
                }
            },
            {
                key: "move",
                value: function(t1) {
                    t1 && t1.event || B.setZeroCoords(this.coords.delta), (t1 = (0, M.default)({
                        pointer: this._latestPointer.pointer,
                        event: this._latestPointer.event,
                        eventTarget: this._latestPointer.eventTarget,
                        interaction: this
                    }, t1 || {})).phase = "move", this._doPhase(t1);
                }
            },
            {
                key: "pointerUp",
                value: function(t1, e, n, r) {
                    var o = this.getPointerIndex(t1);
                    -1 === o && (o = this.updatePointer(t1, e, n, !1));
                    var i = /cancel$/i.test(e.type) ? "cancel" : "up";
                    this._scopeFire("interactions:".concat(i), {
                        pointer: t1,
                        pointerIndex: o,
                        pointerInfo: this.pointers[o],
                        event: e,
                        eventTarget: n,
                        type: i,
                        curEventTarget: r,
                        interaction: this
                    }), this.simulation || this.end(e), this.removePointer(t1, e);
                }
            },
            {
                key: "documentBlur",
                value: function(t1) {
                    this.end(t1), this._scopeFire("interactions:blur", {
                        event: t1,
                        type: "blur",
                        interaction: this
                    });
                }
            },
            {
                key: "end",
                value: function(t1) {
                    var e;
                    this._ending = !0, t1 = t1 || this._latestPointer.event, this.interacting() && (e = this._doPhase({
                        event: t1,
                        interaction: this,
                        phase: "end"
                    })), this._ending = !1, !0 === e && this.stop();
                }
            },
            {
                key: "currentAction",
                value: function() {
                    return this._interacting ? this.prepared.name : null;
                }
            },
            {
                key: "interacting",
                value: function() {
                    return this._interacting;
                }
            },
            {
                key: "stop",
                value: function() {
                    this._scopeFire("interactions:stop", {
                        interaction: this
                    }), this.interactable = this.element = null, this._interacting = !1, this._stopped = !0, this.prepared.name = this.prevEvent = null;
                }
            },
            {
                key: "getPointerIndex",
                value: function(t1) {
                    var e = B.getPointerId(t1);
                    return "mouse" === this.pointerType || "pen" === this.pointerType ? this.pointers.length - 1 : K.findIndex(this.pointers, function(t1) {
                        return t1.id === e;
                    });
                }
            },
            {
                key: "getPointerInfo",
                value: function(t1) {
                    return this.pointers[this.getPointerIndex(t1)];
                }
            },
            {
                key: "updatePointer",
                value: function(t1, e, n, r) {
                    var o = B.getPointerId(t1), i = this.getPointerIndex(t1), a = this.pointers[i];
                    return r = !1 !== r && (r || /(down|start)$/i.test(e.type)), a ? a.pointer = t1 : (a = new We.PointerInfo(o, t1, e, null, null), i = this.pointers.length, this.pointers.push(a)), B.setCoords(this.coords.cur, this.pointers.map(function(t1) {
                        return t1.pointer;
                    }), this._now()), B.setCoordDeltas(this.coords.delta, this.coords.prev, this.coords.cur), r && (this.pointerIsDown = !0, a.downTime = this.coords.cur.timeStamp, a.downTarget = n, B.pointerExtend(this.downPointer, t1), this.interacting() || (B.copyCoords(this.coords.start, this.coords.cur), B.copyCoords(this.coords.prev, this.coords.cur), this.downEvent = e, this.pointerWasMoved = !1)), this._updateLatestPointer(t1, e, n), this._scopeFire("interactions:update-pointer", {
                        pointer: t1,
                        event: e,
                        eventTarget: n,
                        down: r,
                        pointerInfo: a,
                        pointerIndex: i,
                        interaction: this
                    }), i;
                }
            },
            {
                key: "removePointer",
                value: function(t1, e) {
                    var n = this.getPointerIndex(t1);
                    if (-1 !== n) {
                        var r = this.pointers[n];
                        this._scopeFire("interactions:remove-pointer", {
                            pointer: t1,
                            event: e,
                            eventTarget: null,
                            pointerIndex: n,
                            pointerInfo: r,
                            interaction: this
                        }), this.pointers.splice(n, 1), this.pointerIsDown = !1;
                    }
                }
            },
            {
                key: "_updateLatestPointer",
                value: function(t1, e, n) {
                    this._latestPointer.pointer = t1, this._latestPointer.event = e, this._latestPointer.eventTarget = n;
                }
            },
            {
                key: "destroy",
                value: function() {
                    this._latestPointer.pointer = null, this._latestPointer.event = null, this._latestPointer.eventTarget = null;
                }
            },
            {
                key: "_createPreparedEvent",
                value: function(t1, e, n, r) {
                    return new De.InteractEvent(this, t1, this.prepared.name, e, this.element, n, r);
                }
            },
            {
                key: "_fireEvent",
                value: function(t1) {
                    var e;
                    null == (e = this.interactable) || e.fire(t1), (!this.prevEvent || t1.timeStamp >= this.prevEvent.timeStamp) && (this.prevEvent = t1);
                }
            },
            {
                key: "_doPhase",
                value: function(t1) {
                    var e = t1.event, n = t1.phase, r = t1.preEnd, o = t1.type, i = this.rect;
                    if (i && "move" === n && (k.addEdges(this.edges, i, this.coords.delta[this.interactable.options.deltaSource]), i.width = i.right - i.left, i.height = i.bottom - i.top), !1 === this._scopeFire("interactions:before-action-".concat(n), t1)) return !1;
                    var a = t1.iEvent = this._createPreparedEvent(e, n, r, o);
                    return this._scopeFire("interactions:action-".concat(n), t1), "start" === n && (this.prevEvent = a), this._fireEvent(a), this._scopeFire("interactions:after-action-".concat(n), t1), !0;
                }
            },
            {
                key: "_now",
                value: function() {
                    return Date.now();
                }
            }
        ], n && He(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t1;
    }();
    $e.Interaction = Je;
    var Qe = Je;
    $e.default = Qe;
    var tn = {};
    function en(t1) {
        t1.pointerIsDown && (an(t1.coords.cur, t1.offset.total), t1.offset.pending.x = 0, t1.offset.pending.y = 0);
    }
    function nn(t1) {
        rn(t1.interaction);
    }
    function rn(t1) {
        if (!function(t1) {
            return !(!t1.offset.pending.x && !t1.offset.pending.y);
        }(t1)) return !1;
        var e = t1.offset.pending;
        return an(t1.coords.cur, e), an(t1.coords.delta, e), k.addEdges(t1.edges, t1.rect, e), e.x = 0, e.y = 0, !0;
    }
    function on(t1) {
        var e = t1.x, n = t1.y;
        this.offset.pending.x += e, this.offset.pending.y += n, this.offset.total.x += e, this.offset.total.y += n;
    }
    function an(t1, e) {
        var n = t1.page, r = t1.client, o = e.x, i = e.y;
        n.x += o, n.y += i, r.x += o, r.y += i;
    }
    Object.defineProperty(tn, "__esModule", {
        value: !0
    }), tn.addTotal = en, tn.applyPending = rn, tn.default = void 0, $e._ProxyMethods.offsetBy = "";
    var sn = {
        id: "offset",
        before: [
            "modifiers",
            "pointer-events",
            "actions",
            "inertia"
        ],
        install: function(t1) {
            t1.Interaction.prototype.offsetBy = on;
        },
        listeners: {
            "interactions:new": function(t1) {
                t1.interaction.offset = {
                    total: {
                        x: 0,
                        y: 0
                    },
                    pending: {
                        x: 0,
                        y: 0
                    }
                };
            },
            "interactions:update-pointer": function(t1) {
                return en(t1.interaction);
            },
            "interactions:before-action-start": nn,
            "interactions:before-action-move": nn,
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction;
                if (rn(e)) return e.move({
                    offset: !0
                }), e.end(), !1;
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction;
                e.offset.total.x = 0, e.offset.total.y = 0, e.offset.pending.x = 0, e.offset.pending.y = 0;
            }
        }
    }, ln = sn;
    tn.default = ln;
    var un = {};
    function cn(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function fn(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(un, "__esModule", {
        value: !0
    }), un.default = un.InertiaState = void 0;
    var dn = function() {
        function t1(e) {
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t1), fn(this, "active", !1), fn(this, "isModified", !1), fn(this, "smoothEnd", !1), fn(this, "allowResume", !1), fn(this, "modification", void 0), fn(this, "modifierCount", 0), fn(this, "modifierArg", void 0), fn(this, "startCoords", void 0), fn(this, "t0", 0), fn(this, "v0", 0), fn(this, "te", 0), fn(this, "targetOffset", void 0), fn(this, "modifiedOffset", void 0), fn(this, "currentOffset", void 0), fn(this, "lambda_v0", 0), fn(this, "one_ve_v0", 0), fn(this, "timeout", void 0), fn(this, "interaction", void 0), this.interaction = e;
        }
        var e, n;
        return e = t1, n = [
            {
                key: "start",
                value: function(t1) {
                    var e = this.interaction, n = pn(e);
                    if (!n || !n.enabled) return !1;
                    var r = e.coords.velocity.client, o = (0, R.default)(r.x, r.y), i = this.modification || (this.modification = new be.default(e));
                    if (i.copyFrom(e.modification), this.t0 = e._now(), this.allowResume = n.allowResume, this.v0 = o, this.currentOffset = {
                        x: 0,
                        y: 0
                    }, this.startCoords = e.coords.cur.page, this.modifierArg = i.fillArg({
                        pageCoords: this.startCoords,
                        preEnd: !0,
                        phase: "inertiastart"
                    }), this.t0 - e.coords.cur.timeStamp < 50 && o > n.minSpeed && o > n.endSpeed) this.startInertia();
                    else {
                        if (i.result = i.setAll(this.modifierArg), !i.result.changed) return !1;
                        this.startSmoothEnd();
                    }
                    return e.modification.result.rect = null, e.offsetBy(this.targetOffset), e._doPhase({
                        interaction: e,
                        event: t1,
                        phase: "inertiastart"
                    }), e.offsetBy({
                        x: -this.targetOffset.x,
                        y: -this.targetOffset.y
                    }), e.modification.result.rect = null, this.active = !0, e.simulation = this, !0;
                }
            },
            {
                key: "startInertia",
                value: function() {
                    var t1 = this, e = this.interaction.coords.velocity.client, n = pn(this.interaction), r = n.resistance, o = -Math.log(n.endSpeed / this.v0) / r;
                    this.targetOffset = {
                        x: (e.x - o) / r,
                        y: (e.y - o) / r
                    }, this.te = o, this.lambda_v0 = r / this.v0, this.one_ve_v0 = 1 - n.endSpeed / this.v0;
                    var i = this.modification, a = this.modifierArg;
                    a.pageCoords = {
                        x: this.startCoords.x + this.targetOffset.x,
                        y: this.startCoords.y + this.targetOffset.y
                    }, i.result = i.setAll(a), i.result.changed && (this.isModified = !0, this.modifiedOffset = {
                        x: this.targetOffset.x + i.result.delta.x,
                        y: this.targetOffset.y + i.result.delta.y
                    }), this.onNextFrame(function() {
                        return t1.inertiaTick();
                    });
                }
            },
            {
                key: "startSmoothEnd",
                value: function() {
                    var t1 = this;
                    this.smoothEnd = !0, this.isModified = !0, this.targetOffset = {
                        x: this.modification.result.delta.x,
                        y: this.modification.result.delta.y
                    }, this.onNextFrame(function() {
                        return t1.smoothEndTick();
                    });
                }
            },
            {
                key: "onNextFrame",
                value: function(t1) {
                    var e = this;
                    this.timeout = jt.default.request(function() {
                        e.active && t1();
                    });
                }
            },
            {
                key: "inertiaTick",
                value: function() {
                    var t1, e, n, r, o, i = this, a = this.interaction, s = pn(a).resistance, l = (a._now() - this.t0) / 1e3;
                    if (l < this.te) {
                        var u, c = 1 - (Math.exp(-s * l) - this.lambda_v0) / this.one_ve_v0;
                        this.isModified ? (t1 = this.targetOffset.x, e = this.targetOffset.y, n = this.modifiedOffset.x, r = this.modifiedOffset.y, u = {
                            x: hn(o = c, 0, t1, n),
                            y: hn(o, 0, e, r)
                        }) : u = {
                            x: this.targetOffset.x * c,
                            y: this.targetOffset.y * c
                        };
                        var f = {
                            x: u.x - this.currentOffset.x,
                            y: u.y - this.currentOffset.y
                        };
                        this.currentOffset.x += f.x, this.currentOffset.y += f.y, a.offsetBy(f), a.move(), this.onNextFrame(function() {
                            return i.inertiaTick();
                        });
                    } else a.offsetBy({
                        x: this.modifiedOffset.x - this.currentOffset.x,
                        y: this.modifiedOffset.y - this.currentOffset.y
                    }), this.end();
                }
            },
            {
                key: "smoothEndTick",
                value: function() {
                    var t1 = this, e = this.interaction, n = e._now() - this.t0, r = pn(e).smoothEndDuration;
                    if (n < r) {
                        var o = {
                            x: gn(n, 0, this.targetOffset.x, r),
                            y: gn(n, 0, this.targetOffset.y, r)
                        }, i = {
                            x: o.x - this.currentOffset.x,
                            y: o.y - this.currentOffset.y
                        };
                        this.currentOffset.x += i.x, this.currentOffset.y += i.y, e.offsetBy(i), e.move({
                            skipModifiers: this.modifierCount
                        }), this.onNextFrame(function() {
                            return t1.smoothEndTick();
                        });
                    } else e.offsetBy({
                        x: this.targetOffset.x - this.currentOffset.x,
                        y: this.targetOffset.y - this.currentOffset.y
                    }), this.end();
                }
            },
            {
                key: "resume",
                value: function(t1) {
                    var e = t1.pointer, n = t1.event, r = t1.eventTarget, o = this.interaction;
                    o.offsetBy({
                        x: -this.currentOffset.x,
                        y: -this.currentOffset.y
                    }), o.updatePointer(e, n, r, !0), o._doPhase({
                        interaction: o,
                        event: n,
                        phase: "resume"
                    }), (0, B.copyCoords)(o.coords.prev, o.coords.cur), this.stop();
                }
            },
            {
                key: "end",
                value: function() {
                    this.interaction.move(), this.interaction.end(), this.stop();
                }
            },
            {
                key: "stop",
                value: function() {
                    this.active = this.smoothEnd = !1, this.interaction.simulation = null, jt.default.cancel(this.timeout);
                }
            }
        ], cn(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t1;
    }();
    function pn(t1) {
        var e = t1.interactable, n = t1.prepared;
        return e && e.options && n.name && e.options[n.name].inertia;
    }
    un.InertiaState = dn;
    var vn = {
        id: "inertia",
        before: [
            "modifiers",
            "actions"
        ],
        install: function(t1) {
            var e = t1.defaults;
            t1.usePlugin(tn.default), t1.usePlugin(Te.default), t1.actions.phases.inertiastart = !0, t1.actions.phases.resume = !0, e.perAction.inertia = {
                enabled: !1,
                resistance: 10,
                minSpeed: 100,
                endSpeed: 10,
                allowResume: !0,
                smoothEndDuration: 300
            };
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.inertia = new dn(e);
            },
            "interactions:before-action-end": function(t1) {
                var e = t1.interaction, n = t1.event;
                return (!e._interacting || e.simulation || !e.inertia.start(n)) && null;
            },
            "interactions:down": function(t1) {
                var e = t1.interaction, n = t1.eventTarget, r = e.inertia;
                if (r.active) for(var o = n; i.default.element(o);){
                    if (o === e.element) {
                        r.resume(t1);
                        break;
                    }
                    o = _.parentNode(o);
                }
            },
            "interactions:stop": function(t1) {
                var e = t1.interaction.inertia;
                e.active && e.stop();
            },
            "interactions:before-action-resume": function(t1) {
                var e = t1.interaction.modification;
                e.stop(t1), e.start(t1, t1.interaction.coords.cur.page), e.applyToInteraction(t1);
            },
            "interactions:before-action-inertiastart": function(t1) {
                return t1.interaction.modification.setAndApply(t1);
            },
            "interactions:action-resume": Te.addEventModifiers,
            "interactions:action-inertiastart": Te.addEventModifiers,
            "interactions:after-action-inertiastart": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            },
            "interactions:after-action-resume": function(t1) {
                return t1.interaction.modification.restoreInteractionCoords(t1);
            }
        }
    };
    function hn(t1, e, n, r) {
        var o = 1 - t1;
        return o * o * e + 2 * o * t1 * n + t1 * t1 * r;
    }
    function gn(t1, e, n, r) {
        return -n * (t1 /= r) * (t1 - 2) + e;
    }
    var yn = vn;
    un.default = yn;
    var mn = {};
    function bn(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function xn(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    function wn(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            if (t1.immediatePropagationStopped) break;
            r(t1);
        }
    }
    Object.defineProperty(mn, "__esModule", {
        value: !0
    }), mn.Eventable = void 0;
    var _n = function() {
        function t1(e) {
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t1), xn(this, "options", void 0), xn(this, "types", {}), xn(this, "propagationStopped", !1), xn(this, "immediatePropagationStopped", !1), xn(this, "global", void 0), this.options = (0, M.default)({}, e || {});
        }
        var e, n;
        return e = t1, n = [
            {
                key: "fire",
                value: function(t1) {
                    var e, n = this.global;
                    (e = this.types[t1.type]) && wn(t1, e), !t1.propagationStopped && n && (e = n[t1.type]) && wn(t1, e);
                }
            },
            {
                key: "on",
                value: function(t1, e) {
                    var n = (0, z.default)(t1, e);
                    for(t1 in n)this.types[t1] = K.merge(this.types[t1] || [], n[t1]);
                }
            },
            {
                key: "off",
                value: function(t1, e) {
                    var n = (0, z.default)(t1, e);
                    for(t1 in n){
                        var r = this.types[t1];
                        if (r && r.length) for(var o = 0; o < n[t1].length; o++){
                            var i = n[t1][o], a = r.indexOf(i);
                            -1 !== a && r.splice(a, 1);
                        }
                    }
                }
            },
            {
                key: "getRect",
                value: function(t1) {
                    return null;
                }
            }
        ], bn(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t1;
    }();
    mn.Eventable = _n;
    var Pn = {};
    Object.defineProperty(Pn, "__esModule", {
        value: !0
    }), Pn.default = function(t1, e) {
        if (e.phaselessTypes[t1]) return !0;
        for(var n in e.map)if (0 === t1.indexOf(n) && t1.substr(n.length) in e.phases) return !0;
        return !1;
    };
    var On = {};
    Object.defineProperty(On, "__esModule", {
        value: !0
    }), On.createInteractStatic = function(t1) {
        var e = function e(n, r) {
            var o = t1.interactables.get(n, r);
            return o || ((o = t1.interactables.new(n, r)).events.global = e.globalEvents), o;
        };
        return e.getPointerAverage = B.pointerAverage, e.getTouchBBox = B.touchBBox, e.getTouchDistance = B.touchDistance, e.getTouchAngle = B.touchAngle, e.getElementRect = _.getElementRect, e.getElementClientRect = _.getElementClientRect, e.matchesSelector = _.matchesSelector, e.closest = _.closest, e.globalEvents = {}, e.version = "1.10.19", e.scope = t1, e.use = function(t1, e) {
            return this.scope.usePlugin(t1, e), this;
        }, e.isSet = function(t1, e) {
            return !!this.scope.interactables.get(t1, e && e.context);
        }, e.on = (0, Bt.warnOnce)(function(t1, e, n) {
            if (i.default.string(t1) && -1 !== t1.search(" ") && (t1 = t1.trim().split(/ +/)), i.default.array(t1)) {
                for(var r = 0; r < t1.length; r++){
                    var o = t1[r];
                    this.on(o, e, n);
                }
                return this;
            }
            if (i.default.object(t1)) {
                for(var a in t1)this.on(a, t1[a], e);
                return this;
            }
            return (0, Pn.default)(t1, this.scope.actions) ? this.globalEvents[t1] ? this.globalEvents[t1].push(e) : this.globalEvents[t1] = [
                e
            ] : this.scope.events.add(this.scope.document, t1, e, {
                options: n
            }), this;
        }, "The interact.on() method is being deprecated"), e.off = (0, Bt.warnOnce)(function(t1, e, n) {
            if (i.default.string(t1) && -1 !== t1.search(" ") && (t1 = t1.trim().split(/ +/)), i.default.array(t1)) {
                for(var r = 0; r < t1.length; r++){
                    var o = t1[r];
                    this.off(o, e, n);
                }
                return this;
            }
            if (i.default.object(t1)) {
                for(var a in t1)this.off(a, t1[a], e);
                return this;
            }
            var s;
            return (0, Pn.default)(t1, this.scope.actions) ? t1 in this.globalEvents && -1 !== (s = this.globalEvents[t1].indexOf(e)) && this.globalEvents[t1].splice(s, 1) : this.scope.events.remove(this.scope.document, t1, e, n), this;
        }, "The interact.off() method is being deprecated"), e.debug = function() {
            return this.scope;
        }, e.supportsTouch = function() {
            return b.default.supportsTouch;
        }, e.supportsPointerEvent = function() {
            return b.default.supportsPointerEvent;
        }, e.stop = function() {
            for(var t1 = 0; t1 < this.scope.interactions.list.length; t1++)this.scope.interactions.list[t1].stop();
            return this;
        }, e.pointerMoveTolerance = function(t1) {
            return i.default.number(t1) ? (this.scope.interactions.pointerMoveTolerance = t1, this) : this.scope.interactions.pointerMoveTolerance;
        }, e.addDocument = function(t1, e) {
            this.scope.addDocument(t1, e);
        }, e.removeDocument = function(t1) {
            this.scope.removeDocument(t1);
        }, e;
    };
    var En = {};
    function Sn(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function Tn(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(En, "__esModule", {
        value: !0
    }), En.Interactable = void 0;
    var jn = function() {
        function t1(n, r, o, i) {
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t1), Tn(this, "options", void 0), Tn(this, "_actions", void 0), Tn(this, "target", void 0), Tn(this, "events", new mn.Eventable), Tn(this, "_context", void 0), Tn(this, "_win", void 0), Tn(this, "_doc", void 0), Tn(this, "_scopeEvents", void 0), Tn(this, "_rectChecker", void 0), this._actions = r.actions, this.target = n, this._context = r.context || o, this._win = (0, e.getWindow)((0, _.trySelector)(n) ? this._context : n), this._doc = this._win.document, this._scopeEvents = i, this.set(r);
        }
        var n, r;
        return n = t1, r = [
            {
                key: "_defaults",
                get: function() {
                    return {
                        base: {},
                        perAction: {},
                        actions: {}
                    };
                }
            },
            {
                key: "setOnEvents",
                value: function(t1, e) {
                    return i.default.func(e.onstart) && this.on("".concat(t1, "start"), e.onstart), i.default.func(e.onmove) && this.on("".concat(t1, "move"), e.onmove), i.default.func(e.onend) && this.on("".concat(t1, "end"), e.onend), i.default.func(e.oninertiastart) && this.on("".concat(t1, "inertiastart"), e.oninertiastart), this;
                }
            },
            {
                key: "updatePerActionListeners",
                value: function(t1, e, n) {
                    (i.default.array(e) || i.default.object(e)) && this.off(t1, e), (i.default.array(n) || i.default.object(n)) && this.on(t1, n);
                }
            },
            {
                key: "setPerAction",
                value: function(t1, e) {
                    var n = this._defaults;
                    for(var r in e){
                        var o = r, a = this.options[t1], s = e[o];
                        "listeners" === o && this.updatePerActionListeners(t1, a.listeners, s), i.default.array(s) ? a[o] = K.from(s) : i.default.plainObject(s) ? (a[o] = (0, M.default)(a[o] || {}, (0, me.default)(s)), i.default.object(n.perAction[o]) && "enabled" in n.perAction[o] && (a[o].enabled = !1 !== s.enabled)) : i.default.bool(s) && i.default.object(n.perAction[o]) ? a[o].enabled = s : a[o] = s;
                    }
                }
            },
            {
                key: "getRect",
                value: function(t1) {
                    return t1 = t1 || (i.default.element(this.target) ? this.target : null), i.default.string(this.target) && (t1 = t1 || this._context.querySelector(this.target)), (0, _.getElementRect)(t1);
                }
            },
            {
                key: "rectChecker",
                value: function(t1) {
                    var e = this;
                    return i.default.func(t1) ? (this._rectChecker = t1, this.getRect = function(t1) {
                        var n = (0, M.default)({}, e._rectChecker(t1));
                        return "width" in n || (n.width = n.right - n.left, n.height = n.bottom - n.top), n;
                    }, this) : null === t1 ? (delete this.getRect, delete this._rectChecker, this) : this.getRect;
                }
            },
            {
                key: "_backCompatOption",
                value: function(t1, e) {
                    if ((0, _.trySelector)(e) || i.default.object(e)) {
                        for(var n in this.options[t1] = e, this._actions.map)this.options[n][t1] = e;
                        return this;
                    }
                    return this.options[t1];
                }
            },
            {
                key: "origin",
                value: function(t1) {
                    return this._backCompatOption("origin", t1);
                }
            },
            {
                key: "deltaSource",
                value: function(t1) {
                    return "page" === t1 || "client" === t1 ? (this.options.deltaSource = t1, this) : this.options.deltaSource;
                }
            },
            {
                key: "context",
                value: function() {
                    return this._context;
                }
            },
            {
                key: "inContext",
                value: function(t1) {
                    return this._context === t1.ownerDocument || (0, _.nodeContains)(this._context, t1);
                }
            },
            {
                key: "testIgnoreAllow",
                value: function(t1, e, n) {
                    return !this.testIgnore(t1.ignoreFrom, e, n) && this.testAllow(t1.allowFrom, e, n);
                }
            },
            {
                key: "testAllow",
                value: function(t1, e, n) {
                    return !t1 || !!i.default.element(n) && (i.default.string(t1) ? (0, _.matchesUpTo)(n, t1, e) : !!i.default.element(t1) && (0, _.nodeContains)(t1, n));
                }
            },
            {
                key: "testIgnore",
                value: function(t1, e, n) {
                    return !(!t1 || !i.default.element(n)) && (i.default.string(t1) ? (0, _.matchesUpTo)(n, t1, e) : !!i.default.element(t1) && (0, _.nodeContains)(t1, n));
                }
            },
            {
                key: "fire",
                value: function(t1) {
                    return this.events.fire(t1), this;
                }
            },
            {
                key: "_onOff",
                value: function(t1, e, n, r) {
                    i.default.object(e) && !i.default.array(e) && (r = n, n = null);
                    var o = "on" === t1 ? "add" : "remove", a = (0, z.default)(e, n);
                    for(var s in a){
                        "wheel" === s && (s = b.default.wheelEvent);
                        for(var l = 0; l < a[s].length; l++){
                            var u = a[s][l];
                            (0, Pn.default)(s, this._actions) ? this.events[t1](s, u) : i.default.string(this.target) ? this._scopeEvents["".concat(o, "Delegate")](this.target, this._context, s, u, r) : this._scopeEvents[o](this.target, s, u, r);
                        }
                    }
                    return this;
                }
            },
            {
                key: "on",
                value: function(t1, e, n) {
                    return this._onOff("on", t1, e, n);
                }
            },
            {
                key: "off",
                value: function(t1, e, n) {
                    return this._onOff("off", t1, e, n);
                }
            },
            {
                key: "set",
                value: function(t1) {
                    var e = this._defaults;
                    for(var n in i.default.object(t1) || (t1 = {}), this.options = (0, me.default)(e.base), this._actions.methodDict){
                        var r = n, o = this._actions.methodDict[r];
                        this.options[r] = {}, this.setPerAction(r, (0, M.default)((0, M.default)({}, e.perAction), e.actions[r])), this[o](t1[r]);
                    }
                    for(var a in t1)i.default.func(this[a]) && this[a](t1[a]);
                    return this;
                }
            },
            {
                key: "unset",
                value: function() {
                    if (i.default.string(this.target)) for(var t1 in this._scopeEvents.delegatedEvents)for(var e = this._scopeEvents.delegatedEvents[t1], n = e.length - 1; n >= 0; n--){
                        var r = e[n], o = r.selector, a = r.context, s = r.listeners;
                        o === this.target && a === this._context && e.splice(n, 1);
                        for(var l = s.length - 1; l >= 0; l--)this._scopeEvents.removeDelegate(this.target, this._context, t1, s[l][0], s[l][1]);
                    }
                    else this._scopeEvents.remove(this.target, "all");
                }
            }
        ], Sn(n.prototype, r), Object.defineProperty(n, "prototype", {
            writable: !1
        }), t1;
    }();
    En.Interactable = jn;
    var Mn = {};
    function kn(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function In(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(Mn, "__esModule", {
        value: !0
    }), Mn.InteractableSet = void 0;
    var Dn = function() {
        function t1(e) {
            var n = this;
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t1), In(this, "list", []), In(this, "selectorMap", {}), In(this, "scope", void 0), this.scope = e, e.addListeners({
                "interactable:unset": function(t1) {
                    var e = t1.interactable, r = e.target, o = e._context, a = i.default.string(r) ? n.selectorMap[r] : r[n.scope.id], s = K.findIndex(a, function(t1) {
                        return t1.context === o;
                    });
                    a[s] && (a[s].context = null, a[s].interactable = null), a.splice(s, 1);
                }
            });
        }
        var e, n;
        return e = t1, n = [
            {
                key: "new",
                value: function(t1, e) {
                    e = (0, M.default)(e || {}, {
                        actions: this.scope.actions
                    });
                    var n = new this.scope.Interactable(t1, e, this.scope.document, this.scope.events), r = {
                        context: n._context,
                        interactable: n
                    };
                    return this.scope.addDocument(n._doc), this.list.push(n), i.default.string(t1) ? (this.selectorMap[t1] || (this.selectorMap[t1] = []), this.selectorMap[t1].push(r)) : (n.target[this.scope.id] || Object.defineProperty(t1, this.scope.id, {
                        value: [],
                        configurable: !0
                    }), t1[this.scope.id].push(r)), this.scope.fire("interactable:new", {
                        target: t1,
                        options: e,
                        interactable: n,
                        win: this.scope._win
                    }), n;
                }
            },
            {
                key: "get",
                value: function(t1, e) {
                    var n = e && e.context || this.scope.document, r = i.default.string(t1), o = r ? this.selectorMap[t1] : t1[this.scope.id];
                    if (!o) return null;
                    var a = K.find(o, function(e) {
                        return e.context === n && (r || e.interactable.inContext(t1));
                    });
                    return a && a.interactable;
                }
            },
            {
                key: "forEachMatch",
                value: function(t1, e) {
                    for(var n = 0; n < this.list.length; n++){
                        var r = this.list[n], o = void 0;
                        if ((i.default.string(r.target) ? i.default.element(t1) && _.matchesSelector(t1, r.target) : t1 === r.target) && r.inContext(t1) && (o = e(r)), void 0 !== o) return o;
                    }
                }
            }
        ], kn(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t1;
    }();
    Mn.InteractableSet = Dn;
    var An = {};
    function zn(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function Cn(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    function Rn(t1, e) {
        return function(t1) {
            if (Array.isArray(t1)) return t1;
        }(t1) || function(t1, e) {
            var n = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
            if (null != n) {
                var r, o, i = [], a = !0, s = !1;
                try {
                    for(n = n.call(t1); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0);
                } catch (t1) {
                    s = !0, o = t1;
                } finally{
                    try {
                        a || null == n.return || n.return();
                    } finally{
                        if (s) throw o;
                    }
                }
                return i;
            }
        }(t1, e) || function(t1, e) {
            if (t1) {
                if ("string" == typeof t1) return Fn(t1, e);
                var n = Object.prototype.toString.call(t1).slice(8, -1);
                return "Object" === n && t1.constructor && (n = t1.constructor.name), "Map" === n || "Set" === n ? Array.from(t1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Fn(t1, e) : void 0;
            }
        }(t1, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Fn(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var n = 0, r = Array(e); n < e; n++)r[n] = t1[n];
        return r;
    }
    Object.defineProperty(An, "__esModule", {
        value: !0
    }), An.default = void 0;
    var Xn = function() {
        function t1(e) {
            !function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t1), Cn(this, "currentTarget", void 0), Cn(this, "originalEvent", void 0), Cn(this, "type", void 0), this.originalEvent = e, (0, F.default)(this, e);
        }
        var e, n;
        return e = t1, n = [
            {
                key: "preventOriginalDefault",
                value: function() {
                    this.originalEvent.preventDefault();
                }
            },
            {
                key: "stopPropagation",
                value: function() {
                    this.originalEvent.stopPropagation();
                }
            },
            {
                key: "stopImmediatePropagation",
                value: function() {
                    this.originalEvent.stopImmediatePropagation();
                }
            }
        ], zn(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t1;
    }();
    function Bn(t1) {
        if (!i.default.object(t1)) return {
            capture: !!t1,
            passive: !1
        };
        var e = (0, M.default)({}, t1);
        return e.capture = !!t1.capture, e.passive = !!t1.passive, e;
    }
    var Yn = {
        id: "events",
        install: function(t1) {
            var e, n = [], r = {}, o = [], a = {
                add: s,
                remove: l,
                addDelegate: function(t1, e, n, i, a) {
                    var l = Bn(a);
                    if (!r[n]) {
                        r[n] = [];
                        for(var f = 0; f < o.length; f++){
                            var d = o[f];
                            s(d, n, u), s(d, n, c, !0);
                        }
                    }
                    var p = r[n], v = K.find(p, function(n) {
                        return n.selector === t1 && n.context === e;
                    });
                    v || (v = {
                        selector: t1,
                        context: e,
                        listeners: []
                    }, p.push(v)), v.listeners.push([
                        i,
                        l
                    ]);
                },
                removeDelegate: function(t1, e, n, o, i) {
                    var a, s = Bn(i), f = r[n], d = !1;
                    if (f) for(a = f.length - 1; a >= 0; a--){
                        var p = f[a];
                        if (p.selector === t1 && p.context === e) {
                            for(var v = p.listeners, h = v.length - 1; h >= 0; h--){
                                var g = Rn(v[h], 2), y = g[0], m = g[1], b = m.capture, x = m.passive;
                                if (y === o && b === s.capture && x === s.passive) {
                                    v.splice(h, 1), v.length || (f.splice(a, 1), l(e, n, u), l(e, n, c, !0)), d = !0;
                                    break;
                                }
                            }
                            if (d) break;
                        }
                    }
                },
                delegateListener: u,
                delegateUseCapture: c,
                delegatedEvents: r,
                documents: o,
                targets: n,
                supportsOptions: !1,
                supportsPassive: !1
            };
            function s(t1, e, r, o) {
                var i = Bn(o), s = K.find(n, function(e) {
                    return e.eventTarget === t1;
                });
                s || (s = {
                    eventTarget: t1,
                    events: {}
                }, n.push(s)), s.events[e] || (s.events[e] = []), t1.addEventListener && !K.contains(s.events[e], r) && (t1.addEventListener(e, r, a.supportsOptions ? i : i.capture), s.events[e].push(r));
            }
            function l(t1, e, r, o) {
                var i = Bn(o), s = K.findIndex(n, function(e) {
                    return e.eventTarget === t1;
                }), u = n[s];
                if (u && u.events) {
                    if ("all" !== e) {
                        var c = !1, f = u.events[e];
                        if (f) {
                            if ("all" === r) {
                                for(var d = f.length - 1; d >= 0; d--)l(t1, e, f[d], i);
                                return;
                            }
                            for(var p = 0; p < f.length; p++)if (f[p] === r) {
                                t1.removeEventListener(e, r, a.supportsOptions ? i : i.capture), f.splice(p, 1), 0 === f.length && (delete u.events[e], c = !0);
                                break;
                            }
                        }
                        c && !Object.keys(u.events).length && n.splice(s, 1);
                    } else for(e in u.events)u.events.hasOwnProperty(e) && l(t1, e, "all");
                }
            }
            function u(t1, e) {
                for(var n = Bn(e), o = new Xn(t1), a = r[t1.type], s = Rn(B.getEventTargets(t1), 1)[0], l = s; i.default.element(l);){
                    for(var u = 0; u < a.length; u++){
                        var c = a[u], f = c.selector, d = c.context;
                        if (_.matchesSelector(l, f) && _.nodeContains(d, s) && _.nodeContains(d, l)) {
                            var p = c.listeners;
                            o.currentTarget = l;
                            for(var v = 0; v < p.length; v++){
                                var h = Rn(p[v], 2), g = h[0], y = h[1], m = y.capture, b = y.passive;
                                m === n.capture && b === n.passive && g(o);
                            }
                        }
                    }
                    l = _.parentNode(l);
                }
            }
            function c(t1) {
                return u(t1, !0);
            }
            return null == (e = t1.document) || e.createElement("div").addEventListener("test", null, {
                get capture () {
                    return a.supportsOptions = !0;
                },
                get passive () {
                    return a.supportsPassive = !0;
                }
            }), t1.events = a, a;
        }
    };
    An.default = Yn;
    var Wn = {};
    Object.defineProperty(Wn, "__esModule", {
        value: !0
    }), Wn.default = void 0;
    var Ln = {
        methodOrder: [
            "simulationResume",
            "mouseOrPen",
            "hasPointer",
            "idle"
        ],
        search: function(t1) {
            for(var e = 0; e < Ln.methodOrder.length; e++){
                var n;
                n = Ln.methodOrder[e];
                var r = Ln[n](t1);
                if (r) return r;
            }
            return null;
        },
        simulationResume: function(t1) {
            var e = t1.pointerType, n = t1.eventType, r = t1.eventTarget, o = t1.scope;
            if (!/down|start/i.test(n)) return null;
            for(var i = 0; i < o.interactions.list.length; i++){
                var a = o.interactions.list[i], s = r;
                if (a.simulation && a.simulation.allowResume && a.pointerType === e) for(; s;){
                    if (s === a.element) return a;
                    s = _.parentNode(s);
                }
            }
            return null;
        },
        mouseOrPen: function(t1) {
            var e, n = t1.pointerId, r = t1.pointerType, o = t1.eventType, i = t1.scope;
            if ("mouse" !== r && "pen" !== r) return null;
            for(var a = 0; a < i.interactions.list.length; a++){
                var s = i.interactions.list[a];
                if (s.pointerType === r) {
                    if (s.simulation && !Un(s, n)) continue;
                    if (s.interacting()) return s;
                    e || (e = s);
                }
            }
            if (e) return e;
            for(var l = 0; l < i.interactions.list.length; l++){
                var u = i.interactions.list[l];
                if (!(u.pointerType !== r || /down/i.test(o) && u.simulation)) return u;
            }
            return null;
        },
        hasPointer: function(t1) {
            for(var e = t1.pointerId, n = t1.scope, r = 0; r < n.interactions.list.length; r++){
                var o = n.interactions.list[r];
                if (Un(o, e)) return o;
            }
            return null;
        },
        idle: function(t1) {
            for(var e = t1.pointerType, n = t1.scope, r = 0; r < n.interactions.list.length; r++){
                var o = n.interactions.list[r];
                if (1 === o.pointers.length) {
                    var i = o.interactable;
                    if (i && (!i.options.gesture || !i.options.gesture.enabled)) continue;
                } else if (o.pointers.length >= 2) continue;
                if (!o.interacting() && e === o.pointerType) return o;
            }
            return null;
        }
    };
    function Un(t1, e) {
        return t1.pointers.some(function(t1) {
            return t1.id === e;
        });
    }
    var Vn = Ln;
    Wn.default = Vn;
    var Nn = {};
    function qn(t1) {
        return qn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, qn(t1);
    }
    function Gn(t1, e) {
        return function(t1) {
            if (Array.isArray(t1)) return t1;
        }(t1) || function(t1, e) {
            var n = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
            if (null != n) {
                var r, o, i = [], a = !0, s = !1;
                try {
                    for(n = n.call(t1); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0);
                } catch (t1) {
                    s = !0, o = t1;
                } finally{
                    try {
                        a || null == n.return || n.return();
                    } finally{
                        if (s) throw o;
                    }
                }
                return i;
            }
        }(t1, e) || function(t1, e) {
            if (t1) {
                if ("string" == typeof t1) return $n(t1, e);
                var n = Object.prototype.toString.call(t1).slice(8, -1);
                return "Object" === n && t1.constructor && (n = t1.constructor.name), "Map" === n || "Set" === n ? Array.from(t1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $n(t1, e) : void 0;
            }
        }(t1, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function $n(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var n = 0, r = Array(e); n < e; n++)r[n] = t1[n];
        return r;
    }
    function Hn(t1, e) {
        if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function Kn(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function Zn(t1, e) {
        return Zn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
            return t1.__proto__ = e, t1;
        }, Zn(t1, e);
    }
    function Jn(t1, e) {
        if (e && ("object" === qn(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function(t1) {
            if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t1;
        }(t1);
    }
    function Qn(t1) {
        return Qn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
            return t1.__proto__ || Object.getPrototypeOf(t1);
        }, Qn(t1);
    }
    Object.defineProperty(Nn, "__esModule", {
        value: !0
    }), Nn.default = void 0;
    var tr = [
        "pointerDown",
        "pointerMove",
        "pointerUp",
        "updatePointer",
        "removePointer",
        "windowBlur"
    ];
    function er(t1, e) {
        return function(n) {
            var r = e.interactions.list, o = B.getPointerType(n), i = Gn(B.getEventTargets(n), 2), a = i[0], s = i[1], l = [];
            if (/^touch/.test(n.type)) {
                e.prevTouchTime = e.now();
                for(var u = 0; u < n.changedTouches.length; u++){
                    var c = n.changedTouches[u], f = {
                        pointer: c,
                        pointerId: B.getPointerId(c),
                        pointerType: o,
                        eventType: n.type,
                        eventTarget: a,
                        curEventTarget: s,
                        scope: e
                    }, d = nr(f);
                    l.push([
                        f.pointer,
                        f.eventTarget,
                        f.curEventTarget,
                        d
                    ]);
                }
            } else {
                var p = !1;
                if (!b.default.supportsPointerEvent && /mouse/.test(n.type)) {
                    for(var v = 0; v < r.length && !p; v++)p = "mouse" !== r[v].pointerType && r[v].pointerIsDown;
                    p = p || e.now() - e.prevTouchTime < 500 || 0 === n.timeStamp;
                }
                if (!p) {
                    var h = {
                        pointer: n,
                        pointerId: B.getPointerId(n),
                        pointerType: o,
                        eventType: n.type,
                        curEventTarget: s,
                        eventTarget: a,
                        scope: e
                    }, g = nr(h);
                    l.push([
                        h.pointer,
                        h.eventTarget,
                        h.curEventTarget,
                        g
                    ]);
                }
            }
            for(var y = 0; y < l.length; y++){
                var m = Gn(l[y], 4), x = m[0], w = m[1], _ = m[2];
                m[3][t1](x, n, w, _);
            }
        };
    }
    function nr(t1) {
        var e = t1.pointerType, n = t1.scope, r = {
            interaction: Wn.default.search(t1),
            searchDetails: t1
        };
        return n.fire("interactions:find", r), r.interaction || n.interactions.new({
            pointerType: e
        });
    }
    function rr(t1, e) {
        var n = t1.doc, r = t1.scope, o = t1.options, i = r.interactions.docEvents, a = r.events, s = a[e];
        for(var l in r.browser.isIOS && !o.events && (o.events = {
            passive: !1
        }), a.delegatedEvents)s(n, l, a.delegateListener), s(n, l, a.delegateUseCapture, !0);
        for(var u = o && o.events, c = 0; c < i.length; c++){
            var f = i[c];
            s(n, f.type, f.listener, u);
        }
    }
    var or = {
        id: "core/interactions",
        install: function(t1) {
            for(var e = {}, n = 0; n < tr.length; n++){
                var r = tr[n];
                e[r] = er(r, t1);
            }
            var o, i = b.default.pEventTypes;
            function a() {
                for(var e = 0; e < t1.interactions.list.length; e++){
                    var n = t1.interactions.list[e];
                    if (n.pointerIsDown && "touch" === n.pointerType && !n._interacting) for(var r = function() {
                        var e = n.pointers[o];
                        t1.documents.some(function(t1) {
                            var n = t1.doc;
                            return (0, _.nodeContains)(n, e.downTarget);
                        }) || n.removePointer(e.pointer, e.event);
                    }, o = 0; o < n.pointers.length; o++)r();
                }
            }
            (o = h.default.PointerEvent ? [
                {
                    type: i.down,
                    listener: a
                },
                {
                    type: i.down,
                    listener: e.pointerDown
                },
                {
                    type: i.move,
                    listener: e.pointerMove
                },
                {
                    type: i.up,
                    listener: e.pointerUp
                },
                {
                    type: i.cancel,
                    listener: e.pointerUp
                }
            ] : [
                {
                    type: "mousedown",
                    listener: e.pointerDown
                },
                {
                    type: "mousemove",
                    listener: e.pointerMove
                },
                {
                    type: "mouseup",
                    listener: e.pointerUp
                },
                {
                    type: "touchstart",
                    listener: a
                },
                {
                    type: "touchstart",
                    listener: e.pointerDown
                },
                {
                    type: "touchmove",
                    listener: e.pointerMove
                },
                {
                    type: "touchend",
                    listener: e.pointerUp
                },
                {
                    type: "touchcancel",
                    listener: e.pointerUp
                }
            ]).push({
                type: "blur",
                listener: function(e) {
                    for(var n = 0; n < t1.interactions.list.length; n++)t1.interactions.list[n].documentBlur(e);
                }
            }), t1.prevTouchTime = 0, t1.Interaction = function(e) {
                !function(t1, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t1.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(t1, "prototype", {
                        writable: !1
                    }), e && Zn(t1, e);
                }(s, e);
                var n, r, o, i, a = (o = s, i = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (t1) {
                        return !1;
                    }
                }(), function() {
                    var t1, e = Qn(o);
                    if (i) {
                        var n = Qn(this).constructor;
                        t1 = Reflect.construct(e, arguments, n);
                    } else t1 = e.apply(this, arguments);
                    return Jn(this, t1);
                });
                function s() {
                    return Hn(this, s), a.apply(this, arguments);
                }
                return n = s, r = [
                    {
                        key: "pointerMoveTolerance",
                        get: function() {
                            return t1.interactions.pointerMoveTolerance;
                        },
                        set: function(e) {
                            t1.interactions.pointerMoveTolerance = e;
                        }
                    },
                    {
                        key: "_now",
                        value: function() {
                            return t1.now();
                        }
                    }
                ], Kn(n.prototype, r), Object.defineProperty(n, "prototype", {
                    writable: !1
                }), s;
            }($e.default), t1.interactions = {
                list: [],
                new: function(e) {
                    e.scopeFire = function(e, n) {
                        return t1.fire(e, n);
                    };
                    var n = new t1.Interaction(e);
                    return t1.interactions.list.push(n), n;
                },
                listeners: e,
                docEvents: o,
                pointerMoveTolerance: 1
            }, t1.usePlugin(ue.default);
        },
        listeners: {
            "scope:add-document": function(t1) {
                return rr(t1, "add");
            },
            "scope:remove-document": function(t1) {
                return rr(t1, "remove");
            },
            "interactable:unset": function(t1, e) {
                for(var n = t1.interactable, r = e.interactions.list.length - 1; r >= 0; r--){
                    var o = e.interactions.list[r];
                    o.interactable === n && (o.stop(), e.fire("interactions:destroy", {
                        interaction: o
                    }), o.destroy(), e.interactions.list.length > 2 && e.interactions.list.splice(r, 1));
                }
            }
        },
        onDocSignal: rr,
        doOnInteractions: er,
        methodNames: tr
    }, ir = or;
    Nn.default = ir;
    var ar = {};
    function sr(t1) {
        return sr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, sr(t1);
    }
    function lr() {
        return lr = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(t1, e, n) {
            var r = ur(t1, e);
            if (r) {
                var o = Object.getOwnPropertyDescriptor(r, e);
                return o.get ? o.get.call(arguments.length < 3 ? t1 : n) : o.value;
            }
        }, lr.apply(this, arguments);
    }
    function ur(t1, e) {
        for(; !Object.prototype.hasOwnProperty.call(t1, e) && null !== (t1 = dr(t1)););
        return t1;
    }
    function cr(t1, e) {
        return cr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
            return t1.__proto__ = e, t1;
        }, cr(t1, e);
    }
    function fr(t1, e) {
        if (e && ("object" === sr(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return function(t1) {
            if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t1;
        }(t1);
    }
    function dr(t1) {
        return dr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
            return t1.__proto__ || Object.getPrototypeOf(t1);
        }, dr(t1);
    }
    function pr(t1, e) {
        if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function vr(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function hr(t1, e, n) {
        return e && vr(t1.prototype, e), n && vr(t1, n), Object.defineProperty(t1, "prototype", {
            writable: !1
        }), t1;
    }
    function gr(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(ar, "__esModule", {
        value: !0
    }), ar.Scope = void 0, ar.initScope = mr;
    var yr = function() {
        function t1() {
            var e = this;
            pr(this, t1), gr(this, "id", "__interact_scope_".concat(Math.floor(100 * Math.random()))), gr(this, "isInitialized", !1), gr(this, "listenerMaps", []), gr(this, "browser", b.default), gr(this, "defaults", (0, me.default)(Ie.defaults)), gr(this, "Eventable", mn.Eventable), gr(this, "actions", {
                map: {},
                phases: {
                    start: !0,
                    move: !0,
                    end: !0
                },
                methodDict: {},
                phaselessTypes: {}
            }), gr(this, "interactStatic", (0, On.createInteractStatic)(this)), gr(this, "InteractEvent", De.InteractEvent), gr(this, "Interactable", void 0), gr(this, "interactables", new Mn.InteractableSet(this)), gr(this, "_win", void 0), gr(this, "document", void 0), gr(this, "window", void 0), gr(this, "documents", []), gr(this, "_plugins", {
                list: [],
                map: {}
            }), gr(this, "onWindowUnload", function(t1) {
                return e.removeDocument(t1.target);
            });
            var n = this;
            this.Interactable = function(t1) {
                !function(t1, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t1.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(t1, "prototype", {
                        writable: !1
                    }), e && cr(t1, e);
                }(i, t1);
                var e, r, o = (e = i, r = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (t1) {
                        return !1;
                    }
                }(), function() {
                    var t1, n = dr(e);
                    if (r) {
                        var o = dr(this).constructor;
                        t1 = Reflect.construct(n, arguments, o);
                    } else t1 = n.apply(this, arguments);
                    return fr(this, t1);
                });
                function i() {
                    return pr(this, i), o.apply(this, arguments);
                }
                return hr(i, [
                    {
                        key: "_defaults",
                        get: function() {
                            return n.defaults;
                        }
                    },
                    {
                        key: "set",
                        value: function(t1) {
                            return lr(dr(i.prototype), "set", this).call(this, t1), n.fire("interactable:set", {
                                options: t1,
                                interactable: this
                            }), this;
                        }
                    },
                    {
                        key: "unset",
                        value: function() {
                            lr(dr(i.prototype), "unset", this).call(this);
                            var t1 = n.interactables.list.indexOf(this);
                            t1 < 0 || (n.interactables.list.splice(t1, 1), n.fire("interactable:unset", {
                                interactable: this
                            }));
                        }
                    }
                ]), i;
            }(En.Interactable);
        }
        return hr(t1, [
            {
                key: "addListeners",
                value: function(t1, e) {
                    this.listenerMaps.push({
                        id: e,
                        map: t1
                    });
                }
            },
            {
                key: "fire",
                value: function(t1, e) {
                    for(var n = 0; n < this.listenerMaps.length; n++){
                        var r = this.listenerMaps[n].map[t1];
                        if (r && !1 === r(e, this, t1)) return !1;
                    }
                }
            },
            {
                key: "init",
                value: function(t1) {
                    return this.isInitialized ? this : mr(this, t1);
                }
            },
            {
                key: "pluginIsInstalled",
                value: function(t1) {
                    return this._plugins.map[t1.id] || -1 !== this._plugins.list.indexOf(t1);
                }
            },
            {
                key: "usePlugin",
                value: function(t1, e) {
                    if (!this.isInitialized) return this;
                    if (this.pluginIsInstalled(t1)) return this;
                    if (t1.id && (this._plugins.map[t1.id] = t1), this._plugins.list.push(t1), t1.install && t1.install(this, e), t1.listeners && t1.before) {
                        for(var n = 0, r = this.listenerMaps.length, o = t1.before.reduce(function(t1, e) {
                            return t1[e] = !0, t1[br(e)] = !0, t1;
                        }, {}); n < r; n++){
                            var i = this.listenerMaps[n].id;
                            if (o[i] || o[br(i)]) break;
                        }
                        this.listenerMaps.splice(n, 0, {
                            id: t1.id,
                            map: t1.listeners
                        });
                    } else t1.listeners && this.listenerMaps.push({
                        id: t1.id,
                        map: t1.listeners
                    });
                    return this;
                }
            },
            {
                key: "addDocument",
                value: function(t1, n) {
                    if (-1 !== this.getDocIndex(t1)) return !1;
                    var r = e.getWindow(t1);
                    n = n ? (0, M.default)({}, n) : {}, this.documents.push({
                        doc: t1,
                        options: n
                    }), this.events.documents.push(t1), t1 !== this.document && this.events.add(r, "unload", this.onWindowUnload), this.fire("scope:add-document", {
                        doc: t1,
                        window: r,
                        scope: this,
                        options: n
                    });
                }
            },
            {
                key: "removeDocument",
                value: function(t1) {
                    var n = this.getDocIndex(t1), r = e.getWindow(t1), o = this.documents[n].options;
                    this.events.remove(r, "unload", this.onWindowUnload), this.documents.splice(n, 1), this.events.documents.splice(n, 1), this.fire("scope:remove-document", {
                        doc: t1,
                        window: r,
                        scope: this,
                        options: o
                    });
                }
            },
            {
                key: "getDocIndex",
                value: function(t1) {
                    for(var e = 0; e < this.documents.length; e++)if (this.documents[e].doc === t1) return e;
                    return -1;
                }
            },
            {
                key: "getDocOptions",
                value: function(t1) {
                    var e = this.getDocIndex(t1);
                    return -1 === e ? null : this.documents[e].options;
                }
            },
            {
                key: "now",
                value: function() {
                    return (this.window.Date || Date).now();
                }
            }
        ]), t1;
    }();
    function mr(t1, n) {
        return t1.isInitialized = !0, i.default.window(n) && e.init(n), h.default.init(n), b.default.init(n), jt.default.init(n), t1.window = n, t1.document = n.document, t1.usePlugin(Nn.default), t1.usePlugin(An.default), t1;
    }
    function br(t1) {
        return t1 && t1.replace(/\/.*$/, "");
    }
    ar.Scope = yr;
    var xr = {};
    Object.defineProperty(xr, "__esModule", {
        value: !0
    }), xr.default = void 0;
    var wr = new ar.Scope, _r = wr.interactStatic;
    xr.default = _r;
    var Pr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0;
    wr.init(Pr);
    var Or = {};
    Object.defineProperty(Or, "__esModule", {
        value: !0
    }), Or.default = void 0, Or.default = function() {};
    var Er = {};
    Object.defineProperty(Er, "__esModule", {
        value: !0
    }), Er.default = void 0, Er.default = function() {};
    var Sr = {};
    function Tr(t1, e) {
        return function(t1) {
            if (Array.isArray(t1)) return t1;
        }(t1) || function(t1, e) {
            var n = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
            if (null != n) {
                var r, o, i = [], a = !0, s = !1;
                try {
                    for(n = n.call(t1); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0);
                } catch (t1) {
                    s = !0, o = t1;
                } finally{
                    try {
                        a || null == n.return || n.return();
                    } finally{
                        if (s) throw o;
                    }
                }
                return i;
            }
        }(t1, e) || function(t1, e) {
            if (t1) {
                if ("string" == typeof t1) return jr(t1, e);
                var n = Object.prototype.toString.call(t1).slice(8, -1);
                return "Object" === n && t1.constructor && (n = t1.constructor.name), "Map" === n || "Set" === n ? Array.from(t1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? jr(t1, e) : void 0;
            }
        }(t1, e) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function jr(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var n = 0, r = Array(e); n < e; n++)r[n] = t1[n];
        return r;
    }
    Object.defineProperty(Sr, "__esModule", {
        value: !0
    }), Sr.default = void 0, Sr.default = function(t1) {
        var e = [
            [
                "x",
                "y"
            ],
            [
                "left",
                "top"
            ],
            [
                "right",
                "bottom"
            ],
            [
                "width",
                "height"
            ]
        ].filter(function(e) {
            var n = Tr(e, 2), r = n[0], o = n[1];
            return r in t1 || o in t1;
        }), n = function(n, r) {
            for(var o = t1.range, i = t1.limits, a = void 0 === i ? {
                left: -1 / 0,
                right: 1 / 0,
                top: -1 / 0,
                bottom: 1 / 0
            } : i, s = t1.offset, l = void 0 === s ? {
                x: 0,
                y: 0
            } : s, u = {
                range: o,
                grid: t1,
                x: null,
                y: null
            }, c = 0; c < e.length; c++){
                var f = Tr(e[c], 2), d = f[0], p = f[1], v = Math.round((n - l.x) / t1[d]), h = Math.round((r - l.y) / t1[p]);
                u[d] = Math.max(a.left, Math.min(a.right, v * t1[d] + l.x)), u[p] = Math.max(a.top, Math.min(a.bottom, h * t1[p] + l.y));
            }
            return u;
        };
        return n.grid = t1, n.coordFields = e, n;
    };
    var Mr = {};
    Object.defineProperty(Mr, "__esModule", {
        value: !0
    }), Object.defineProperty(Mr, "edgeTarget", {
        enumerable: !0,
        get: function() {
            return Or.default;
        }
    }), Object.defineProperty(Mr, "elements", {
        enumerable: !0,
        get: function() {
            return Er.default;
        }
    }), Object.defineProperty(Mr, "grid", {
        enumerable: !0,
        get: function() {
            return Sr.default;
        }
    });
    var kr = {};
    Object.defineProperty(kr, "__esModule", {
        value: !0
    }), kr.default = void 0;
    var Ir = {
        id: "snappers",
        install: function(t1) {
            var e = t1.interactStatic;
            e.snappers = (0, M.default)(e.snappers || {}, Mr), e.createSnapGrid = e.snappers.grid;
        }
    }, Dr = Ir;
    kr.default = Dr;
    var Ar = {};
    function zr(t1, e) {
        var n = Object.keys(t1);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t1);
            e && (r = r.filter(function(e) {
                return Object.getOwnPropertyDescriptor(t1, e).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function Cr(t1) {
        for(var e = 1; e < arguments.length; e++){
            var n = null != arguments[e] ? arguments[e] : {};
            e % 2 ? zr(Object(n), !0).forEach(function(e) {
                Rr(t1, e, n[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t1, Object.getOwnPropertyDescriptors(n)) : zr(Object(n)).forEach(function(e) {
                Object.defineProperty(t1, e, Object.getOwnPropertyDescriptor(n, e));
            });
        }
        return t1;
    }
    function Rr(t1, e, n) {
        return e in t1 ? Object.defineProperty(t1, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t1[e] = n, t1;
    }
    Object.defineProperty(Ar, "__esModule", {
        value: !0
    }), Ar.default = Ar.aspectRatio = void 0;
    var Fr = {
        start: function(t1) {
            var e = t1.state, n = t1.rect, r = t1.edges, o = t1.pageCoords, i = e.options, a = i.ratio, s = i.enabled, l = e.options, u = l.equalDelta, c = l.modifiers;
            "preserve" === a && (a = n.width / n.height), e.startCoords = (0, M.default)({}, o), e.startRect = (0, M.default)({}, n), e.ratio = a, e.equalDelta = u;
            var f = e.linkedEdges = {
                top: r.top || r.left && !r.bottom,
                left: r.left || r.top && !r.right,
                bottom: r.bottom || r.right && !r.top,
                right: r.right || r.bottom && !r.left
            };
            if (e.xIsPrimaryAxis = !(!r.left && !r.right), e.equalDelta) {
                var d = (f.left ? 1 : -1) * (f.top ? 1 : -1);
                e.edgeSign = {
                    x: d,
                    y: d
                };
            } else e.edgeSign = {
                x: f.left ? -1 : 1,
                y: f.top ? -1 : 1
            };
            if (!1 !== s && (0, M.default)(r, f), null != c && c.length) {
                var p = new be.default(t1.interaction);
                p.copyFrom(t1.interaction.modification), p.prepareStates(c), e.subModification = p, p.startAll(Cr({}, t1));
            }
        },
        set: function(t1) {
            var e = t1.state, n = t1.rect, r = t1.coords, o = e.linkedEdges, i = (0, M.default)({}, r), a = e.equalDelta ? Xr : Br;
            if ((0, M.default)(t1.edges, o), a(e, e.xIsPrimaryAxis, r, n), !e.subModification) return null;
            var s = (0, M.default)({}, n);
            (0, k.addEdges)(o, s, {
                x: r.x - i.x,
                y: r.y - i.y
            });
            var l = e.subModification.setAll(Cr(Cr({}, t1), {}, {
                rect: s,
                edges: o,
                pageCoords: r,
                prevCoords: r,
                prevRect: s
            })), u = l.delta;
            return l.changed && (a(e, Math.abs(u.x) > Math.abs(u.y), l.coords, l.rect), (0, M.default)(r, l.coords)), l.eventProps;
        },
        defaults: {
            ratio: "preserve",
            equalDelta: !1,
            modifiers: [],
            enabled: !1
        }
    };
    function Xr(t1, e, n) {
        var r = t1.startCoords, o = t1.edgeSign;
        e ? n.y = r.y + (n.x - r.x) * o.y : n.x = r.x + (n.y - r.y) * o.x;
    }
    function Br(t1, e, n, r) {
        var o = t1.startRect, i = t1.startCoords, a = t1.ratio, s = t1.edgeSign;
        if (e) {
            var l = r.width / a;
            n.y = i.y + (l - o.height) * s.y;
        } else {
            var u = r.height * a;
            n.x = i.x + (u - o.width) * s.x;
        }
    }
    Ar.aspectRatio = Fr;
    var Yr = (0, Te.makeModifier)(Fr, "aspectRatio");
    Ar.default = Yr;
    var Wr = {};
    Object.defineProperty(Wr, "__esModule", {
        value: !0
    }), Wr.default = void 0;
    var Lr = function() {};
    Lr._defaults = {};
    var Ur = Lr;
    Wr.default = Ur;
    var Vr = {};
    Object.defineProperty(Vr, "__esModule", {
        value: !0
    }), Object.defineProperty(Vr, "default", {
        enumerable: !0,
        get: function() {
            return Wr.default;
        }
    });
    var Nr = {};
    function qr(t1, e, n) {
        return i.default.func(t1) ? k.resolveRectLike(t1, e.interactable, e.element, [
            n.x,
            n.y,
            e
        ]) : k.resolveRectLike(t1, e.interactable, e.element);
    }
    Object.defineProperty(Nr, "__esModule", {
        value: !0
    }), Nr.default = void 0, Nr.getRestrictionRect = qr, Nr.restrict = void 0;
    var Gr = {
        start: function(t1) {
            var e = t1.rect, n = t1.startOffset, r = t1.state, o = t1.interaction, i = t1.pageCoords, a = r.options, s = a.elementRect, l = (0, M.default)({
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            }, a.offset || {});
            if (e && s) {
                var u = qr(a.restriction, o, i);
                if (u) {
                    var c = u.right - u.left - e.width, f = u.bottom - u.top - e.height;
                    c < 0 && (l.left += c, l.right += c), f < 0 && (l.top += f, l.bottom += f);
                }
                l.left += n.left - e.width * s.left, l.top += n.top - e.height * s.top, l.right += n.right - e.width * (1 - s.right), l.bottom += n.bottom - e.height * (1 - s.bottom);
            }
            r.offset = l;
        },
        set: function(t1) {
            var e = t1.coords, n = t1.interaction, r = t1.state, o = r.options, i = r.offset, a = qr(o.restriction, n, e);
            if (a) {
                var s = k.xywhToTlbr(a);
                e.x = Math.max(Math.min(s.right - i.right, e.x), s.left + i.left), e.y = Math.max(Math.min(s.bottom - i.bottom, e.y), s.top + i.top);
            }
        },
        defaults: {
            restriction: null,
            elementRect: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    };
    Nr.restrict = Gr;
    var $r = (0, Te.makeModifier)(Gr, "restrict");
    Nr.default = $r;
    var Hr = {};
    Object.defineProperty(Hr, "__esModule", {
        value: !0
    }), Hr.restrictEdges = Hr.default = void 0;
    var Kr = {
        top: 1 / 0,
        left: 1 / 0,
        bottom: -1 / 0,
        right: -1 / 0
    }, Zr = {
        top: -1 / 0,
        left: -1 / 0,
        bottom: 1 / 0,
        right: 1 / 0
    };
    function Jr(t1, e) {
        for(var n = [
            "top",
            "left",
            "bottom",
            "right"
        ], r = 0; r < n.length; r++){
            var o = n[r];
            o in t1 || (t1[o] = e[o]);
        }
        return t1;
    }
    var Qr = {
        noInner: Kr,
        noOuter: Zr,
        start: function(t1) {
            var e, n = t1.interaction, r = t1.startOffset, o = t1.state, i = o.options;
            if (i) {
                var a = (0, Nr.getRestrictionRect)(i.offset, n, n.coords.start.page);
                e = k.rectToXY(a);
            }
            e = e || {
                x: 0,
                y: 0
            }, o.offset = {
                top: e.y + r.top,
                left: e.x + r.left,
                bottom: e.y - r.bottom,
                right: e.x - r.right
            };
        },
        set: function(t1) {
            var e = t1.coords, n = t1.edges, r = t1.interaction, o = t1.state, i = o.offset, a = o.options;
            if (n) {
                var s = (0, M.default)({}, e), l = (0, Nr.getRestrictionRect)(a.inner, r, s) || {}, u = (0, Nr.getRestrictionRect)(a.outer, r, s) || {};
                Jr(l, Kr), Jr(u, Zr), n.top ? e.y = Math.min(Math.max(u.top + i.top, s.y), l.top + i.top) : n.bottom && (e.y = Math.max(Math.min(u.bottom + i.bottom, s.y), l.bottom + i.bottom)), n.left ? e.x = Math.min(Math.max(u.left + i.left, s.x), l.left + i.left) : n.right && (e.x = Math.max(Math.min(u.right + i.right, s.x), l.right + i.right));
            }
        },
        defaults: {
            inner: null,
            outer: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    };
    Hr.restrictEdges = Qr;
    var to = (0, Te.makeModifier)(Qr, "restrictEdges");
    Hr.default = to;
    var eo = {};
    Object.defineProperty(eo, "__esModule", {
        value: !0
    }), eo.restrictRect = eo.default = void 0;
    var no = (0, M.default)({
        get elementRect () {
            return {
                top: 0,
                left: 0,
                bottom: 1,
                right: 1
            };
        },
        set elementRect (t){}
    }, Nr.restrict.defaults), ro = {
        start: Nr.restrict.start,
        set: Nr.restrict.set,
        defaults: no
    };
    eo.restrictRect = ro;
    var oo = (0, Te.makeModifier)(ro, "restrictRect");
    eo.default = oo;
    var io = {};
    Object.defineProperty(io, "__esModule", {
        value: !0
    }), io.restrictSize = io.default = void 0;
    var ao = {
        width: -1 / 0,
        height: -1 / 0
    }, so = {
        width: 1 / 0,
        height: 1 / 0
    }, lo = {
        start: function(t1) {
            return Hr.restrictEdges.start(t1);
        },
        set: function(t1) {
            var e = t1.interaction, n = t1.state, r = t1.rect, o = t1.edges, i = n.options;
            if (o) {
                var a = k.tlbrToXywh((0, Nr.getRestrictionRect)(i.min, e, t1.coords)) || ao, s = k.tlbrToXywh((0, Nr.getRestrictionRect)(i.max, e, t1.coords)) || so;
                n.options = {
                    endOnly: i.endOnly,
                    inner: (0, M.default)({}, Hr.restrictEdges.noInner),
                    outer: (0, M.default)({}, Hr.restrictEdges.noOuter)
                }, o.top ? (n.options.inner.top = r.bottom - a.height, n.options.outer.top = r.bottom - s.height) : o.bottom && (n.options.inner.bottom = r.top + a.height, n.options.outer.bottom = r.top + s.height), o.left ? (n.options.inner.left = r.right - a.width, n.options.outer.left = r.right - s.width) : o.right && (n.options.inner.right = r.left + a.width, n.options.outer.right = r.left + s.width), Hr.restrictEdges.set(t1), n.options = i;
            }
        },
        defaults: {
            min: null,
            max: null,
            endOnly: !1,
            enabled: !1
        }
    };
    io.restrictSize = lo;
    var uo = (0, Te.makeModifier)(lo, "restrictSize");
    io.default = uo;
    var co = {};
    Object.defineProperty(co, "__esModule", {
        value: !0
    }), Object.defineProperty(co, "default", {
        enumerable: !0,
        get: function() {
            return Wr.default;
        }
    });
    var fo = {};
    Object.defineProperty(fo, "__esModule", {
        value: !0
    }), fo.snap = fo.default = void 0;
    var po = {
        start: function(t1) {
            var e, n = t1.interaction, r = t1.interactable, o = t1.element, i = t1.rect, a = t1.state, s = t1.startOffset, l = a.options, u = l.offsetWithOrigin ? function(t1) {
                var e = t1.interaction.element;
                return (0, k.rectToXY)((0, k.resolveRectLike)(t1.state.options.origin, null, null, [
                    e
                ])) || (0, A.default)(t1.interactable, e, t1.interaction.prepared.name);
            }(t1) : {
                x: 0,
                y: 0
            };
            if ("startCoords" === l.offset) e = {
                x: n.coords.start.page.x,
                y: n.coords.start.page.y
            };
            else {
                var c = (0, k.resolveRectLike)(l.offset, r, o, [
                    n
                ]);
                (e = (0, k.rectToXY)(c) || {
                    x: 0,
                    y: 0
                }).x += u.x, e.y += u.y;
            }
            var f = l.relativePoints;
            a.offsets = i && f && f.length ? f.map(function(t1, n) {
                return {
                    index: n,
                    relativePoint: t1,
                    x: s.left - i.width * t1.x + e.x,
                    y: s.top - i.height * t1.y + e.y
                };
            }) : [
                {
                    index: 0,
                    relativePoint: null,
                    x: e.x,
                    y: e.y
                }
            ];
        },
        set: function(t1) {
            var e = t1.interaction, n = t1.coords, r = t1.state, o = r.options, a = r.offsets, s = (0, A.default)(e.interactable, e.element, e.prepared.name), l = (0, M.default)({}, n), u = [];
            o.offsetWithOrigin || (l.x -= s.x, l.y -= s.y);
            for(var c = 0; c < a.length; c++)for(var f = a[c], d = l.x - f.x, p = l.y - f.y, v = 0, h = o.targets.length; v < h; v++){
                var g, y = o.targets[v];
                (g = i.default.func(y) ? y(d, p, e._proxy, f, v) : y) && u.push({
                    x: (i.default.number(g.x) ? g.x : d) + f.x,
                    y: (i.default.number(g.y) ? g.y : p) + f.y,
                    range: i.default.number(g.range) ? g.range : o.range,
                    source: y,
                    index: v,
                    offset: f
                });
            }
            for(var m = {
                target: null,
                inRange: !1,
                distance: 0,
                range: 0,
                delta: {
                    x: 0,
                    y: 0
                }
            }, b = 0; b < u.length; b++){
                var x = u[b], w = x.range, _ = x.x - l.x, P = x.y - l.y, O = (0, R.default)(_, P), E = O <= w;
                w === 1 / 0 && m.inRange && m.range !== 1 / 0 && (E = !1), m.target && !(E ? m.inRange && w !== 1 / 0 ? O / w < m.distance / m.range : w === 1 / 0 && m.range !== 1 / 0 || O < m.distance : !m.inRange && O < m.distance) || (m.target = x, m.distance = O, m.range = w, m.inRange = E, m.delta.x = _, m.delta.y = P);
            }
            return m.inRange && (n.x = m.target.x, n.y = m.target.y), r.closest = m, m;
        },
        defaults: {
            range: 1 / 0,
            targets: null,
            offset: null,
            offsetWithOrigin: !0,
            origin: null,
            relativePoints: null,
            endOnly: !1,
            enabled: !1
        }
    };
    fo.snap = po;
    var vo = (0, Te.makeModifier)(po, "snap");
    fo.default = vo;
    var ho = {};
    function go(t1, e) {
        (null == e || e > t1.length) && (e = t1.length);
        for(var n = 0, r = Array(e); n < e; n++)r[n] = t1[n];
        return r;
    }
    Object.defineProperty(ho, "__esModule", {
        value: !0
    }), ho.snapSize = ho.default = void 0;
    var yo = {
        start: function(t1) {
            var e = t1.state, n = t1.edges, r = e.options;
            if (!n) return null;
            t1.state = {
                options: {
                    targets: null,
                    relativePoints: [
                        {
                            x: n.left ? 0 : 1,
                            y: n.top ? 0 : 1
                        }
                    ],
                    offset: r.offset || "self",
                    origin: {
                        x: 0,
                        y: 0
                    },
                    range: r.range
                }
            }, e.targetFields = e.targetFields || [
                [
                    "width",
                    "height"
                ],
                [
                    "x",
                    "y"
                ]
            ], fo.snap.start(t1), e.offsets = t1.state.offsets, t1.state = e;
        },
        set: function(t1) {
            var e, n, r = t1.interaction, o = t1.state, a = t1.coords, s = o.options, l = o.offsets, u = {
                x: a.x - l[0].x,
                y: a.y - l[0].y
            };
            o.options = (0, M.default)({}, s), o.options.targets = [];
            for(var c = 0; c < (s.targets || []).length; c++){
                var f = (s.targets || [])[c], d = void 0;
                if (d = i.default.func(f) ? f(u.x, u.y, r) : f) {
                    for(var p = 0; p < o.targetFields.length; p++){
                        var v = (e = o.targetFields[p], n = 2, function(t1) {
                            if (Array.isArray(t1)) return t1;
                        }(e) || function(t1, e) {
                            var n = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
                            if (null != n) {
                                var r, o, i = [], a = !0, s = !1;
                                try {
                                    for(n = n.call(t1); !(a = (r = n.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0);
                                } catch (t1) {
                                    s = !0, o = t1;
                                } finally{
                                    try {
                                        a || null == n.return || n.return();
                                    } finally{
                                        if (s) throw o;
                                    }
                                }
                                return i;
                            }
                        }(e, n) || function(t1, e) {
                            if (t1) {
                                if ("string" == typeof t1) return go(t1, e);
                                var n = Object.prototype.toString.call(t1).slice(8, -1);
                                return "Object" === n && t1.constructor && (n = t1.constructor.name), "Map" === n || "Set" === n ? Array.from(t1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? go(t1, e) : void 0;
                            }
                        }(e, n) || function() {
                            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }()), h = v[0], g = v[1];
                        if (h in d || g in d) {
                            d.x = d[h], d.y = d[g];
                            break;
                        }
                    }
                    o.options.targets.push(d);
                }
            }
            var y = fo.snap.set(t1);
            return o.options = s, y;
        },
        defaults: {
            range: 1 / 0,
            targets: null,
            offset: null,
            endOnly: !1,
            enabled: !1
        }
    };
    ho.snapSize = yo;
    var mo = (0, Te.makeModifier)(yo, "snapSize");
    ho.default = mo;
    var bo = {};
    Object.defineProperty(bo, "__esModule", {
        value: !0
    }), bo.snapEdges = bo.default = void 0;
    var xo = {
        start: function(t1) {
            var e = t1.edges;
            return e ? (t1.state.targetFields = t1.state.targetFields || [
                [
                    e.left ? "left" : "right",
                    e.top ? "top" : "bottom"
                ]
            ], ho.snapSize.start(t1)) : null;
        },
        set: ho.snapSize.set,
        defaults: (0, M.default)((0, me.default)(ho.snapSize.defaults), {
            targets: null,
            range: null,
            offset: {
                x: 0,
                y: 0
            }
        })
    };
    bo.snapEdges = xo;
    var wo = (0, Te.makeModifier)(xo, "snapEdges");
    bo.default = wo;
    var _o = {};
    Object.defineProperty(_o, "__esModule", {
        value: !0
    }), Object.defineProperty(_o, "default", {
        enumerable: !0,
        get: function() {
            return Wr.default;
        }
    });
    var Po = {};
    Object.defineProperty(Po, "__esModule", {
        value: !0
    }), Object.defineProperty(Po, "default", {
        enumerable: !0,
        get: function() {
            return Wr.default;
        }
    });
    var Oo = {};
    Object.defineProperty(Oo, "__esModule", {
        value: !0
    }), Oo.default = void 0;
    var Eo = {
        aspectRatio: Ar.default,
        restrictEdges: Hr.default,
        restrict: Nr.default,
        restrictRect: eo.default,
        restrictSize: io.default,
        snapEdges: bo.default,
        snap: fo.default,
        snapSize: ho.default,
        spring: _o.default,
        avoid: Vr.default,
        transform: Po.default,
        rubberband: co.default
    };
    Oo.default = Eo;
    var So = {};
    Object.defineProperty(So, "__esModule", {
        value: !0
    }), So.default = void 0;
    var To = {
        id: "modifiers",
        install: function(t1) {
            var e = t1.interactStatic;
            for(var n in t1.usePlugin(Te.default), t1.usePlugin(kr.default), e.modifiers = Oo.default, Oo.default){
                var r = Oo.default[n], o = r._defaults, i = r._methods;
                o._methods = i, t1.defaults.perAction[n] = o;
            }
        }
    }, jo = To;
    So.default = jo;
    var Mo = {};
    function ko(t1) {
        return ko = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, ko(t1);
    }
    function Io(t1, e) {
        for(var n = 0; n < e.length; n++){
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t1, r.key, r);
        }
    }
    function Do(t1, e) {
        return Do = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t1, e) {
            return t1.__proto__ = e, t1;
        }, Do(t1, e);
    }
    function Ao(t1, e) {
        if (e && ("object" === ko(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return zo(t1);
    }
    function zo(t1) {
        if (void 0 === t1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t1;
    }
    function Co(t1) {
        return Co = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t1) {
            return t1.__proto__ || Object.getPrototypeOf(t1);
        }, Co(t1);
    }
    Object.defineProperty(Mo, "__esModule", {
        value: !0
    }), Mo.default = Mo.PointerEvent = void 0;
    var Ro = function(t1) {
        !function(t1, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t1.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t1,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(t1, "prototype", {
                writable: !1
            }), e && Do(t1, e);
        }(a, t1);
        var e, n, r, o, i = (r = a, o = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (t1) {
                return !1;
            }
        }(), function() {
            var t1, e = Co(r);
            if (o) {
                var n = Co(this).constructor;
                t1 = Reflect.construct(e, arguments, n);
            } else t1 = e.apply(this, arguments);
            return Ao(this, t1);
        });
        function a(t1, e, n, r, o, s) {
            var l;
            if (function(t1, e) {
                if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, a), l = i.call(this, o), B.pointerExtend(zo(l), n), n !== e && B.pointerExtend(zo(l), e), l.timeStamp = s, l.originalEvent = n, l.type = t1, l.pointerId = B.getPointerId(e), l.pointerType = B.getPointerType(e), l.target = r, l.currentTarget = null, "tap" === t1) {
                var u = o.getPointerIndex(e);
                l.dt = l.timeStamp - o.pointers[u].downTime;
                var c = l.timeStamp - o.tapTime;
                l.double = !!o.prevTap && "doubletap" !== o.prevTap.type && o.prevTap.target === l.target && c < 500;
            } else "doubletap" === t1 && (l.dt = e.timeStamp - o.tapTime, l.double = !0);
            return l;
        }
        return e = a, n = [
            {
                key: "_subtractOrigin",
                value: function(t1) {
                    var e = t1.x, n = t1.y;
                    return this.pageX -= e, this.pageY -= n, this.clientX -= e, this.clientY -= n, this;
                }
            },
            {
                key: "_addOrigin",
                value: function(t1) {
                    var e = t1.x, n = t1.y;
                    return this.pageX += e, this.pageY += n, this.clientX += e, this.clientY += n, this;
                }
            },
            {
                key: "preventDefault",
                value: function() {
                    this.originalEvent.preventDefault();
                }
            }
        ], Io(e.prototype, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), a;
    }(q.BaseEvent);
    Mo.PointerEvent = Mo.default = Ro;
    var Fo = {};
    Object.defineProperty(Fo, "__esModule", {
        value: !0
    }), Fo.default = void 0;
    var Xo = {
        id: "pointer-events/base",
        before: [
            "inertia",
            "modifiers",
            "auto-start",
            "actions"
        ],
        install: function(t1) {
            t1.pointerEvents = Xo, t1.defaults.actions.pointerEvents = Xo.defaults, (0, M.default)(t1.actions.phaselessTypes, Xo.types);
        },
        listeners: {
            "interactions:new": function(t1) {
                var e = t1.interaction;
                e.prevTap = null, e.tapTime = 0;
            },
            "interactions:update-pointer": function(t1) {
                var e = t1.down, n = t1.pointerInfo;
                !e && n.hold || (n.hold = {
                    duration: 1 / 0,
                    timeout: null
                });
            },
            "interactions:move": function(t1, e) {
                var n = t1.interaction, r = t1.pointer, o = t1.event, i = t1.eventTarget;
                t1.duplicate || n.pointerIsDown && !n.pointerWasMoved || (n.pointerIsDown && Wo(t1), Bo({
                    interaction: n,
                    pointer: r,
                    event: o,
                    eventTarget: i,
                    type: "move"
                }, e));
            },
            "interactions:down": function(t1, e) {
                !function(t1, e) {
                    for(var n = t1.interaction, r = t1.pointer, o = t1.event, i = t1.eventTarget, a = t1.pointerIndex, s = n.pointers[a].hold, l = _.getPath(i), u = {
                        interaction: n,
                        pointer: r,
                        event: o,
                        eventTarget: i,
                        type: "hold",
                        targets: [],
                        path: l,
                        node: null
                    }, c = 0; c < l.length; c++){
                        var f = l[c];
                        u.node = f, e.fire("pointerEvents:collect-targets", u);
                    }
                    if (u.targets.length) {
                        for(var d = 1 / 0, p = 0; p < u.targets.length; p++){
                            var v = u.targets[p].eventable.options.holdDuration;
                            v < d && (d = v);
                        }
                        s.duration = d, s.timeout = setTimeout(function() {
                            Bo({
                                interaction: n,
                                eventTarget: i,
                                pointer: r,
                                event: o,
                                type: "hold"
                            }, e);
                        }, d);
                    }
                }(t1, e), Bo(t1, e);
            },
            "interactions:up": function(t1, e) {
                Wo(t1), Bo(t1, e), function(t1, e) {
                    var n = t1.interaction, r = t1.pointer, o = t1.event, i = t1.eventTarget;
                    n.pointerWasMoved || Bo({
                        interaction: n,
                        eventTarget: i,
                        pointer: r,
                        event: o,
                        type: "tap"
                    }, e);
                }(t1, e);
            },
            "interactions:cancel": function(t1, e) {
                Wo(t1), Bo(t1, e);
            }
        },
        PointerEvent: Mo.PointerEvent,
        fire: Bo,
        collectEventTargets: Yo,
        defaults: {
            holdDuration: 600,
            ignoreFrom: null,
            allowFrom: null,
            origin: {
                x: 0,
                y: 0
            }
        },
        types: {
            down: !0,
            move: !0,
            up: !0,
            cancel: !0,
            tap: !0,
            doubletap: !0,
            hold: !0
        }
    };
    function Bo(t1, e) {
        var n = t1.interaction, r = t1.pointer, o = t1.event, i = t1.eventTarget, a = t1.type, s = t1.targets, l = void 0 === s ? Yo(t1, e) : s, u = new Mo.PointerEvent(a, r, o, i, n, e.now());
        e.fire("pointerEvents:new", {
            pointerEvent: u
        });
        for(var c = {
            interaction: n,
            pointer: r,
            event: o,
            eventTarget: i,
            targets: l,
            type: a,
            pointerEvent: u
        }, f = 0; f < l.length; f++){
            var d = l[f];
            for(var p in d.props || {})u[p] = d.props[p];
            var v = (0, A.default)(d.eventable, d.node);
            if (u._subtractOrigin(v), u.eventable = d.eventable, u.currentTarget = d.node, d.eventable.fire(u), u._addOrigin(v), u.immediatePropagationStopped || u.propagationStopped && f + 1 < l.length && l[f + 1].node !== u.currentTarget) break;
        }
        if (e.fire("pointerEvents:fired", c), "tap" === a) {
            var h = u.double ? Bo({
                interaction: n,
                pointer: r,
                event: o,
                eventTarget: i,
                type: "doubletap"
            }, e) : u;
            n.prevTap = h, n.tapTime = h.timeStamp;
        }
        return u;
    }
    function Yo(t1, e) {
        var n = t1.interaction, r = t1.pointer, o = t1.event, i = t1.eventTarget, a = t1.type, s = n.getPointerIndex(r), l = n.pointers[s];
        if ("tap" === a && (n.pointerWasMoved || !l || l.downTarget !== i)) return [];
        for(var u = _.getPath(i), c = {
            interaction: n,
            pointer: r,
            event: o,
            eventTarget: i,
            type: a,
            path: u,
            targets: [],
            node: null
        }, f = 0; f < u.length; f++){
            var d = u[f];
            c.node = d, e.fire("pointerEvents:collect-targets", c);
        }
        return "hold" === a && (c.targets = c.targets.filter(function(t1) {
            var e;
            return t1.eventable.options.holdDuration === (null == (e = n.pointers[s]) ? void 0 : e.hold.duration);
        })), c.targets;
    }
    function Wo(t1) {
        var e = t1.interaction, n = t1.pointerIndex, r = e.pointers[n].hold;
        r && r.timeout && (clearTimeout(r.timeout), r.timeout = null);
    }
    var Lo = Xo;
    Fo.default = Lo;
    var Uo = {};
    function Vo(t1) {
        var e = t1.interaction;
        e.holdIntervalHandle && (clearInterval(e.holdIntervalHandle), e.holdIntervalHandle = null);
    }
    Object.defineProperty(Uo, "__esModule", {
        value: !0
    }), Uo.default = void 0;
    var No = {
        id: "pointer-events/holdRepeat",
        install: function(t1) {
            t1.usePlugin(Fo.default);
            var e = t1.pointerEvents;
            e.defaults.holdRepeatInterval = 0, e.types.holdrepeat = t1.actions.phaselessTypes.holdrepeat = !0;
        },
        listeners: [
            "move",
            "up",
            "cancel",
            "endall"
        ].reduce(function(t1, e) {
            return t1["pointerEvents:".concat(e)] = Vo, t1;
        }, {
            "pointerEvents:new": function(t1) {
                var e = t1.pointerEvent;
                "hold" === e.type && (e.count = (e.count || 0) + 1);
            },
            "pointerEvents:fired": function(t1, e) {
                var n = t1.interaction, r = t1.pointerEvent, o = t1.eventTarget, i = t1.targets;
                if ("hold" === r.type && i.length) {
                    var a = i[0].eventable.options.holdRepeatInterval;
                    a <= 0 || (n.holdIntervalHandle = setTimeout(function() {
                        e.pointerEvents.fire({
                            interaction: n,
                            eventTarget: o,
                            type: "hold",
                            pointer: r,
                            event: r
                        }, e);
                    }, a));
                }
            }
        })
    }, qo = No;
    Uo.default = qo;
    var Go = {};
    function $o(t1) {
        return (0, M.default)(this.events.options, t1), this;
    }
    Object.defineProperty(Go, "__esModule", {
        value: !0
    }), Go.default = void 0;
    var Ho = {
        id: "pointer-events/interactableTargets",
        install: function(t1) {
            var e = t1.Interactable;
            e.prototype.pointerEvents = $o;
            var n = e.prototype._backCompatOption;
            e.prototype._backCompatOption = function(t1, e) {
                var r = n.call(this, t1, e);
                return r === this && (this.events.options[t1] = e), r;
            };
        },
        listeners: {
            "pointerEvents:collect-targets": function(t1, e) {
                var n = t1.targets, r = t1.node, o = t1.type, i = t1.eventTarget;
                e.interactables.forEachMatch(r, function(t1) {
                    var e = t1.events, a = e.options;
                    e.types[o] && e.types[o].length && t1.testIgnoreAllow(a, r, i) && n.push({
                        node: r,
                        eventable: e,
                        props: {
                            interactable: t1
                        }
                    });
                });
            },
            "interactable:new": function(t1) {
                var e = t1.interactable;
                e.events.getRect = function(t1) {
                    return e.getRect(t1);
                };
            },
            "interactable:set": function(t1, e) {
                var n = t1.interactable, r = t1.options;
                (0, M.default)(n.events.options, e.pointerEvents.defaults), (0, M.default)(n.events.options, r.pointerEvents || {});
            }
        }
    }, Ko = Ho;
    Go.default = Ko;
    var Zo = {};
    Object.defineProperty(Zo, "__esModule", {
        value: !0
    }), Zo.default = void 0;
    var Jo = {
        id: "pointer-events",
        install: function(t1) {
            t1.usePlugin(Fo), t1.usePlugin(Uo.default), t1.usePlugin(Go.default);
        }
    }, Qo = Jo;
    Zo.default = Qo;
    var ti = {};
    function ei(t1) {
        var e = t1.Interactable;
        t1.actions.phases.reflow = !0, e.prototype.reflow = function(e) {
            return function(t1, e, n) {
                for(var r = i.default.string(t1.target) ? K.from(t1._context.querySelectorAll(t1.target)) : [
                    t1.target
                ], o = n.window.Promise, a = o ? [] : null, s = function() {
                    var i = r[l], s = t1.getRect(i);
                    if (!s) return "break";
                    var u = K.find(n.interactions.list, function(n) {
                        return n.interacting() && n.interactable === t1 && n.element === i && n.prepared.name === e.name;
                    }), c = void 0;
                    if (u) u.move(), a && (c = u._reflowPromise || new o(function(t1) {
                        u._reflowResolve = t1;
                    }));
                    else {
                        var f = (0, k.tlbrToXywh)(s), d = {
                            page: {
                                x: f.x,
                                y: f.y
                            },
                            client: {
                                x: f.x,
                                y: f.y
                            },
                            timeStamp: n.now()
                        }, p = B.coordsToEvent(d);
                        c = function(t1, e, n, r, o) {
                            var i = t1.interactions.new({
                                pointerType: "reflow"
                            }), a = {
                                interaction: i,
                                event: o,
                                pointer: o,
                                eventTarget: n,
                                phase: "reflow"
                            };
                            i.interactable = e, i.element = n, i.prevEvent = o, i.updatePointer(o, o, n, !0), B.setZeroCoords(i.coords.delta), (0, Bt.copyAction)(i.prepared, r), i._doPhase(a);
                            var s = t1.window.Promise, l = s ? new s(function(t1) {
                                i._reflowResolve = t1;
                            }) : void 0;
                            return i._reflowPromise = l, i.start(r, e, n), i._interacting ? (i.move(a), i.end(o)) : (i.stop(), i._reflowResolve()), i.removePointer(o, o), l;
                        }(n, t1, i, e, p);
                    }
                    a && a.push(c);
                }, l = 0; l < r.length && "break" !== s(); l++);
                return a && o.all(a).then(function() {
                    return t1;
                });
            }(this, e, t1);
        };
    }
    Object.defineProperty(ti, "__esModule", {
        value: !0
    }), ti.default = void 0, ti.install = ei;
    var ni = {
        id: "reflow",
        install: ei,
        listeners: {
            "interactions:stop": function(t1, e) {
                var n = t1.interaction;
                "reflow" === n.pointerType && (n._reflowResolve && n._reflowResolve(), K.remove(e.interactions.list, n));
            }
        }
    }, ri = ni;
    ti.default = ri;
    var oi = {};
    Object.defineProperty(oi, "__esModule", {
        value: !0
    }), oi.default = void 0, xr.default.use(ue.default), xr.default.use(tn.default), xr.default.use(Zo.default), xr.default.use(un.default), xr.default.use(So.default), xr.default.use(se.default), xr.default.use(St.default), xr.default.use(At.default), xr.default.use(ti.default);
    var ii = xr.default;
    oi.default = ii, xr.default.default = xr.default, St.default, At.default, se.default, ue.default, ge.default, un.default, xr.default, So.default, tn.default, Zo.default, ti.default;
    var ai = {
        exports: {}
    };
    function si(t1) {
        return si = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
            return typeof t1;
        } : function(t1) {
            return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
        }, si(t1);
    }
    Object.defineProperty(ai.exports, "__esModule", {
        value: !0
    }), ai.exports.default = void 0;
    var li = oi.default;
    if (ai.exports.default = li, "object" === si(ai) && ai) try {
        ai.exports = oi.default;
    } catch (t1) {}
    return oi.default.default = oi.default, ai.exports;
});


let $0bc47041d20a2d19$export$d7d5d435647ed5a0 = (0, (/*@__PURE__*/$parcel$interopDefault($46efa3ec03c6de42$exports)))(".drag").draggable({
    listeners: {
        start (event) {
            event.target.classList.add("active");
            event.target.dataset.dragged = "false";
        },
        end (event) {
            event.target.classList.remove("active");
        },
        // call this function on every dragmove event
        move (event) {
            var target = event.target;
            target.dataset.dragged = "true";
            // keep the dragged position in the data-x/data-y attributes
            var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
            var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
            target.style.transform = `translate(${x}px,${y}px)`;
            // update the posiion attributes
            target.setAttribute("data-x", x);
            target.setAttribute("data-y", y);
        }
    }
});
let $0bc47041d20a2d19$export$663103110d94aac9 = (0, (/*@__PURE__*/$parcel$interopDefault($46efa3ec03c6de42$exports)))(".dropzone").dropzone({
    accept: ".drag",
    overlap: 0.75,
    // listen for drop related events:
    ondropactivate: function(event) {
        // feedback for available drop zones
        event.target.classList.add("dropzone--ready");
    },
    ondragenter: function(event) {
        // feedback the possibility of a drop
        event.target.classList.add("dropzone--over");
        event.relatedTarget.classList.add("can-drop");
    },
    ondragleave: function(event) {
        // remove the drop feedback style
        event.target.classList.remove("dropzone--over");
        event.relatedTarget.classList.remove("can-drop");
        event.relatedTarget.classList.remove("dropped");
        event.relatedTarget.dispatchEvent(new Event("unheld"));
    },
    ondrop: function(event) {
        event.relatedTarget.dispatchEvent(new Event("held"));
        event.relatedTarget.classList.add("dropped");
    // event.relatedTarget.setAttribute('data-held', true)
    },
    ondropdeactivate: function(event) {
        // remove active dropzone feedback
        event.target.classList.remove("dropzone--ready");
        event.target.classList.remove("dropzone--over");
    }
});


(0, $ceb1972acc1ecda9$export$2e2bcd8739ae039).data("dice", (0, $8dc991c4c18630b2$export$2e2bcd8739ae039));
(0, $ceb1972acc1ecda9$export$2e2bcd8739ae039).start();


//# sourceMappingURL=index.d56b302a.js.map
